/* eslint-disable no-control-regex */
/* global BrowserPrint */
import React, { Component } from "react";

import "./pack-and-ship-transaction-model.scss";

// Component
import WmsModel from "../../components/WmsModel/WmsModel.jsx";
import WmsButton from "../../components/WmsButton/WmsButton.jsx";
import WmsCollapse from "../../components/WmsCollapse/WmsCollapse.jsx";
import WmsDropdown from "../../components/WmsDropdown/WmsDropdown.jsx";
import WmsCheckBox from "../../components/WmsCheckBox/WmsCheckBox.jsx";
import WmsInput from "../../components/WmsInput/WmsInput.jsx";
import WmsComboBox from "../../components/WmsComboBox/WmsComboBox.jsx";
import { EditAddressDetail } from "./edit-address-detail.component.jsx";
import VirtualGroupGrid from "../../components/VirtualGroupGrid/VirtualGroupGrid.jsx";
import { AvailableRates } from "./available-rates.component.jsx";
import { ArrayWms } from "../../../../assets/ts/ArrayWms.ts";
import { KendoGridWmsVirtual } from "../../../../assets/ts/KendoGridWmsVirtual.ts";
import * as GlobalService from "../../global_services";
import * as Scale from "../../scale";
import * as metaDataService from "../meta-data.service";
import * as PackAndShipGridConfig from "./pack-and-ship-grid-config.jsx";
import * as smallParcelService from ".././smallParcel.service.jsx";
import * as shipInFlightGuard from "../ship-in-flight-guard.service.jsx";
import * as smallParcelSettingsServices from "../../smallParcelSettings/small-parcel-settings.services.jsx";
import * as findOrdersService from "../../orders/findOrders/findOrders.services.jsx";
import * as papiDocumentUtil from "../papi-document.util.js";
import WmsConfirmModel from "../../components/WmsConfirmModel/WmsConfirmModel.jsx";
import * as printerService from "../../services/printer.service";
import { PrinterSettingsModal } from "../../components/PrinterSettings/printer-settings.component.jsx";

export class PackAndShipTransactionModel extends Component {
    constructor(props) {
        super(props);
        // Default we are assuming order don't have any pack item
        this.isAnyItemPacked = false;
        this.$rootScope = window;
        this.isPrintIconShaw = metaDataService.getPackAndShipAutoPrintInMetaData();
        this.translate = window.translate;
        this.optionsPapiPackSlipScope = [
            { text: this.translate("Label_PapiPackSlipLayout_PerOrder"), value: "shipment" },
            { text: this.translate("Label_PapiPackSlipLayout_PerPackage"), value: "package" },
        ];
        window.packageArr = [];
        this.weightChanged = false;
        this.currentPackage = { PackageId: 0, PackageDefId: 0, Name: "" };
        this.previousSelectedPackage = {
            PackageId: 0,
            PackageDefId: 0,
            Name: "",
        };
        this.previousSelectedPackageArr = [];
        this.order = {};
        this.content = {};
        this.nonSkuContent = {};
        this.lastPackedSelectedIndex = 0;
        this.selectedItems = 0;
        this.showT = false;
        this.showQ = false;
        this.showS = false;
        this._isMounted = false;
        this.isSmallParcelGridRefresh = false;
        this.isIntegral = true; // you only add number value if it's true
        this.isDisabledPack = false;
        this.isSetActivePackage = true;
        this.packageIdForEdit = "";
        this.packageIdForDelete = "";
        this.careerSectionElement = null;
        this.contactSectionElement = null;
        this.qtyBaseOnUPC = 1;
        this.isAllowDuplicatedUPC = false;
        this.isCallAutoRateAPI = false;
        this.isCallAutoRateAPIMultiOrder = false;
        this.pkgCustomOption = {
            PackageDefId: 0,
            PackageId: 0,
            Name: this.translate("Label_Custom_Dimensions"),
            Description: this.translate("Label_Custom_Dimensions"),
            Barcode: "",
            IsDefault: false,
            LengthImperial: 0,
            WidthImperial: 0,
            HeightImperial: 0,
            WeightImperial: 0,
            LengthMetric: 0,
            WidthMetric: 0,
            HeightMetric: 0,
            WeightMetric: 0,
            AssignedCustomers: [],
        };

        this.isEnteredValue = false;
        this.isDuplicatePrintCalledFrom = "";
        this.scannedValueResArr = [];
        this.processAsOption = [];
        this.labelFormateOption = [
            { description: "PDF", value: "Pdf" },
            { description: "ZPL", value: "Zpl" },
        ];
        this.labelFormateOptionForHvp = [
            { description: "PDF", value: "Pdf" },
            { description: "ZPL", value: "Zpl" },
            { description: "PNG (Combo Label)", value: "Png" },
        ];
        this.returnLabelOptions = [
            { description: "Not Included", value: false },
            { description: "Included", value: true },
        ];
        this.isUnpackedAndUnScannedItem = false;

        let rights = GlobalService.GetRights();
        let isSParcelEnabled = false;
        let isSPackEnabled = false;
        if (
            rights.hasOwnProperty("Shipping.SmallParcelEnabled") &&
            rights.hasOwnProperty("orders.manage.smartparcel")
        ) {
            isSParcelEnabled = true;
        }

        if (
            rights.hasOwnProperty("Shipping.WarehousePackEnabled") &&
            rights.hasOwnProperty("orders.edit.pack") &&
            this.props.sharedSelectedOrderIds.length == 1
        ) {
            isSPackEnabled = true;
        }

        this.isEnableProvider =
            rights.hasOwnProperty("Shipping.SmallParcelEnabled") &&
            rights["Integrations.SmallParcelPartner"] == "ParcelApi";
        this.papiDocsEnabled = papiDocumentUtil.isPapiDocEnabled(rights, "packingSlip");
        this.mixedPackingSlipSavedValue = null;
        this.mixedPackingSlipSavedScope = "";
        this.mixedPackingSlipSavedFormat = "";
        this.packingSlipTypeChosen = false;
        this.carrierAccountSchema = GlobalService.GetDynamicCarrierAccountSchema();

        this.state = {
            selector: "packAndShipTransaction",
            gifShipBtn: false,
            gifPackNShipButton: false,
            isOnHoldOrder: false,
            isOpenDeleteConfirmModel: false,
            selectedPackageName: "",
            retailerOptions: [],
            cartonLabelOptions: [],
            cartonLabelOptionsLoading: false,
            transactionLabelOptions: [],
            retailerTemplate: 0,
            cartonLabel: 0,
            ucc128Format: "zpl",
            ucc128TemplatesRaw: [],
            transactionLabel: metaDataService.getPackAndShipTransactionLabelInMetaData(),
            packAdnShipObj: {
                processAs: "Standard",
                labelFormat: "Pdf",
                returnLabel: false,
                comboLabelTemplate: "",
                comboLabelTemplateValue: "",
                SmallParcelPackSlip: "",
                SmallParcelAddressTemplate: "",
                SmallParcelPapiPackSlipTemplateId: "",
                SmallParcelPapiPackSlipTemplateVersion: null,
                SmallParcelPapiPackSlipScope: "",
                SmallParcelPapiPackSlipFormat: "",
                SmallParcelDocumentTypeValue: null,
            },
            selectedPackage: "",
            addNumOfPackages: 1,
            packagesOptions: [],
            isOpenCustomPackageModel: false,
            customPackageObj: {},
            carrierOptions: [],
            menuOptions: [{ Reports: [] }],
            rights: rights,
            packAndShipOrderInfo: {},
            mixedNewPackingSlipFeaturesDisagree: false,
            packAndShipContactString: "",
            smallPackGridData: [],
            isOpenAddQuantity: false,
            isOpenAddNonSkuQuantityModal: false,
            isOpenSerialPopup: false,
            enteredSerialNumber: "",
            isEnabledNextOnSerialPopup: false,
            serials: [],
            packSerialQty: 0,
            remainingQuantity: 0,
            itemQuantity: 0,
            nonSkuItemQuantity: 0,
            isOpenEditPackageDetailsModel: false,
            isOpenEditItemQtyModel: false,
            packedInSaveDisable: true,
            packGroupSaveDisable: true,
            selectPackedIn: "",
            editPackageOptions: [],
            editPackedInOptions: [],
            isOpenTrackByInfoMOdel: false,
            scanInputLoading: false,
            packCompleteLoading: false,
            isOpenConfirmDeleteAllPopup: false,
            invalidValue: false,
            disableDeleteAll: false,
            trackByModelInfo: [],
            editSelectedPackageDefId: "",
            editPackageWeight: "",
            editPackageHeight: "",
            editPackageWidth: "",
            editPackageLength: "",
            isCustomDimensionPackSelect: false,
            originalPackageWeight: "",
            scanGridKey: "",
            scanPackedQty: "",
            scanNonSkuPackedQty: "",
            isScanPackedNotAvailable: false,
            scanPackedLoading: false,
            deleteAllLoading: false,
            currentMeasurementStandardIsImperial: GlobalService.getMeasurementStandardFlag(this.props.facilityId),
            isPackNShipLoading: false,
            packNShipLoadingMsg: "",
            isQtyPopupScannedFocus: false,
            isSmartParcelEnabled: isSParcelEnabled,
            isSmartPackEnabled: isSPackEnabled,
            isAnyItemUnpacked: false,
            showAvailableRates: false,
            quantityRegx: /(^[0-9]+$|^$)/,
            isPackOrPackAndShipDisabled: true,
            packOrPackShipTooltip: this.translate("Label_Order_Still_Loading_Try_Again"),
            isOrderLoadFailed: false,
            isShipInFlight: false,
            scaleChangeWeight: 0,
            isDeviceConnect: false,
            isOneQtyPack: metaDataService.getPackAndShipOneQtyPackInMetaData(),
            selectUnpack: false,
            isPackSelectedBtnEnabled: false,
            packSelectedBtnTooltip: "",
            gridSortOptions: {},
            isShowEditContactIcon: false,
            isOpenEditAddressDetailModal: false,
            isShowEditCareerIcon: false,
            isOpenEditCareerDetailModal: false,
            isOpenDuplicatePrintingModel: false,
            carrier: this.translate("Label_None_Selected"),
            service: this.translate("Label_None_Selected"),
            reference1: "",
            reference2: "",
            reference3: "",
            packageContentDescription: "",
            tempCarrierAccountNickname: "",
            availableCarrierAccounts: "",
            optionsTemplateReports: [],
            optionsPackingReports: [],
            papiDocumentTemplatesRaw: [],
            // isIntegratedPackingSlips: true when a packing slip is configured for the current order.
            // Under PAPI: set when SmallParcelPapiPackSlipTemplateId is non-empty.
            // Under SSRS: set when both SmallParcelPackSlip and SmallParcelAddressTemplate are non-empty.
            // When passed in showProgressModal events, false under PAPI (slip comes via documents.combined).
            isIntegratedPackingSlips: false,
            quotedRates: "",
            settings: null, // Store SmallParcel settings including SmallParcelRateShoppingLogic

            // QZ Tray printer configuration
            showPrinterConfigNotification: false,
            printerNotificationType: "zpl", // 'zpl' or 'pdf'
            printerNotificationMessage: {
                title: "",
                message: "",
            },
            showPrinterSettingsModal: false,
            loadPackInfoCall: false,
            requiredScanActive: rights.hasOwnProperty('UxPrototypingDirectivesRequiredScan'),
            scannedPkgUris:[]
        };
    }
    async componentDidMount() {
        this._isMounted = true;
        document.addEventListener(shipInFlightGuard.SHIP_IN_FLIGHT_CHANGED_EVENT, this.syncShipInFlightButtonState);
        document.addEventListener("EventSmallParcelDataChanged", this.syncShipInFlightButtonState);
        document.addEventListener("focusin", this.handleWindowTakingFocus);
        this.syncShipInFlightButtonState();
        kendo.ui.progress($("#PackAndShipTransactionModel"), true);
        await GlobalService.GetCustomersAndFacility();
        // clear current package on componentDidMount
        this._clearCurrentPackage();

        // Check printer configuration (use .catch() to handle async errors and not block startup)
        this.checkPrinterConfiguration().catch((error) => {
            console.error("[Pack & Ship] Error checking printer configuration on mount:", error);
            // Silently fail - don't block component from loading
        });

        if (this.props.sharedSelectedOrderIds.length == 1) {
            let orderId = this.props.sharedSelectedOrderIds[0];
            let facilityId = this.props.facilityId;
            smallParcelService.orderInfo(orderId).then((response) => {
                this.order = response.orderPackInfoResponse;

                if (this.order.ChosenRate) {
                    let convertToObject = JSON.parse(this.order.ChosenRate);
                    if (convertToObject.amounts && convertToObject.amounts.total) {
                        this.setState({
                            quotedRates: "$"+convertToObject.amounts.total.toFixed(2),
                        });
                    } else {
                        this.setState({
                            quotedRates: "",
                        });
                    }
                }
                // Extract and parse SmallParcelRateShoppingLogic from OrderPackInfo response
                if (this.order.SmallParcelRateShoppingLogic) {
                    try {
                        const parsedSettings = {
                            SmallParcelRateShoppingLogic: JSON.parse(this.order.SmallParcelRateShoppingLogic)
                        };
                        this.setState({ settings: parsedSettings });
                    } catch (error) {
                        console.error("Failed to parse SmallParcelRateShoppingLogic:", error);
                    }
                }

                if (this.order.PackageData.length > 0 && this.order.OrderPacked == false && !this.order.SmallParcelShipDate) {
                    // If SmallParcelDisableClickToPack is enabled and OrderScanned is false, set first package as active
                    if (this.order.SmallParcelDisableClickToPack && this.state.requiredScanActive && !this.order.OrderScanned) {
                        this._setCurrentPackage(this.order.PackageData[0].PackageId);
                    } else {
                        this._setCurrentPackage(this.order.PackageData[this.order.PackageData.length - 1].PackageId);
                    }
                    // Which order we have open with have one or more packed item.
                    this.isAnyItemPacked = true;
                    // Call Order Pack Resumed Event
                    smallParcelService.orderPackEvent(orderId, 'OrderPackResumed').then((response) => {
                        // console.log("OrderPackResumed Events", response);
                    });
                } else if (this.order.PackageData.length > 0 && !this.order.SmallParcelShipDate) {
                    // Handle case when order is already packed but we still need to set active package
                    if (this.order.SmallParcelDisableClickToPack && this.state.requiredScanActive && !this.order.OrderScanned) {
                        this._setCurrentPackage(this.order.PackageData[0].PackageId);
                    } else {
                        this._setCurrentPackage(this.order.PackageData[this.order.PackageData.length - 1].PackageId);
                    }
                    this.isAnyItemPacked = true;
                }

                var tmpOrderInfo = response.orderInfoResponse;
                this.setPackagesOptions(tmpOrderInfo, facilityId);
                var tmpContactString = this.generateContactString(tmpOrderInfo);

                // set transaction label option
                let tempTransactionLabelOptions = [];
                tempTransactionLabelOptions.push({
                    LabelTemplateId: 0,
                    Name: this.translate("Label_Not_Specified"),
                });
                var genericTransactionArr = []; // template name is 'Generic'
                var customGenericTransactionArr = []; // retailer is 'Transaction Label'
                var customTransactionArr = []; // retailer is 'Transaction Label'

                for (let tlIndex = 0; tlIndex < this.order.TransactionLabels.length; tlIndex++) {
                    const objTLabel = this.order.TransactionLabels[tlIndex];
                    let tlName = objTLabel.Retailer ? objTLabel.Retailer + " : " : "";
                    tlName = tlName + objTLabel.Name;
                    let newObjCLabel = {
                        Name: tlName,
                        LabelTemplateId: objTLabel.LabelTemplateId,
                    };
                    if (objTLabel.Name == "Generic" && objTLabel.Retailer == "Transaction Label") {
                        genericTransactionArr.push(newObjCLabel);
                    } else if (objTLabel.Retailer == "Transaction Label") {
                        customGenericTransactionArr.push(newObjCLabel);
                    } else {
                        customTransactionArr.push(newObjCLabel);
                    }
                }
                genericTransactionArr.sort(this.sortOptions);
                customGenericTransactionArr.sort(this.sortOptions);
                customTransactionArr.sort(this.sortOptions);
                tempTransactionLabelOptions = tempTransactionLabelOptions.concat(customGenericTransactionArr, genericTransactionArr, customTransactionArr);

                // set carton label option
                let tempCartonLabelOptions = [];
                tempCartonLabelOptions.push({
                    LabelTemplateId: 0,
                    Name: this.translate("Label_Not_Specified"),
                });

                var libraryUCC128CartonArr = []; // template name start with  Library-
                var customUCC128CartonArr = []; // no specific naming rule
                var genericCartonArr = []; // template name is Generic
                var customGenericCartonArr = []; // template retailer  is Carton label

                for (let clIndex = 0; clIndex < this.order.CartonLabels.length; clIndex++) {
                    const objCLabel = this.order.CartonLabels[clIndex];
                    let clName = objCLabel.Retailer ? objCLabel.Retailer + " : " : "";
                    clName = clName + objCLabel.Name;
                    let newObjCLabel = {
                        Name: clName,
                        LabelTemplateId: objCLabel.LabelTemplateId,
                        sourceName: objCLabel.Name,
                    };
                    if (objCLabel.Name.indexOf("Library-") != -1) {
                        newObjCLabel.Name = newObjCLabel.Name.replace("Library-", "");
                        libraryUCC128CartonArr.push(newObjCLabel);
                    } else if (objCLabel.Name == "Generic" && objCLabel.Retailer == "Carton Label") {
                        genericCartonArr.push(newObjCLabel);
                    } else if (objCLabel.Retailer == "Carton Label") {
                        customGenericCartonArr.push(newObjCLabel);
                    } else {
                        customUCC128CartonArr.push(newObjCLabel);
                    }
                }

                libraryUCC128CartonArr.sort(this.sortOptions);
                genericCartonArr.sort(this.sortOptions);
                customGenericCartonArr.sort(this.sortOptions);
                customUCC128CartonArr.sort(this.sortOptions);

                if (customGenericCartonArr.length) {
                    customGenericCartonArr.push({
                        Name: "",
                        LabelTemplateId: "",
                        isSeparator: true,
                    });
                }
                if (genericCartonArr.length) {
                    genericCartonArr.push({
                        Name: "",
                        LabelTemplateId: "",
                        isSeparator: true,
                    });
                }
                if (customUCC128CartonArr.length) {
                    customUCC128CartonArr.push({
                        Name: "",
                        LabelTemplateId: "",
                        isSeparator: true,
                    });
                }

                tempCartonLabelOptions = tempCartonLabelOptions.concat(customGenericCartonArr, genericCartonArr, customUCC128CartonArr, libraryUCC128CartonArr);

                var packAdnShipObj = this.state.packAdnShipObj;
                if (tmpOrderInfo.smallParcelZplPrintDefault) {
                    packAdnShipObj.labelFormat = "Zpl";
                }
                if (
                    tmpOrderInfo.smallParcelHighVolumeDefaultChecked &&
                    this.state.rights.hasOwnProperty("Shipping.SmallParcelHighVolumeProcessing")
                ) {
                    packAdnShipObj.processAs = "High Volume";
                }
                if (tmpOrderInfo.autoPrintCartonLabelDefault) {
                    this.isPrintIconShaw = true;
                }
                if (tmpOrderInfo.smartPackScaleEnabled) {
                    if (window.self === window.top) {
                        // console.log("Scale without iFrame");
                        Scale.connect();
                        document.addEventListener("scaleDeviceWeightChange", this.scaleDeviceWeightChange);
                        document.addEventListener("scaleConnectionChange", this.scaleConnectionChange);
                    } else {
                        console.log("Scale with iFrame");
                        window.top.postMessage(
                            {
                                event: "TRIGGER_SCALE_CONNECTION",
                                data: {},
                            },
                            "*"
                        );
                        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                        var eventer = window[eventMethod];
                        var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
                        var that = this;
                        eventer(messageEvent, function (e) {
                            //data you receive from parent is stored inside e.data
                            if (e.data.event === "scaleDeviceWeightChange") {
                                that.scaleDeviceWeightChange(e.data.data);
                            } else if (e.data.event === "scaleConnectionChange") {
                                that.scaleConnectionChange(e.data.data);
                            }
                        });
                    }
                }
                if (tmpOrderInfo.customerId) {
                    var customerObj = GlobalService.getCustomerById(tmpOrderInfo.customerId);
                    if (customerObj && customerObj.options && customerObj.options.allowDuplicateUPCs) {
                        this.isAllowDuplicatedUPC = true;
                    }
                }
                this.isDisabledPack = this.order.OrderPacked;
                this.isSetActivePackage = this.order.OrderPacked == true ? false : true;
                var transactionLabel = this.state.transactionLabel;
                var transactionAvailable = tempTransactionLabelOptions.find((x) => x.LabelTemplateId == this.state.transactionLabel);
                if (!transactionAvailable) {
                    transactionLabel = "";
                }

                this._legacyCartonLabelOptions = tempCartonLabelOptions;
                this._cartonDefaultPackaging = null;
                const deferCartonOptions = papiDocumentUtil.isPapiDocEnabled(this.state.rights, "ucc128");
                const initialCartonDefaultName = papiDocumentUtil.readSavedDefaultCartonLabelName(
                    tmpOrderInfo,
                    null
                );
                const initialCartonLabel = deferCartonOptions
                    ? 0
                    : papiDocumentUtil.reconcileLabelSelection(
                        tempCartonLabelOptions,
                        papiDocumentUtil.resolveLegacyCartonLabelTemplateId(
                            tempCartonLabelOptions,
                            initialCartonDefaultName
                        )
                    );
                this.setState({
                    packAndShipContactString: tmpContactString,
                    packAndShipOrderInfo: Object.assign({}, tmpOrderInfo, {
                        OrderId: orderId,
                    }),
                    cartonLabelOptions: deferCartonOptions
                        ? [{ LabelTemplateId: 0, Name: this.translate("Label_Ucc128_Loading_Templates") }]
                        : tempCartonLabelOptions,
                    cartonLabelOptionsLoading: deferCartonOptions,
                    cartonLabel: initialCartonLabel,
                    transactionLabelOptions: tempTransactionLabelOptions,
                    packAdnShipObj: packAdnShipObj,
                    transactionLabel: transactionLabel,
                    loadPackInfoCall: true,
                    isOrderLoadFailed: false,
                });

                setTimeout(() => {
                    this.listGrid_dataBind();
                }, 500);
                this.callInitialPrintMenu(tmpOrderInfo.customerId);
                if (papiDocumentUtil.isPapiDocEnabled(this.state.rights, "ucc128")) {
                    const uccCustomerIds = tmpOrderInfo.customerId != null
                        ? [tmpOrderInfo.customerId]
                        : (this.props.sharedSelectedCustomerIds || []);
                    smallParcelService.getCustomersSettings(uccCustomerIds).then((settingsResponse) => {
                        this.captureUcc128CustomerSettings(settingsResponse && settingsResponse.data);
                        if (this.usesNewUcc128ForPackAndShip()) {
                            this.loadUcc128TemplateOptions();
                        } else {
                            this.publishLegacyCartonLabelOptions();
                        }
                    }).catch(() => {
                        this.publishCartonOptionsAfterSettingsFailure();
                    });
                }

                var self = this;
                $(document).off("click", ".edit-package");
                $(document).on("click", ".edit-package", function () {
                    self.packageIdForEdit =
                        $(this).attr("package-id") ||
                        $(this).closest(".group-icon-wrapper").attr("package-id");
                    self.groupPackageEditPopupOpen();
                    return false;
                });
                $(document).off("click", ".remove-package");
                $(document).on("click", ".remove-package", function () {
                    self.packageIdForDelete =
                        $(this).attr("package-id") ||
                        $(this).closest(".group-icon-wrapper").attr("package-id");
                    var pkgForDelete = self._getPackageFromOrder(self.packageIdForDelete);
                    self.setState({
                        isOpenDeleteConfirmModel: true,
                        selectedPackageName: pkgForDelete.Name,
                    });
                    return false;
                });
                $(document).off("click", ".remove-unassing-package");
                $(document).on("click", ".remove-unassing-package", function () {
                    var packageName =
                        $(this).closest(".group-icon-wrapper").attr("unique-package-name") ||
                        $(this).attr("unique-package-name");
                    self.removePackageFromArr(packageName);
                    if (self.previousSelectedPackageArr.length) {
                        var lastIndex = self.previousSelectedPackageArr.length - 1;
                        self.currentPackage = self.previousSelectedPackageArr[lastIndex];
                        self.activePackageIconChange();
                    } else if (self.order.PackageData.length > 0) {
                        // If SmallParcelDisableClickToPack is enabled and OrderScanned is false, set first package as active
                        if (self.order.SmallParcelDisableClickToPack && (!self.order.OrderScanned || self.state.requiredScanActive)) {
                            self._setCurrentPackage(self.order.PackageData[0].PackageId);
                        } else {
                            self._setCurrentPackage(self.order.PackageData[self.order.PackageData.length - 1].PackageId);
                        }
                    } else {
                        self._clearCurrentPackage();
                    }
                    self.listGrid_dataBind();
                    return false;
                });

                $(document).off("click", ".print-package");
                $(document).on("click", ".print-package", function (e) {
                    var packageId =
                        $(this).attr("package-id") ||
                        $(this).closest(".group-icon-wrapper").attr("package-id");
                    self.autoPrintForIndividualPackage(packageId);
                    return false;
                });
            }, (error) => {
                console.error("[Pack & Ship] Failed to load order:", error);
                kendo.ui.progress($("#PackAndShipTransactionModel"), false);
                if (this._isMounted) {
                    this.setState({
                        isOrderLoadFailed: true,
                        isPackOrPackAndShipDisabled: true,
                        packOrPackShipTooltip: this.translate("Label_Order_Failed_To_Load_Refresh"),
                    });
                    GlobalService.notification("error", this.translate("Label_Order_Failed_To_Load_Refresh"));
                }
            }).catch((error) => {
                console.error("[Pack & Ship] Error while processing loaded order:", error);
                kendo.ui.progress($("#PackAndShipTransactionModel"), false);
                if (this._isMounted && !(this.state.packAndShipOrderInfo && this.state.packAndShipOrderInfo.OrderId)) {
                    this.setState({
                        isOrderLoadFailed: true,
                        isPackOrPackAndShipDisabled: true,
                        packOrPackShipTooltip: this.translate("Label_Order_Failed_To_Load_Refresh"),
                    });
                }
            });
        } else {
            if (this.props.isSameCustomerCallOrderApi) {
                let orderId = this.props.sharedSelectedOrderIds[0];
                smallParcelService.getOrderInfo(orderId).then((response) => {
                    var packAdnShipObj = Object.assign({}, this.state.packAdnShipObj);
                    if (response.smallParcelZplPrintDefault) {
                        packAdnShipObj.labelFormat = "Zpl";
                    }
                    if (
                        response.smallParcelHighVolumeDefaultChecked &&
                        this.state.rights.hasOwnProperty("Shipping.SmallParcelHighVolumeProcessing")
                    ) {
                        packAdnShipObj.processAs = "High Volume";
                    }
                    this.setState({
                        packAdnShipObj: packAdnShipObj,
                    });
                });
            }
            // Print menu waits on customer settings so the new packing slip flag is known first.
            this._multiOrderPrintMenuStarted = false;
            const startPrintMenu = () => {
                if (this._multiOrderPrintMenuStarted) {
                    return;
                }
                this._multiOrderPrintMenuStarted = true;
                this.callInitialPrintMenu();
            };
            smallParcelService.getCustomersSettings(this.props.sharedSelectedCustomerIds).then((response) => {
                this.captureUcc128CustomerSettings(response && response.data);
                this.loadUcc128TemplateOptions();
                if (response.data) {
                    _.map(response.data, (customer) => {
                        if (customer.Options && customer.Options.Packaging && customer.Options.Packaging.SmallParcelAutoRateShopOnShip) {
                            this.isCallAutoRateAPIMultiOrder = true;
                        }
                    });
                }

                // PAPI packing slips: mixed customers → unbound catalog only (no first-customer
                // default). Same-customer multi → that customer's saved default + opt-in.
                if (this.papiDocsEnabled) {
                    if (this.isPapiPackAndShipMixedCustomers()) {
                        const allCustomers = response.data || [];
                        const rights = this.state.rights;
                        const packagingList = allCustomers.map(function (customer) {
                            return customer && customer.Options && customer.Options.Packaging;
                        });
                        const allUseNew = allCustomers.length > 0 && allCustomers.every(function (c) {
                            return papiDocumentUtil.usesNewPackingSlipUi(rights, c);
                        });
                        // A split stays hidden. Unanimous legacy follows the directive-off packing-slip path.
                        const allUseLegacy = !allUseNew && allCustomers.length > 0 && allCustomers.every(function (c) {
                            return !papiDocumentUtil.isCustomerUsingNewPackingSlipFeatures(
                                c && c.Options && c.Options.Packaging
                            );
                        });
                        this.mixedPackingSlipSavedValue = papiDocumentUtil.resolveSharedPapiDocumentValue(
                            packagingList,
                            "packingSlip"
                        );
                        this.mixedPackingSlipSavedScope = papiDocumentUtil.resolveSharedPackagingValue(
                            packagingList,
                            "SmallParcelPapiPackSlipScope"
                        );
                        this.mixedPackingSlipSavedFormat = papiDocumentUtil.resolveSharedPackagingValue(
                            packagingList,
                            "SmallParcelPapiPackSlipFormat"
                        );
                        this.setState({
                            mixedNewPackingSlipFeaturesDisagree: allCustomers.length > 1 && !allUseNew && !allUseLegacy,
                            packAndShipOrderInfo: Object.assign({}, this.state.packAndShipOrderInfo, {
                                smallParcelUseNewPackingSlipFeatures: allUseNew,
                                smallParcelPapiPackSlipFormat: this.mixedPackingSlipSavedFormat || "",
                            }),
                            packAdnShipObj: Object.assign({}, this.state.packAdnShipObj, {
                                SmallParcelPapiPackSlipFormat: this.mixedPackingSlipSavedFormat || "",
                            }),
                        }, () => {
                            if (allUseNew) {
                                this.loadPackingSlipTypeOptions();
                            }
                            startPrintMenu();
                        });
                        return;
                    } else {
                        let savedDefaultId = null;
                        let savedTemplateVersion = null;
                        let savedScope = "";
                        let savedFormat = "";
                        let useNewPackingSlipFeatures = false;
                        let savedPackSlip = "";
                        let savedAddressTemplate = "";
                        if (response.data && response.data.length > 0) {
                            const firstCustomer = response.data[0];
                            const packaging = firstCustomer && firstCustomer.Options && firstCustomer.Options.Packaging;
                            const papiSettings = papiDocumentUtil.readCustomerPapiPackSlipSettings(packaging);
                            savedDefaultId = papiSettings.templateId;
                            savedTemplateVersion = papiSettings.templateVersion;
                            savedScope = papiSettings.scope;
                            savedFormat = papiSettings.format;
                            useNewPackingSlipFeatures = papiDocumentUtil.isCustomerUsingNewPackingSlipFeatures(packaging);
                            savedPackSlip = (packaging && packaging.SmallParcelPackSlip) || "";
                            savedAddressTemplate = (packaging && packaging.SmallParcelAddressTemplate) || "";
                        }
                        if (!papiDocumentUtil.usesNewPackingSlipUi(this.state.rights, response.data && response.data[0])) {
                            startPrintMenu();
                            return;
                        }
                        this.setState(
                            {
                                mixedNewPackingSlipFeaturesDisagree: false,
                                packAndShipOrderInfo: Object.assign({}, this.state.packAndShipOrderInfo, {
                                    smallParcelPapiPackSlipTemplateId: savedDefaultId,
                                    smallParcelPapiPackSlipTemplateVersion: savedTemplateVersion,
                                    smallParcelPapiPackSlipScope: savedScope,
                                    smallParcelPapiPackSlipFormat: savedFormat,
                                    smallParcelUseNewPackingSlipFeatures: useNewPackingSlipFeatures,
                                    smallParcelPackSlip: savedPackSlip,
                                    smallParcelAddressTemplate: savedAddressTemplate,
                                }),
                                packAdnShipObj: Object.assign({}, this.state.packAdnShipObj, {
                                    SmallParcelPapiPackSlipTemplateId: savedDefaultId || "",
                                    SmallParcelPapiPackSlipTemplateVersion: savedTemplateVersion,
                                    SmallParcelPapiPackSlipScope: savedScope || "",
                                    SmallParcelPapiPackSlipFormat: savedFormat || "",
                                    SmallParcelPackSlip: savedPackSlip,
                                    SmallParcelAddressTemplate: savedAddressTemplate,
                                }),
                            },
                            () => {
                                this.loadPackingSlipTypeOptions();
                                startPrintMenu();
                            }
                        );
                        return;
                    }
                }
                startPrintMenu();
            }).catch(() => {
                startPrintMenu();
            });
        }
        let tmpProcessAsOption = [{ description: "Standard", value: "Standard" }];
        if (this.state.rights.hasOwnProperty("Shipping.SmallParcelHighVolumeProcessing")) {
            tmpProcessAsOption.push({
                description: "High-Volume",
                value: "High Volume",
            });
        }
        this.processAsOption = tmpProcessAsOption;
        var combobox = $("#PackAndShiAddaPackage").data("kendoComboBox");
        combobox.bind("filtering", function (e) {
            var filterValue = e.filter != undefined ? e.filter.value : "";
            e.preventDefault();
            this.dataSource.filter({
                logic: "or",
                filters: [
                    {
                        field: "Name",
                        operator: "contains",
                        value: filterValue,
                    },
                    {
                        field: "Barcode",
                        operator: "contains",
                        value: filterValue,
                    },
                ],
            });
        });

        $("#" + this.state.selector + "scanGridKey").keydown((e) => {
            if (e.keyCode == 13) {
                this.onScanValueEnter();
            }
        });

        // Delegated listeners survive Kendo Window DOM reparenting.
        // Own scan/qty events via jQuery only (no React onChange/onFocus/onClick) to avoid double-binding.
        this.unbindQtyPopupDocumentListeners();

        $(document).on("keydown", "#" + this.state.selector + "scanPackedQty", (e) => {
            if (e.keyCode == 13) {
                this.onScanQtyPopupEnter();
            }
        });
        $(document).on("input", "#" + this.state.selector + "scanPackedQty", (e) => {
            this.handleScanGridKeyChange(e);
        });
        $(document).on("focusin", "#" + this.state.selector + "scanPackedQty", this.onFocusScanQtyPopup);
        $(document).on("focusout", "#" + this.state.selector + "scanPackedQty", this.onBlurScanQtyPopup);

        $(document).on("keydown", "#" + this.state.selector + "scanNonSkuPackedQty", (e) => {
            if (e.keyCode == 13) {
                this.onScanNonSkuQtyPopupEnter();
            }
        });
        $(document).on("input", "#" + this.state.selector + "scanNonSkuPackedQty", (e) => {
            this.handleScanGridKeyChange(e);
        });
        $(document).on("focusin", "#" + this.state.selector + "scanNonSkuPackedQty", this.onFocusScanQtyPopup);
        $(document).on("focusout", "#" + this.state.selector + "scanNonSkuPackedQty", this.onBlurScanQtyPopup);

        // Scan icon: focus the hidden input (works after Kendo Window reparenting).
        $(document).on("click", ".add-item-quantity-wrapper .scan-inputlabel", function () {
            var input = this.querySelector("input");
            if (input) {
                input.focus();
            }
        });

        // +/- : React onClick misses after Kendo Window reparents the DOM.
        $(document).on("click", "[data-wms-selector='packedQuantityMinus']", (e) => {
            this.onQtyDecrement(e);
        });
        $(document).on("click", "[data-wms-selector='packedQuantityPlus']", (e) => {
            this.onQtyIncrement(e);
        });
        $(document).on("click", "[data-wms-selector='packedNonSkuQuantityMinus']", (e) => {
            this.onNonSkuQtyDecrement(e);
        });
        $(document).on("click", "[data-wms-selector='packedNonSkuQuantityPlus']", (e) => {
            this.onNonSkuQtyIncrement(e);
        });

        let scannedTimeOut = null
        $(document).on("keydown", "#" + this.state.selector + "serialNumber", (e) => {
            if (e.keyCode == 13 && e.target.value) {
                clearTimeout(scannedTimeOut);
                scannedTimeOut = setTimeout(() => {
                    this.onEnterSerialInput();
                }, 500);
            }
        });
        $(document).on("input", "#" + this.state.selector + "serialNumber", (e) => {
            this.handleScanGridKeyChange(e);
        });
    }

    scaleDeviceWeightChange = (e) => {
        if (!this.state.isDeviceConnect) {
            this.setState({ isDeviceConnect: true });
        }
        // console.log("scaleDeviceWeightChange Called", e);
        if (e.detail) {
            var weight = e.detail.weight;
            var measurementUnit = this.state.currentMeasurementStandardIsImperial ? "lbs" : "kg";
            if (measurementUnit != e.detail.unit) {
                if (e.detail.unit == "lbs" && measurementUnit == "kg") {
                    weight = (e.detail.weight / 2.2046).toFixed(4);
                } else if (e.detail.unit == "kg" && measurementUnit == "lbs") {
                    weight = (e.detail.weight * 2.2046).toFixed(4);
                } else if (e.detail.unit == "oz" && measurementUnit == "kg") {
                    weight = (e.detail.weight * 0.02834952).toFixed(4);
                } else if (e.detail.unit == "oz" && measurementUnit == "lbs") {
                    weight = (e.detail.weight / 16).toFixed(4);
                } else if (e.detail.unit == "g" && measurementUnit == "kg") {
                    weight = (e.detail.weight / 1000).toFixed(4);
                } else if (e.detail.unit == "g" && measurementUnit == "lbs") {
                    weight = (e.detail.weight / 453.59237).toFixed(4);
                }
            }

            if (this.state.isOpenEditPackageDetailsModel) {
                this.weightChanged = true;
                this.setState({
                    editPackageWeight: weight,
                    packGroupSaveDisable: false,
                });
            } else {
                this.setState({
                    scaleChangeWeight: weight,
                });
            }
        }
    };
    scaleConnectionChange = (e) => {
        this.setState(
            {
                isDeviceConnect: e.detail.connected,
            },
            () => {
                this.listGrid_dataBind();
            }
        );
    };
    sortOptions(first, second) {
        var firstLabelName = first.Name.toUpperCase(); // ignore upper and lowercase
        var secondLabelName = second.Name.toUpperCase(); // ignore upper and lowercase

        if (firstLabelName < secondLabelName) {
            return -1;
        }

        if (firstLabelName > secondLabelName) {
            return 1;
        }
        // names must be equal
        return 0;
    }
    unbindQtyPopupDocumentListeners = () => {
        var scanPackedQty = "#" + this.state.selector + "scanPackedQty";
        var scanNonSkuPackedQty = "#" + this.state.selector + "scanNonSkuPackedQty";
        var serialNumber = "#" + this.state.selector + "serialNumber";
        $(document).off("keydown input focusin focusout", scanPackedQty);
        $(document).off("keydown input focusin focusout", scanNonSkuPackedQty);
        $(document).off("keydown input", serialNumber);
        $(document).off("click", ".add-item-quantity-wrapper .scan-inputlabel");
        $(document).off("click", "[data-wms-selector='packedQuantityMinus']");
        $(document).off("click", "[data-wms-selector='packedQuantityPlus']");
        $(document).off("click", "[data-wms-selector='packedNonSkuQuantityMinus']");
        $(document).off("click", "[data-wms-selector='packedNonSkuQuantityPlus']");
    };

    // Clicking anything Kendo renders outside the window, such as the package
    // combobox list, makes Kendo's toFront() park focus on the window itself once
    // its animation delay has passed. That happens after this modal has put focus
    // in the scan field, and it leaves the operator with nothing to scan into, so
    // hand the field back whenever the window takes focus for itself.
    handleWindowTakingFocus = (e) => {
        var windowElement = e.target;
        if (!windowElement || !windowElement.classList || !windowElement.classList.contains("k-window")) {
            return;
        }
        var modelElement = document.getElementById("PackAndShipTransactionModel");
        if (!modelElement || !windowElement.contains(modelElement)) {
            return;
        }
        if (this.isAnyPopupOpenOverPackAndShip(windowElement)) {
            return;
        }
        // With no package left there is nothing a SKU scan could pack into, so
        // handing back the scan field would only bounce the operator to the package
        // combobox a moment later.
        if (this.shouldFocusAddPackage()) {
            this.setFocusOnAddPackageAndSelectValue();
            return;
        }
        var scanElement = document.getElementById(this.state.selector + "scanGridKey");
        if (scanElement && !scanElement.disabled && scanElement.offsetParent !== null) {
            scanElement.focus();
        }
    };

    isAnyPopupOpenOverPackAndShip = (packAndShipWindow) => {
        return Array.prototype.some.call(document.querySelectorAll(".k-window"), (windowElement) => {
            return windowElement !== packAndShipWindow && windowElement.offsetParent !== null;
        });
    };

    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener(shipInFlightGuard.SHIP_IN_FLIGHT_CHANGED_EVENT, this.syncShipInFlightButtonState);
        document.removeEventListener("EventSmallParcelDataChanged", this.syncShipInFlightButtonState);
        document.removeEventListener("focusin", this.handleWindowTakingFocus);
        document.removeEventListener("scaleDeviceWeightChange", this.scaleDeviceWeightChange);
        document.removeEventListener("scaleConnectionChange", this.scaleConnectionChange);
        this.unbindQtyPopupDocumentListeners();
        this.setCareerSectionRef(null);
        this.setContactSectionRef(null);
    }
    setPackagesOptions = (tmpOrderInfo, facilityId) => {
        var customerId = tmpOrderInfo.customerId;
        smallParcelService
            .getCarriersAndCapacityTypes(customerId, facilityId)
            .then((response) => {
                // Get Carrier Accounts
                this.setState({
                    availableCarrierAccounts: response.CarrierAccounts.CarrierAccounts,
                });

                var packageOptions = response.PackageDefs;

                let tmpShipEngineCarrierResponse = response.Carriers.Carriers;
                tmpShipEngineCarrierResponse = tmpShipEngineCarrierResponse.filter((obj) => {
                    return obj.Name != "Buku" && obj.Name != "PitneyBowesExp";
                });
                if (!this.isEnableProvider) {
                    tmpShipEngineCarrierResponse = tmpShipEngineCarrierResponse.filter((obj) => {
                        return obj.Name != "PitneyBowesStd";
                    });
                }

                var carrierOptions = tmpShipEngineCarrierResponse;

                packageOptions = _.orderBy(packageOptions, [(packageItem) => packageItem.Name.toLowerCase()], ["asc"]);
                packageOptions = _.orderBy(packageOptions, ["IsDefault"], ["desc"]);
                // packageOptions.find(function (e) {
                //     if (e.IsDefault) {
                //         e.Name = e.Name + " (default)";
                //     }
                // });
                packageOptions = packageOptions.filter(function (e) {
                    if (e.IsDefault) {
                        e.Name = e.Name + " (default)";
                    }
                    if (e.AssignedCustomers.length === 0 || e.AssignedCustomers.includes(customerId)) {
                        return true;
                    }
                });
                if (this.state.rights.hasOwnProperty("Shipping.SmartPackScaleEnabled")) {
                    packageOptions.push(this.pkgCustomOption);
                }
                var tmpCarrierServiceObj = this.getCarrierServiceName(
                    carrierOptions,
                    tmpOrderInfo.carrier,
                    tmpOrderInfo.shipServiceCode
                );
                this.setState({
                    packagesOptions: packageOptions,
                    carrierOptions: carrierOptions,
                    carrier: tmpCarrierServiceObj.Carrier,
                    service: tmpCarrierServiceObj.Service,
                });
                // Set Carrier Account Nickname
                this.setCarrierAccountNickname(tmpOrderInfo.accountNumber);
            })
            .finally(() => {});
    };
    callInitialPrintMenu = (customerId = "") => {
        GlobalService.initialPrintMenu(customerId)
            .then((response) => {
                if (response) {
                    let reprintShippingLabelMenus = response.filter(function (e) {
                        return e.CategoryName == "Reprint Shipping Label";
                    });

                    // Check If Label Template Deleted Then Set Default Label Template Otherwise Set Small Parcel Setting Label Template
                    let tmpComboLabelTemplate = reprintShippingLabelMenus[0].Reports[0].Name;
                    let tmpComboLabelTemplateValue = reprintShippingLabelMenus[0].Reports[0].TemplatedRunnerKey;
                    const orderInfo = this.state.packAndShipOrderInfo || {};
                    const useNewFeatures = papiDocumentUtil.usesNewPackingSlipUi(this.state.rights, orderInfo);
                    if (!useNewFeatures && orderInfo.smallParcelDefaultLabelTemplate != "") {
                        let selectedReport = reprintShippingLabelMenus[0].Reports.find(
                            (elem) => elem.Name == orderInfo.smallParcelDefaultLabelTemplate
                        );
                        if (selectedReport != undefined) {
                            tmpComboLabelTemplate = selectedReport.Name;
                            tmpComboLabelTemplateValue = selectedReport.TemplatedRunnerKey;
                        }
                    }

                    // Legacy carton templates. The new UCC-128 setting selects its own saved template.
                    if (!this.usesNewUcc128ForPackAndShip()) {
                        const legacyOptions = this._legacyCartonLabelOptions || this.state.cartonLabelOptions;
                        const savedCartonName = papiDocumentUtil.readSavedDefaultCartonLabelName(
                            this.state.packAndShipOrderInfo,
                            this._cartonDefaultPackaging
                        );
                        const nextLabelTemplateId = papiDocumentUtil.reconcileLabelSelection(
                            legacyOptions,
                            papiDocumentUtil.resolveLegacyCartonLabelTemplateId(
                                legacyOptions,
                                savedCartonName
                            )
                        );
                        if (!papiDocumentUtil.isBlankLabelId(nextLabelTemplateId)) {
                            this.setState({ cartonLabel: nextLabelTemplateId });
                        }
                    }

                    this.setState({
                        menuOptions: reprintShippingLabelMenus,
                        packAdnShipObj: Object.assign({}, this.state.packAdnShipObj, {
                            comboLabelTemplate: tmpComboLabelTemplate,
                            comboLabelTemplateValue: tmpComboLabelTemplateValue,
                            SmallParcelAddressTemplate: this.state.packAndShipOrderInfo.smallParcelAddressTemplate,
                            SmallParcelPackSlip: this.state.packAndShipOrderInfo.smallParcelPackSlip,
                            SmallParcelPapiPackSlipTemplateId:
                                this.state.packAndShipOrderInfo.smallParcelPapiPackSlipTemplateId || "",
                            SmallParcelPapiPackSlipTemplateVersion:
                                this.state.packAndShipOrderInfo.smallParcelPapiPackSlipTemplateVersion || null,
                            SmallParcelPapiPackSlipScope:
                                this.state.packAndShipOrderInfo.smallParcelPapiPackSlipScope || "",
                            SmallParcelPapiPackSlipFormat:
                                this.state.packAndShipOrderInfo.smallParcelPapiPackSlipFormat || "",
                        }),
                    }, () => {
                        // The working object prefers its own template id over order info, so the
                        // saved id has to be copied in before the packing-slip list is built.
                        this.loadPackingSlipCatalogs(customerId);
                    });
                }
            })
            .finally(() => {
                kendo.ui.progress($("#PackAndShipTransactionModel"), false);
            });
    };

    groupPackageEditPopupOpen = () => {
        let pkgForEdit = this._getPackageFromOrder(this.packageIdForEdit);
        this.setState(
            {
                editSelectedPackageDefId: pkgForEdit.PackageDefId,
                editPackageWeight: pkgForEdit.Weight,
                isCustomDimensionPackSelect: pkgForEdit.Name == this.translate("Label_Custom_Dimensions"),
                editPackageHeight: pkgForEdit.Height,
                editPackageWidth: pkgForEdit.Width,
                editPackageLength: pkgForEdit.Length,
                originalPackageWeight: pkgForEdit.Weight,
                packGroupSaveDisable: true,
                isOpenEditPackageDetailsModel: true,
                packageContentDescription: pkgForEdit.Description,
            },
            () => {
                kendo.ui.progress($("#" + this.props.windowId + "EditPackageDetails"), true);
                smallParcelService
                    .getReferenceFields(pkgForEdit.PackageUri)
                    .then((response) => {
                        this.setState({
                            reference1: response.reference1,
                            reference2: response.reference2,
                            reference3: response.reference3,
                        });
                    })
                    .finally(() => {
                        kendo.ui.progress($("#" + this.props.windowId + "EditPackageDetails"), false);
                    });
            }
        );
        this.weightChanged = false;
    };

    onCloseDeleteConfirmationModel = () => {
        this.setState(
            {
                isOpenDeleteConfirmModel: false,
                selectedPackageName: "",
            },
            () => {
                this.setFocusOnScanAndSelectValue();
            }
        );
    };
    onCloseDeleteAllConfirmationModel = () => {
        this.setState(
            {
                isOpenConfirmDeleteAllPopup: false,
            },
            () => {
                this.setFocusOnPackOrAddPackage();
            }
        );
    };
    closePackGroup = () => {
        this.setState(
            {
                isOpenEditPackageDetailsModel: false,
            },
            () => {
                this.setFocusOnScanAndSelectValue();
            }
        );
    };
    handleEditPackageChange = (e) => {
        let pkg = this._getPackageFromOrder(this.packageIdForEdit);
        var packGroupSaveDisable = false;
        var tmpIsCustomDimensionPackSelect = this.state.isCustomDimensionPackSelect;
        if (e.target.name === "editSelectedPackageDefId") {
            tmpIsCustomDimensionPackSelect = false;
            if (pkg.PackageDefId == e.target.value && !this.weightChanged) {
                packGroupSaveDisable = true;
            }
            if (e.target.value == 0) {
                tmpIsCustomDimensionPackSelect = true;
            } else {
                var new_pkg = this.state.packagesOptions.find(function (p) {
                    return p.PackageDefId == e.target.value;
                });

                let editPackageHeight = this.state.currentMeasurementStandardIsImperial
                    ? new_pkg.HeightImperial
                        ? new_pkg.HeightImperial + ""
                        : "0"
                    : new_pkg.HeightMetric
                    ? new_pkg.HeightMetric + ""
                    : "0";
                let editPackageWidth = this.state.currentMeasurementStandardIsImperial
                    ? new_pkg.WidthImperial
                        ? new_pkg.WidthImperial + ""
                        : "0"
                    : new_pkg.WidthMetric
                    ? new_pkg.WidthMetric + ""
                    : "0";
                let editPackageLength = this.state.currentMeasurementStandardIsImperial
                    ? new_pkg.LengthImperial
                        ? new_pkg.LengthImperial + ""
                        : "0"
                    : new_pkg.LengthMetric
                    ? new_pkg.LengthMetric + ""
                    : "0";

                this.setState({
                    editPackageHeight: editPackageHeight,
                    editPackageWidth: editPackageWidth,
                    editPackageLength: editPackageLength,
                });
            }
        }
        this.setState({
            [e.target.name]: e.target.value,
            packGroupSaveDisable: packGroupSaveDisable,
            isCustomDimensionPackSelect: tmpIsCustomDimensionPackSelect,
        });
        if (e.target.name === "editPackageWeight") {
            if (pkg.Weight != e.target.value) {
                this.weightChanged = true;
            }
        }
    };
    handleEditReferenceFieldChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            packGroupSaveDisable: false,
        });
    };
    handleEditPackageContentDescriptionChange = (e) => {
        this.setState({
            packageContentDescription: e.target.value,
            packGroupSaveDisable: false,
        });
    };
    onResetIconClick = () => {
        this.setState({ editPackageWeight: this.state.originalPackageWeight });
    };
    closePackItem = () => {
        this.setState(
            {
                isOpenEditItemQtyModel: false,
            },
            () => {
                this.setFocusOnScanAndSelectValue();
            }
        );
    };
    deleteConfirmPackage = () => {
        var pkg = this._getPackageFromOrder(this.packageIdForDelete);
        if (pkg) {
            kendo.ui.progress($("#" + this.props.windowId + "confirmDeletePackage"), true);
            smallParcelService
            .deletePackage(pkg.PackageUri)
            .then((response) => {
                GlobalService.notification("success", this.translate("Label_Package_Remove_Success"));
                this.order.PackageData = this.order.PackageData.filter((p) => {
                    return p.PackageId != this.packageIdForDelete;
                });
                if (this.order.PackageData.length > 0) {
                    // If SmallParcelDisableClickToPack is enabled and OrderScanned is false, set first package as active
                    if (this.order.SmallParcelDisableClickToPack && this.state.requiredScanActive && !this.order.OrderScanned) {
                        this._setCurrentPackage(this.order.PackageData[0].PackageId);
                    } else {
                        this._setCurrentPackage(this.order.PackageData[this.order.PackageData.length - 1].PackageId);
                    }
                    // Which order we have open with have one or more item remain into package.
                    this.isAnyItemPacked = true;
                } else {
                    this._clearCurrentPackage();
                    // Which order we have open and don't have item into package.
                    this.isAnyItemPacked = false;
                }
                this.setState({
                    isOpenDeleteConfirmModel: false,
                    selectedPackageName: "",
                    selectUnpack: false,
                    isPackSelectedBtnEnabled: false,
                });
                // Enable pack button after package item change when order is already packed
                this.isDisabledPack = false;
                this.listGrid_dataBind();
                this.isSmallParcelGridRefresh = true;
            })
            .finally(() => {
                kendo.ui.progress($("#" + this.props.windowId + "confirmDeletePackage"), false);
            });
        }
    };
    deleteAllConfirm = () => {
        this.setState({
            deleteAllLoading: true,
        });

        kendo.ui.progress($("#packAndShipTransactionGrid"), true);

        smallParcelService
            .deleteAllPackage(this.state.packAndShipOrderInfo.OrderId, this.state.requiredScanActive)
            .then( async (response) => {
                // The packages are gone on the server, so drop them here too rather
                // than leaving stale ones behind for the seconds it takes to reload.
                // The popup closes in the meantime and whatever restores focus then
                // would otherwise pick the scan field and have to correct itself.
                this.order.PackageData = [];
                this._clearCurrentPackage();

                // Delete All Non Sku Packages
                if (this.order.Inserts) {
                    let orderId = this.props.sharedSelectedOrderIds[0];
                    for (const itemValue of this.order.Inserts) {
                        if (
                            itemValue.InsertedQuantity &&
                            itemValue.PackageInsertIdentifier &&
                            itemValue.PackageInsertIdentifier.Id
                        ) {
                            try {
                                await smallParcelService.deletePackNonSkuInsertsAsync(
                                    orderId,
                                    itemValue.PackageInsertIdentifier.Id,
                                    0
                                );
                            } catch (e) {
                                console.log(e);
                            }
                        }
                    }
                }

                // Get Order Pack Info
                smallParcelService
                    .getOrderPackInfo(this.state.packAndShipOrderInfo.OrderId)
                    .then((response) => {
                        this.order = response;
                        // Which order we have open and no item into package.
                        this.isAnyItemPacked = false;
                        if (this.order.PackageData.length > 0) {
                            // If SmallParcelDisableClickToPack is enabled and OrderScanned is false, set first package as active
                            if (this.order.SmallParcelDisableClickToPack && this.state.requiredScanActive && !this.order.OrderScanned) {
                                this._setCurrentPackage(this.order.PackageData[0].PackageId);
                            } else {
                                this._setCurrentPackage(this.order.PackageData[this.order.PackageData.length - 1].PackageId);
                            }
                            // Which order we have open with have one or more item into package.
                            this.isAnyItemPacked = true;
                        }
                        this._clearCurrentPackage();
                        // Enable pack button after package item change when order is already packed
                        this.isDisabledPack = false;
                        this.listGrid_dataBind();
                        this.isSmallParcelGridRefresh = true;
                    })
                    .finally(() => {
                        kendo.ui.progress($("#packAndShipTransactionGrid"), false);
                    });
            })
            .finally(() => {
                this.setState({
                    deleteAllLoading: false,
                    isOpenConfirmDeleteAllPopup: false,
                    selectUnpack: false,
                    isPackSelectedBtnEnabled: false,
                });
            });
    };
    _clearCurrentPackage = () => {
        this.currentPackage = {
            PackageId: 0,
            PackageDefId: 0,
            Name: "",
        };
    };
    listGrid_dataBind = () => {
        var items = [];
        if (!this.order.PackageData) {
            return;
        }
        var labelCount = {};
        var tmpPkgArr = _.cloneDeep(this.previousSelectedPackageArr);
        if (tmpPkgArr.length == 0) {
            labelCount = this.getLabelCounts(this.order.PackageData, this.currentPackage);
        } else if (tmpPkgArr.length) {
            labelCount = this.getLabelCounts(this.order.PackageData, tmpPkgArr);
        }

        window.packageArr = [];
        var index = 0;
        var disableDeleteAll = true;
        var tmpIsAnyItemUnpacked = false;
        var self = this;
        var weightLabel = this.state.currentMeasurementStandardIsImperial ? "lbs" : "kg";

        let tmpGridSortOptions = null;
        if (this.order.PackageData.length > 0) {
            tmpGridSortOptions = false;
            disableDeleteAll = false;
        } else {
            tmpGridSortOptions = {
                mode: "mixed",
                allowUnsort: true,
                showIndexes: true,
            };
            disableDeleteAll = true;
        }

        _.map(self.order.OrderItemData, function (value) {
            if (value && value.Allocations) {
                _.map(value.Allocations, function (subValue) {
                    subValue.Remainder = subValue.Qty;
                    subValue.PickRemainder = subValue.Qty;
                    return subValue;
                });
            }
            return self.order;
        });
        _.each(self.order.PackageData, (pacakgeValue) => {
            labelCount[pacakgeValue.Name].i++;
            var packageName =
                labelCount[pacakgeValue.Name].total > 1
                    ? pacakgeValue.Name + " (" + labelCount[pacakgeValue.Name].i + ")"
                    : pacakgeValue.Name;
            if (window.packageArr.indexOf(packageName) == -1) {
                window.packageArr.push(packageName);
            }

            _.each(pacakgeValue.PackageContents, (contentValue) => {
                var item = self.order.OrderItemData.find(function (a) {
                    return a.OrderItemId == contentValue.OrderItemId;
                });
                var alloc = item && item.Allocations ? item.Allocations.find(function (b) {
                    return b.ReceiveItemId == contentValue.ReceiveItemId && b.Remainder >= contentValue.PackedQty;
                }) : null;

                if (!alloc) {
                    if (this.state.scannedPkgUris.length == 0) {
                        GlobalService.notification("error: ", "data mismatch please consolidate packages first and come back");
                    }
                    return;
                }
                alloc.Remainder -= contentValue.PackedQty;

                if (contentValue.PickedQty) {
                    alloc.PickRemainder -= contentValue.PickedQty;
                }

                var scannedQty = contentValue.scannedQty || 0;
                var packedQty = contentValue.PackedQty || 0;
                var isFullyScanned = contentValue.orderItemScanned === true || scannedQty >= packedQty;
                var isPartiallyScanned = this.state.requiredScanActive && scannedQty > 0 && scannedQty < packedQty;

                // Common item properties
                var commonItemProps = {
                    PackageId: pacakgeValue.PackageId,
                    PackageName: packageName,
                    val: window.packageArr.indexOf(packageName),
                    PackageDefId: pacakgeValue.PackageDefId,
                    PackageUri: pacakgeValue.PackageUri,
                    PackageContentId: contentValue.PackageContentId,
                    Description: item.Description,
                    oiid: contentValue.OrderItemId,
                    riid: contentValue.ReceiveItemId,
                    SerialNumbers: contentValue.SerialNumbers,
                    PackageContentUri: contentValue.PackageContentUri,
                    Lot: contentValue.Lot,
                    Serial: contentValue.Serial,
                    OutBoundSerial:
                        contentValue.SerialNumbers && contentValue.SerialNumbers.length
                            ? contentValue.SerialNumbers.join(",")
                            : "",
                    ExpirationDate: contentValue.ExpirationDate,
                    Sku: item.Sku,
                    PrimaryUOM: item.PrimaryUOM,
                    IsSerialize: item.IsSerialize,
                    Upc: item.Upc,
                    Qty: alloc.Qty,
                    Qualifier: alloc.Qualifier,
                    Location: alloc.Location,
                    MovableUnit: alloc.MovableUnit,
                    PickedQty: alloc.PickedQty,
                    PickUri: alloc.PickUri,
                    MispickUri: alloc.MispickUri,
                    UnpickUri: alloc.UnpickUri,
                    Remainder: 0,
                    PickRemainder: 0,
                    Dimensions:
                        (pacakgeValue.Length ? pacakgeValue.Length + "x" : "0x") +
                        (pacakgeValue.Width ? pacakgeValue.Width + "x" : "0x") +
                        (pacakgeValue.Height ? pacakgeValue.Height : "0x"),
                    Weight:
                        this.state.isDeviceConnect &&
                        pacakgeValue.PackageId == this.currentPackage.PackageId &&
                        this.isSetActivePackage
                            ? "--"
                            : (pacakgeValue.Weight ? pacakgeValue.Weight + "" : "0") + weightLabel,
                    Ucc128: pacakgeValue.Ucc128 ? pacakgeValue.Ucc128 : "",
                    CheckIcon: pacakgeValue.PackageId,
                    ScannedIcon: pacakgeValue.PackageId,
                    isPrintIconShaw: this.isPrintIconShaw,
                    isShowAttributes: true,
                    isPrintIconDisable: (this.isBlankPrintLabel(this.state.cartonLabel) && this.isBlankPrintLabel(this.state.transactionLabel)) || pacakgeValue.PackageId == 0,
                    isOrderAlreadyShipped: this.order.SmallParcelShipDate ? true : false,
                    IsInsert: item.IsInsert,
                    IsHazMat: item.IsHazMat,
                };

                if (isPartiallyScanned) {
                    // Split into two rows: scanned portion and unscanned portion
                    var unscannedQty = packedQty - scannedQty;

                    // Row 1: Scanned portion (green icon)
                    index++;
                    items.push(Object.assign({}, commonItemProps, {
                        DisplayQty: scannedQty,
                        RowNumber: index,
                        PackedQty: scannedQty,
                        orderItemScanned: true,
                        scannedQty: scannedQty,
                        isScannedRow: true,
                    }));

                    // Row 2: Unscanned portion (grey icon)
                    index++;
                    items.push(Object.assign({}, commonItemProps, {
                        DisplayQty: unscannedQty,
                        RowNumber: index,
                        PackedQty: unscannedQty,
                        orderItemScanned: false,
                        scannedQty: 0,
                        isUnscannedRow: true,
                    }));
                } else {
                    // Single row (either fully scanned or not scanned at all)
                    index++;
                    items.push(Object.assign({}, commonItemProps, {
                        DisplayQty: packedQty,
                        RowNumber: index,
                        PackedQty: packedQty,
                        orderItemScanned: this.state.requiredScanActive ? (isFullyScanned ? true : this.order.OrderScanned) : true,
                        scannedQty: scannedQty,
                    }));
                }
            });
        });

        _.each(tmpPkgArr, (packageItem, i) => {
            var packageName = "";

            labelCount[packageItem.Name].i++;
            if (packageItem.Name && labelCount[packageItem.Name] && labelCount[packageItem.Name].total > 1) {
                packageName = packageItem.Name + " (" + labelCount[packageItem.Name].i + ")";
            } else {
                packageName = packageItem.Name;
            }

            if (window.packageArr.indexOf(packageName) == -1) {
                window.packageArr.push(packageName);
            }
            index++;
            var tmpDimensions = this.state.currentMeasurementStandardIsImperial
                ? (packageItem.LengthImperial ? packageItem.LengthImperial + "x" : "0x") +
                  (packageItem.WidthImperial ? packageItem.WidthImperial + "x" : "0x") +
                  (packageItem.HeightImperial ? packageItem.HeightImperial : "0x")
                : (packageItem.LengthMetric ? packageItem.LengthMetric + "x" : "0x") +
                  (packageItem.WidthMetric ? packageItem.WidthMetric + "x" : "0x") +
                  (packageItem.HeightMetric ? packageItem.HeightMetric : "0x");
            items.push({
                DisplayQty: 0,
                RowNumber: index,
                PackageId: 0,
                PackageName: packageName,
                val: window.packageArr.indexOf(packageName),
                ExpirationDate: null,
                isShawZeroPackageId: true,
                Dimensions: tmpDimensions,
                Weight:
                    this.state.isDeviceConnect && this.isSetActivePackage
                        ? "--"
                        : (this.state.currentMeasurementStandardIsImperial
                              ? packageItem.WeightImperial
                                  ? packageItem.WeightImperial + ""
                                  : "0"
                              : packageItem.WeightMetric
                              ? packageItem.WeightMetric + ""
                              : "0") + weightLabel,
                CheckIcon: 0,
                Ucc128: packageItem.Ucc128 ? packageItem.Ucc128 : "0",
                ScannedIcon: 0,
                isHideRow: true,
                isPrintIconShaw: true,
                isDeleteIconShawForUnAssingPkg: true,
                uniquePackageName: packageItem.uniquePackageName,
                isPrintIconDisable: false,
                isShowAttributes: true,
                isOrderAlreadyShipped: this.order.SmallParcelShipDate ? true : false,
            });
        });

        // Count unpacked items
        var unpackedItemsCount = 0;
        _.each(self.order.OrderItemData, (itemValue) => {
            if (itemValue && itemValue.Allocations) {
                _.each(itemValue.Allocations, (allocationValue) => {
                    if (allocationValue.Remainder > 0) {
                        unpackedItemsCount++;
                    }
                });
            }
        });
        if (self.order.Inserts) {
            _.each(self.order.Inserts, (insertValue) => {
                if (!insertValue.InsertedQuantity || insertValue.InsertedQuantity <= 0) {
                    unpackedItemsCount++;
                }
            });
        }
        if (unpackedItemsCount > 0) {
            var packageName = "-- Unpacked items (" + unpackedItemsCount + " items) --";

            if (window.packageArr.indexOf(packageName) == -1) {
                window.packageArr.push(packageName);
            }
            index++;
            items.push({
                CheckIcon: 0,
                DisplayQty: 0,
                RowNumber: index,
                PackageId: 0,
                PackageName: packageName,
                val: window.packageArr.indexOf(packageName),
                ExpirationDate: null,
                ScannedIcon: 0,
                isShowOtherAttributes: false,
                Ucc128: "0",
                isHideRow: true,
                isShowAttributes: false,
                isPrintIconShaw: true,
                isDeleteIconShawForUnAssingPkg: true,
                uniquePackageName: "",
                isPrintIconDisable: false,
                isOrderAlreadyShipped: false,
            });
        }

        _.each(self.order.OrderItemData, (itemValue) => {
            if (itemValue && itemValue.Allocations) {
                _.each(itemValue.Allocations, (allocationValue) => {
                    var packageName = "";
                    if (window.packageArr.indexOf(packageName) == -1) {
                        window.packageArr.push(packageName);
                    }

                    if (allocationValue.Remainder > 0) {
                    index++;
                    var tmpDimensions = this.state.currentMeasurementStandardIsImperial
                        ? (this.currentPackage.LengthImperial ? this.currentPackage.LengthImperial + "x" : "0x") +
                          (this.currentPackage.WidthImperial ? this.currentPackage.WidthImperial + "x" : "0x") +
                          (this.currentPackage.HeightImperial ? this.currentPackage.HeightImperial : "0x")
                        : (this.currentPackage.LengthMetric ? this.currentPackage.LengthMetric + "x" : "0x") +
                          (this.currentPackage.WidthMetric ? this.currentPackage.WidthMetric + "x" : "0x") +
                          (this.currentPackage.HeightMetric ? this.currentPackage.HeightMetric : "0x");
                    var secondaryUpc = "";
                    var secondaryUpcPerUnitsRatio = 0;
                    var packageUpc = "";
                    var packageUpcPerUnitsRatio = 0;

                    // var isIntegral = GlobalService.getIsIntegeralFlagByType(itemValue.PrimaryUOM);
                    if (itemValue.SecondaryUnit) {
                        secondaryUpc = itemValue.SecondaryUnit.Upc;
                        // secondaryUpcPerUnitsRatio = isIntegral ? Math.ceil(itemValue.SecondaryUnit.InventoryUnitsPerUnit) : itemValue.SecondaryUnit.InventoryUnitsPerUnit;
                        secondaryUpcPerUnitsRatio = itemValue.SecondaryUnit.InventoryUnitsPerUnit;
                    }
                    if (itemValue.PackageUnit) {
                        packageUpc = itemValue.PackageUnit.Upc;
                        // packageUpcPerUnitsRatio = isIntegral ? Math.ceil(itemValue.PackageUnit.InventoryUnitsPerUnit) : itemValue.PackageUnit.InventoryUnitsPerUnit;
                        packageUpcPerUnitsRatio = itemValue.PackageUnit.InventoryUnitsPerUnit;
                    }

                    items.push({
                        DisplayQty: allocationValue.Remainder,
                        RowNumber: index,
                        PackageId: 0,
                        PackageName: packageName,
                        val: window.packageArr.indexOf(packageName),
                        PackageDefId: 0,
                        PackageUri: "",
                        Description: itemValue.Description,
                        PackageContentId: 0,
                        PackedQty: 0,

                        oiid: itemValue.OrderItemId,
                        Sku: itemValue.Sku,
                        PrimaryUOM: itemValue.PrimaryUOM,
                        IsSerialize: itemValue.IsSerialize,
                        Upc: itemValue.Upc,
                        secondaryUpc: secondaryUpc,
                        secondaryUpcPerUnitsRatio: secondaryUpcPerUnitsRatio,
                        packageUpc: packageUpc,
                        packageUpcPerUnitsRatio: packageUpcPerUnitsRatio,
                        PickTrackExpirationDate: itemValue.PickTrackExpirationDate,
                        PickTrackSerialNumber: itemValue.PickTrackSerialNumber,
                        OutboundMobileSerialization: itemValue.OutboundMobileSerialization,
                        TrackSerialNumber: itemValue.TrackSerialNumber,
                        isSerialUnique:
                            itemValue.TrackSerialNumber == 2 || itemValue.TrackSerialNumber == 4 ? true : false,

                        riid: allocationValue.ReceiveItemId,
                        Qty: allocationValue.Qty,
                        Qualifier: allocationValue.Qualifier,
                        ExpirationDate: allocationValue.ExpirationDate,
                        Lot: allocationValue.Lot,
                        Serial: allocationValue.Serial,
                        OutBoundSerial: "",
                        Location: allocationValue.Location,
                        MovableUnit: allocationValue.MovableUnit,
                        PickedQty: allocationValue.PickedQty,
                        PickUri: allocationValue.PickUri,
                        MispickUri: allocationValue.MispickUri,
                        UnpickUri: allocationValue.UnpickUri,
                        Remainder: allocationValue.Remainder,
                        PickRemainder: allocationValue.PickRemainder,
                        isShawZeroPackageId: false,
                        Dimensions: tmpDimensions,
                        Weight:
                            this.state.isDeviceConnect && this.isSetActivePackage
                                ? "--"
                                : (this.state.currentMeasurementStandardIsImperial
                                      ? this.currentPackage.WeightImperial
                                          ? this.currentPackage.WeightImperial + ""
                                          : "0"
                                      : this.currentPackage.WeightMetric
                                      ? this.currentPackage.WeightMetric + ""
                                      : "0") + weightLabel,
                        Ucc128: this.currentPackage.Ucc128 ? this.currentPackage.Ucc128 : "0",
                        CheckIcon: 0,
                        ScannedIcon: 0,
                        isPrintIconShaw: this.isPrintIconShaw,
                        isPrintIconDisable: true,

                        isShowAttributes: true,
                        isOrderAlreadyShipped: this.order.SmallParcelShipDate ? true : false,
                        IsInsert: itemValue.IsInsert,
                        IsHazMat: itemValue.IsHazMat,
                        orderItemScanned: false, // Unpacked items are not scanned yet
                    });
                    if (!itemValue.IsInsert) {
                        tmpIsAnyItemUnpacked = true;
                    }
                }
                });
            }
        });

        // Check Order Has Inserts
        if (self.order.Inserts) {
            _.each(self.order.Inserts, (itemValue) => {
                if (itemValue.PackageInsertIdentifier) {
                    index++;
                    items.push({
                        DisplayQty: itemValue.InsertedQuantity ? itemValue.InsertedQuantity : 0,
                        Barcode: itemValue.Barcode,
                        RowNumber: index,
                        PackageId: 0,
                        val: index,
                        Description: itemValue.PackageInsertIdentifier.Name,
                        InsertId: itemValue.PackageInsertIdentifier.Id,
                        InsertedQty: itemValue.InsertedQuantity ? itemValue.InsertedQuantity : 0,
                        PackageContentId: 0,
                        PackedQty: 0,
                        Sku: "INSERTS",
                        ExpirationDate: null,
                        CheckIcon: itemValue.InsertedQuantity ? itemValue.InsertedQuantity : 0,
                        ScannedIcon: itemValue.InsertedQuantity ? itemValue.InsertedQuantity : 0,
                        orderItemScanned: this.state.requiredScanActive ? itemValue.orderItemScanned : false,
                    });
                }
            });
        }

        this.setFocusOnPackOrAddPackage();
        this.previousSelectedPackageArr = tmpPkgArr;
        let isDisablePackObject = this.setEnableDisableForPack(tmpIsAnyItemUnpacked, items);
        // console.log("setEnableDisableForPack : items : ", items);
        this.setState({
            smallPackGridData: items,
            disableDeleteAll: disableDeleteAll,
            gridSortOptions: tmpGridSortOptions,
            isAnyItemUnpacked: tmpIsAnyItemUnpacked,
            isPackOrPackAndShipDisabled: isDisablePackObject.isPackOrPackAndShipDisabled,
            packOrPackShipTooltip: isDisablePackObject.packOrPackShipTooltip,
            isShipInFlight: isDisablePackObject.isShipInFlight,
        });
        this.isSetActivePackage = true;
    };

    getOrderNotLoadedMessage = () =>
        this.translate(this.state.isOrderLoadFailed ? "Label_Order_Failed_To_Load_Refresh" : "Label_Order_Still_Loading_Try_Again");

    setEnableDisableForPack = (isAnyItemUnpacked, items) => {
        let isPackOrPackAndShipDisabled = false;
        let packOrPackShipTooltip = "";
        const isShipInFlight = shipInFlightGuard.areOrdersInFlight(this.props.sharedSelectedOrderIds);
        const shipInFlightTooltip = this.translate("Label_Ship_In_Flight_Tooltip");
        if (!this.state.packAndShipOrderInfo || !this.state.packAndShipOrderInfo.OrderId) {
            isPackOrPackAndShipDisabled = true;
            packOrPackShipTooltip = this.getOrderNotLoadedMessage();
        } else if (this.order.SmallParcelShipDate) {
            isPackOrPackAndShipDisabled = true;
            packOrPackShipTooltip = this.translate("Label_Already_Shipped_Tooltip");
        } else if (isShipInFlight) {
            isPackOrPackAndShipDisabled = true;
            packOrPackShipTooltip = shipInFlightTooltip;
        } else if (isAnyItemUnpacked) {
            isPackOrPackAndShipDisabled = true;
            packOrPackShipTooltip = this.translate("Label_Fully_Packed_Disable_Note");
        } else if (this.isDisabledPack) {
            isPackOrPackAndShipDisabled = true;
            packOrPackShipTooltip = this.translate("Label_Already_Packed");
        } else if (this.isPrintIconShaw == true && !this.hasSelectedPrintLabel()) {
            isPackOrPackAndShipDisabled = true;
            packOrPackShipTooltip = this.translate("Label_Carton_Or_Transaction_Require_Tooltip");
        } else if (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && !this.areAllItemsScanned(items)) {
            // When requiredScanActive is true, disable pack/ship buttons until all items are scanned
            isPackOrPackAndShipDisabled = true;
            packOrPackShipTooltip = "Please scan all items before packing or shipping";
        }
        return {
            isPackOrPackAndShipDisabled: isPackOrPackAndShipDisabled,
            packOrPackShipTooltip: packOrPackShipTooltip,
            isShipInFlight: isShipInFlight,
        };
    };

    syncShipInFlightButtonState = () => {
        if (!this._isMounted) {
            return;
        }
        const inFlight = shipInFlightGuard.areOrdersInFlight(this.props.sharedSelectedOrderIds);
        const shipInFlightTooltip = this.translate("Label_Ship_In_Flight_Tooltip");

        if (this.state.smallPackGridData && this.state.smallPackGridData.length > 0) {
            const disableState = this.setEnableDisableForPack(this.state.isAnyItemUnpacked, this.state.smallPackGridData);
            this.setState({
                isShipInFlight: inFlight,
                isPackOrPackAndShipDisabled: disableState.isPackOrPackAndShipDisabled,
                packOrPackShipTooltip: disableState.packOrPackShipTooltip,
            });
            return;
        }

        if (inFlight) {
            this.setState({
                isShipInFlight: true,
                isPackOrPackAndShipDisabled: true,
                packOrPackShipTooltip: shipInFlightTooltip,
            });
            return;
        }

        if (this.state.isShipInFlight) {
            if (this.order) {
                const disableState = this.setEnableDisableForPack(this.state.isAnyItemUnpacked, []);
                this.setState({
                    isShipInFlight: false,
                    isPackOrPackAndShipDisabled: disableState.isPackOrPackAndShipDisabled,
                    packOrPackShipTooltip: disableState.packOrPackShipTooltip,
                });
            } else {
                this.setState({
                    isShipInFlight: false,
                    isPackOrPackAndShipDisabled: true,
                    packOrPackShipTooltip: this.getOrderNotLoadedMessage(),
                });
            }
            return;
        }

        this.setState({ isShipInFlight: false });
    };

    areAllItemsScanned = (items) => {
        // Check if all items in grid are scanned (orderItemScanned === true)
        if (!items || items.length === 0) {
            return false;
        }
        return _.every(items, (item) => {
            // Skip items that are not in a package (unpacked items row headers, etc.)
            if (item.PackageId === 0 || item.isShawZeroPackageId || item.isHideRow) {
                return true;
            }
            return item.orderItemScanned === true;
        });
    };

    getLabelCounts = (list, cur) => {
        var result = list.reduce((obj, p) => {
            if (p.PackageDefId == 0 && p.PackageUri) {
                p.Name = this.translate("Label_Custom_Dimensions");
            }
            if (!obj.hasOwnProperty(p.Name)) {
                obj[p.Name] = { i: 0, total: 1 };
            } else {
                obj[p.Name].total++;
            }
            return obj;
        }, {});

        //seed empty package
        if (Array.isArray(cur)) {
            for (let i = 0; i < cur.length; i++) {
                const element = cur[i];
                if (!result.hasOwnProperty(element.Name)) {
                    result[element.Name] = { i: 0, total: 1 };
                } else {
                    result[element.Name].total++;
                }
            }
        } else if (cur.Name && cur.PackageId == 0) {
            if (!result.hasOwnProperty(cur.Name)) {
                result[cur.Name] = { i: 0, total: 1 };
            } else {
                result[cur.Name].total++;
            }
        }
        return result;
    };
    getResolvedPackingSlipFormat = () => {
        const obj = this.state.packAdnShipObj || {};
        const info = this.state.packAndShipOrderInfo || {};
        const raw = obj.SmallParcelPapiPackSlipFormat
            || info.smallParcelPapiPackSlipFormat
            || info.SmallParcelPapiPackSlipFormat
            || "";
        return papiDocumentUtil.resolvePapiDocumentFormat(
            { SmallParcelPapiPackSlipFormat: raw },
            "packingSlip"
        );
    };

    getPackingSlipPackaging = () => {
        const info = this.state.packAndShipOrderInfo || {};
        const obj = this.state.packAdnShipObj || {};
        const ownOr = (objKey, infoValue) => {
            if (Object.prototype.hasOwnProperty.call(obj, objKey)) {
                return obj[objKey];
            }
            return infoValue;
        };
        return {
            SmallParcelPapiPackSlipTemplateId: ownOr(
                "SmallParcelPapiPackSlipTemplateId",
                info.smallParcelPapiPackSlipTemplateId
            ) || "",
            SmallParcelPapiPackSlipTemplateVersion: ownOr(
                "SmallParcelPapiPackSlipTemplateVersion",
                info.smallParcelPapiPackSlipTemplateVersion != null
                    ? info.smallParcelPapiPackSlipTemplateVersion
                    : info.SmallParcelPapiPackSlipTemplateVersion
            ) ?? null,
            SmallParcelPackSlip: ownOr("SmallParcelPackSlip", info.smallParcelPackSlip) || "",
            SmallParcelAddressTemplate: ownOr("SmallParcelAddressTemplate", info.smallParcelAddressTemplate) || "",
        };
    };

    hasCustomerPackingSlipConfigured = () => {
        const packaging = this.getPackingSlipPackaging();
        const templateId = packaging && (
            packaging.SmallParcelPapiPackSlipTemplateId
            || packaging.smallParcelPapiPackSlipTemplateId
        );
        return papiDocumentUtil.isPapiPackingSlipsOptedIn(templateId);
    };

    usesNewPackingSlipUiForOrder = () => {
        return papiDocumentUtil.usesNewPackingSlipUi(this.state.rights, this.state.packAndShipOrderInfo);
    };

    captureUcc128CustomerSettings = (customers) => {
        const list = Array.isArray(customers) ? customers : (customers ? [customers] : []);
        const packagingList = list.map((customer) => {
            if (!customer) {
                return null;
            }
            const options = customer.Options || customer.options;
            if (options && (options.Packaging || options.packaging)) {
                return options.Packaging || options.packaging;
            }
            return customer;
        });
        const enabled = papiDocumentUtil.isPapiDocEnabled(this.state.rights, "ucc128")
            && list.length > 0
            && list.every((customer, index) =>
            papiDocumentUtil.readSmallParcelUseNewUcc128Features(customer)
            || papiDocumentUtil.readSmallParcelUseNewUcc128Features(packagingList[index])
        );
        const savedValue = enabled
            ? papiDocumentUtil.resolveSharedPapiDocumentValue(packagingList, "ucc128")
            : null;
        const parsed = papiDocumentUtil.parseDocOptionValue(savedValue);
        const sharedFormat = papiDocumentUtil.resolveSharedPackagingValue(
            packagingList,
            "SmallParcelPapiUcc128Format"
        );
        const savedVersion = list.length === 1
            ? papiDocumentUtil.readCustomerPapiTemplateSetting(packagingList[0], "ucc128").templateVersion
            : null;
        this.ucc128PackAndShipSettings = {
            enabled: enabled,
            templateId: parsed.rawId,
            templateVersion: savedVersion,
            format: sharedFormat === "pdf" || sharedFormat === "zpl" ? sharedFormat : "zpl",
        };
        this._cartonDefaultPackaging = packagingList.length === 1 ? packagingList[0] : null;
        if (this._isMounted) {
            this.setState({ ucc128Format: this.ucc128PackAndShipSettings.format });
        }
    };

    ucc128FormatOptionsForTemplate = (templateId, rawTemplates) => {
        if (papiDocumentUtil.isBlankLabelId(templateId)) {
            return papiDocumentUtil.getFormatOptions(true);
        }
        return papiDocumentUtil.getFormatOptionsForTemplate(
            papiDocumentUtil.makeDocOptionValue(papiDocumentUtil.DOC_ENGINE_PAPI, templateId),
            rawTemplates || [],
            papiDocumentUtil.PAPI_DOC_TYPES.ucc128
        );
    };

    resolveUcc128Format = (templateId, format, rawTemplates) => {
        const options = this.ucc128FormatOptionsForTemplate(templateId, rawTemplates);
        const normalized = String(format || "").trim().toLowerCase();
        if (options.some((opt) => opt.Value === normalized)) {
            return normalized;
        }
        return options.length ? options[0].Value : "zpl";
    };

    usesNewUcc128ForPackAndShip = () => {
        return !!(this.ucc128PackAndShipSettings && this.ucc128PackAndShipSettings.enabled);
    };

    isUcc128FormatDropdownDisabled = () => {
        return this.state.cartonLabelOptionsLoading
            || papiDocumentUtil.isBlankLabelId(this.state.cartonLabel);
    };

    orderInfoWantsNewUcc128 = () => {
        const info = this.state.packAndShipOrderInfo || {};
        return !!(info.smallParcelUseNewUcc128Features);
    };

    publishCartonOptionsAfterSettingsFailure = () => {
        if (this.orderInfoWantsNewUcc128()) {
            if (!this._isMounted) {
                return;
            }
            this.setState({
                cartonLabelOptions: [{
                    LabelTemplateId: 0,
                    Name: this.translate("Label_Not_Specified"),
                    version: null,
                }],
                cartonLabelOptionsLoading: false,
                cartonLabel: 0,
            }, () => {
                this.listGrid_dataBind();
            });
            return;
        }
        this.publishLegacyCartonLabelOptions();
    };

    shipCarriesPapiUcc128 = () => {
        const pack = this.state.packAdnShipObj || {};
        return !!(
            this.isPrintIconShaw
            && this.usesNewUcc128ForPackAndShip()
            && !this.isBlankPrintLabel(this.state.cartonLabel)
            && pack.processAs === "Standard"
            && (pack.labelFormat === "Pdf" || pack.labelFormat === "Zpl")
        );
    };

    getPapiUcc128ShipParams = () => {
        if (!this.shipCarriesPapiUcc128()) {
            return { papiUcc128TemplateId: null, papiUcc128TemplateVersion: null, papiUcc128Format: null };
        }
        const settings = this.ucc128PackAndShipSettings || {};
        const templateId = this.state.cartonLabel;
        const option = (this.state.cartonLabelOptions || []).find((opt) =>
            papiDocumentUtil.sameLabelId(opt.LabelTemplateId, templateId)
        );
        return {
            papiUcc128TemplateId: templateId,
            papiUcc128TemplateVersion: option && option.version != null ? option.version : settings.templateVersion,
            papiUcc128Format: this.state.ucc128Format || settings.format || "zpl",
        };
    };

    loadCarrierAccountDocumentTemplates = () => {
        if (!this._carrierAccountTemplatesPromise) {
            this._carrierAccountTemplatesPromise = smallParcelSettingsServices.getCarrierAccountSchema()
                .then((response) => {
                    if (!response || response.status != 200) {
                        return null;
                    }
                    return papiDocumentUtil.parseDocumentTemplatesFromSchemaResponse(response.data);
                })
                .catch((err) => {
                    console.error("PAPI schema load failed", err);
                    return null;
                });
        }
        return this._carrierAccountTemplatesPromise;
    };

    legacyCartonSelection = (options) => {
        const orderInfo = this.state.packAndShipOrderInfo || {};
        const savedCartonName = papiDocumentUtil.readSavedDefaultCartonLabelName(
            orderInfo,
            this._cartonDefaultPackaging
        );
        return papiDocumentUtil.resolveLegacyCartonLabelTemplateId(options, savedCartonName);
    };

    publishLegacyCartonLabelOptions = () => {
        if (!this._isMounted || this.usesNewUcc128ForPackAndShip()) {
            return;
        }
        const options = this._legacyCartonLabelOptions || [];
        this.setState({
            cartonLabelOptions: options,
            cartonLabelOptionsLoading: false,
            cartonLabel: papiDocumentUtil.reconcileLabelSelection(
                options,
                this.legacyCartonSelection(options)
            ),
        }, () => {
            this.listGrid_dataBind();
        });
    };

    loadUcc128TemplateOptions = () => {
        if (!this.usesNewUcc128ForPackAndShip()) {
            this.publishLegacyCartonLabelOptions();
            return;
        }
        const requestId = (this._ucc128OptionsRequestId || 0) + 1;
        this._ucc128OptionsRequestId = requestId;
        const settings = this.ucc128PackAndShipSettings;
        this.loadCarrierAccountDocumentTemplates().then((documentTemplates) => {
            if (!this._isMounted || this._ucc128OptionsRequestId !== requestId) {
                return;
            }
            if (!this.usesNewUcc128ForPackAndShip()) {
                return;
            }
            const filtered = papiDocumentUtil.filterPapiDocumentTemplates(
                documentTemplates || [],
                papiDocumentUtil.PAPI_UCC128_DOC_TYPE,
                false,
                this.props.sharedSelectedCustomerIds
            );
            const options = [{
                LabelTemplateId: 0,
                Name: this.translate("Label_Not_Specified"),
                version: null,
            }];
            filtered.forEach((template) => {
                options.push({
                    Name: template.name,
                    LabelTemplateId: template.id,
                    version: template.version,
                });
            });
            const match = options.find((opt) =>
                opt.LabelTemplateId && papiDocumentUtil.sameLabelId(opt.LabelTemplateId, settings.templateId)
            );
            const cartonLabel = papiDocumentUtil.reconcileLabelSelection(
                options,
                match ? match.LabelTemplateId : 0
            );
            this.setState({
                cartonLabelOptions: options,
                cartonLabelOptionsLoading: false,
                cartonLabel: cartonLabel,
                ucc128TemplatesRaw: filtered,
                ucc128Format: this.resolveUcc128Format(cartonLabel, settings.format, filtered),
            }, () => {
                this.listGrid_dataBind();
            });
        }).catch(() => {
            if (!this._isMounted || this._ucc128OptionsRequestId !== requestId) {
                return;
            }
            if (!this.usesNewUcc128ForPackAndShip()) {
                this.publishLegacyCartonLabelOptions();
                return;
            }
            this.setState({
                cartonLabelOptions: [{
                    LabelTemplateId: 0,
                    Name: this.translate("Label_Not_Specified"),
                    version: null,
                }],
                cartonLabelOptionsLoading: false,
                cartonLabel: 0,
            }, () => {
                this.listGrid_dataBind();
            });
        });
    };

    printPapiUcc128FromPackAndShip = (ucc128List) => {
        const settings = this.ucc128PackAndShipSettings || {};
        const templateId = this.state.cartonLabel;
        const option = (this.state.cartonLabelOptions || []).find((opt) =>
            papiDocumentUtil.sameLabelId(opt.LabelTemplateId, templateId)
        );
        const orderInfo = this.state.packAndShipOrderInfo || {};
        const outputFormat = this.state.ucc128Format || settings.format || "zpl";
        const payload = {
            TransactionIds: this.props.sharedSelectedOrderIds,
            CustomerId: orderInfo.customerId != null ? orderInfo.customerId : null,
            PapiTemplateId: templateId,
            PapiTemplateVersion: option && option.version != null ? option.version : settings.templateVersion,
            OutputFormat: outputFormat,
            Ucc128List: ucc128List || [],
        };
        return findOrdersService.PapiUcc128PackageLabelGenerator(payload).then((response) => {
            if (!(response && response.status === 200 && response.data)) {
                throw new Error("UCC-128 package label generation returned no data");
            }
            const printOptions = { suppressSuccessNotification: true };
            if (outputFormat === "zpl") {
                return GlobalService.printDataInZplPrinter(
                    papiDocumentUtil.decodeZplResponseData(response.data),
                    false,
                    printOptions
                );
            }
            // UCC-128 PDF opens in a new page. Silent PDF print stays off for this call.
            return GlobalService.printOrViewPackingSlipPdf(
                response.data,
                Object.assign({}, printOptions, { viewOnly: true })
            );
        }).then((didPrint) => didPrint === true).catch(() => {
            this.notifyUcc128LabelsFailed();
            return false;
        });
    };

    notifyUcc128LabelsFailed = () => {
        GlobalService.notificationNewDesign(
            "error",
            this.translate("Label_Ucc128_Package_Labels_Generate_Failed"),
            this.translate("Label_Ucc128_Package_Labels_Try_Again")
        );
    };

    getPackingSlipSelectionEngine = () => {
        if (this.usesNewPackingSlipUiForOrder()) {
            const templateId = this.state.packAdnShipObj
                && this.state.packAdnShipObj.SmallParcelPapiPackSlipTemplateId;
            return templateId && String(templateId).trim() ? papiDocumentUtil.DOC_ENGINE_PAPI : null;
        }
        const runner = this.state.packAdnShipObj && this.state.packAdnShipObj.SmallParcelPackSlip;
        return runner && String(runner).trim() ? papiDocumentUtil.DOC_ENGINE_LEGACY : null;
    };

    applySsrsPackingSlipResponse = (responseData) => {
        let tempOptionsTemplateReports = responseData[0].Templates ? responseData[0].Templates.slice() : [];
        tempOptionsTemplateReports.unshift({ Name: "", Id: null });
        let tempOptionsPackingReports = [{ Name: "", TemplatedRunner: null }];
        for (let x = 0; x < responseData.length; x++) {
            if (responseData[x].Reports && responseData[x].Reports.length) {
                for (let y = 0; y < responseData[x].Reports.length; y++) {
                    tempOptionsPackingReports.push(responseData[x].Reports[y]);
                }
            }
        }
        return { tempOptionsTemplateReports, tempOptionsPackingReports };
    };

    mergePackingSlipTypeOptions = (papiTemplates) => {
        const mixed = this.isPapiPackAndShipMixedCustomers();
        const packaging = this.getPackingSlipPackaging();
        if (!this.usesNewPackingSlipUiForOrder()) {
            return;
        }
        if (!mixed && !this.hasCustomerPackingSlipConfigured()) {
            this.setState({
                optionsPackingReports: [],
                isIntegratedPackingSlips: false,
            });
            return;
        }
        // The Type list is filtered by the format already selected. A blank
        // format on open still uses the shared saved format for mixed customers.
        const formFormat = String(
            (this.state.packAdnShipObj && this.state.packAdnShipObj.SmallParcelPapiPackSlipFormat) || ""
        ).trim().toLowerCase();
        const sharedFormat = mixed ? (this.mixedPackingSlipSavedFormat || "") : "";
        const format = (formFormat === "pdf" || formFormat === "zpl")
            ? formFormat
            : (mixed
                ? (sharedFormat === "pdf" || sharedFormat === "zpl" ? sharedFormat : "pdf")
                : this.getResolvedPackingSlipFormat());
        const options = papiDocumentUtil.buildDocumentTypeOptions({
            docTypeKey: "packingSlip",
            papiTemplates: papiTemplates,
            format: format,
            wmsCustomerIds: this.getPapiPackingSlipFilterCustomerIds(),
            includeDraft: false,
            includeEmptyRow: true,
            includeFormatSuffix: true,
            formatSuffixLabels: papiDocumentUtil.formatSuffixLabelsFromTranslate(this.translate),
        });
        const savedValue = mixed
            ? (this.mixedPackingSlipSavedValue || null)
            : papiDocumentUtil.resolveSavedDocumentValue(packaging, "packingSlip");
        const currentValue = this.state.packAdnShipObj
            && this.state.packAdnShipObj.SmallParcelDocumentTypeValue;
        // Keep the slip already chosen when it is still in the filtered list,
        // including Not Included. Opening the modal has no choice yet, so it
        // starts from the saved template.
        const preferredValue = this.packingSlipTypeChosen ? (currentValue || null) : savedValue;
        const selection = papiDocumentUtil.resolveTemplateSelection(options, preferredValue, false);
        const nextObj = Object.assign({}, this.state.packAdnShipObj, {
            SmallParcelDocumentTypeValue: selection.value,
        });
        if (selection.value) {
            papiDocumentUtil.applyDocumentTypeSelection(
                nextObj,
                "packingSlip",
                selection.value,
                options
            );
        } else {
            // Type is Not Included. Clear the id the same way an empty
            // applyDocumentTypeSelection does, without wiping the legacy runner
            // and address that still live on this object.
            nextObj.SmallParcelPapiPackSlipTemplateId = "";
            nextObj.SmallParcelPapiPackSlipTemplateVersion = null;
        }
        if (mixed && this.mixedPackingSlipSavedScope) {
            nextObj.SmallParcelPapiPackSlipScope = this.mixedPackingSlipSavedScope;
        } else {
            nextObj.SmallParcelPapiPackSlipScope =
                nextObj.SmallParcelPapiPackSlipScope
                || this.state.packAndShipOrderInfo.smallParcelPapiPackSlipScope
                || "";
        }
        this.setState({
            optionsPackingReports: options,
            papiDocumentTemplatesRaw: papiTemplates || [],
            isIntegratedPackingSlips: papiDocumentUtil.isPapiSelection(nextObj.SmallParcelDocumentTypeValue) || mixed,
            packAdnShipObj: nextObj,
        });
    };

    loadPackingSlipTypeOptions = () => {
        this.loadPackingSlipCatalogs(this.state.packAndShipOrderInfo && this.state.packAndShipOrderInfo.customerId);
    };

    loadPackingSlipCatalogs = (customerId) => {
        const mixed = this.isPapiPackAndShipMixedCustomers();
        if (!this.usesNewPackingSlipUiForOrder()) {
            const hasSavedPair =
                this.state.packAndShipOrderInfo.smallParcelAddressTemplate &&
                this.state.packAndShipOrderInfo.smallParcelPackSlip;
            const reportCustomerId = customerId
                || (this.props.sharedSelectedCustomerIds && this.props.sharedSelectedCustomerIds[0])
                || null;
            if (hasSavedPair && !mixed) {
                smallParcelSettingsServices.getPackingSlipReports({ customerId: reportCustomerId }).then((response) => {
                    if (response && response.status == 200 && response.data && response.data.length >= 1) {
                        const mapped = this.applySsrsPackingSlipResponse(response.data);
                        this.setState({
                            optionsTemplateReports: mapped.tempOptionsTemplateReports,
                            optionsPackingReports: mapped.tempOptionsPackingReports,
                            isIntegratedPackingSlips: true,
                        });
                    }
                });
            }
            return;
        }

        const optedIn = mixed || this.hasCustomerPackingSlipConfigured();
        if (!optedIn) {
            this.setState({
                optionsPackingReports: [],
                isIntegratedPackingSlips: false,
            });
            return;
        }

        this.loadCarrierAccountDocumentTemplates().then((parsedTemplates) => {
            const documentTemplates = parsedTemplates == null
                ? (this.state.papiDocumentTemplatesRaw || [])
                : parsedTemplates;
            this.mergePackingSlipTypeOptions(documentTemplates);
        });
    };

    getPapiShipTemplateParams = () => {
        if (this.getPackingSlipSelectionEngine() !== papiDocumentUtil.DOC_ENGINE_PAPI) {
            return { papiTemplateId: null, papiTemplateVersion: null, papiSlipScope: null, papiSlipFormat: null };
        }
        if (
            !this.state.isIntegratedPackingSlips ||
            this.state.packAdnShipObj.processAs !== "Standard" ||
            !this.state.packAdnShipObj.SmallParcelPapiPackSlipTemplateId
        ) {
            return { papiTemplateId: null, papiTemplateVersion: null, papiSlipScope: null, papiSlipFormat: null };
        }
        const scope = this.state.packAdnShipObj.SmallParcelPapiPackSlipScope;
        // Only an explicit Format goes on the ship request. Blank lets the server keep
        // its fallback (customer setting, else the shipping label format).
        const rawFormat = String(this.state.packAdnShipObj.SmallParcelPapiPackSlipFormat || "").trim().toLowerCase();
        return {
            papiTemplateId: this.state.packAdnShipObj.SmallParcelPapiPackSlipTemplateId,
            papiTemplateVersion: this.state.packAdnShipObj.SmallParcelPapiPackSlipTemplateVersion,
            papiSlipScope: (scope && String(scope).trim()) ? scope : "shipment",
            papiSlipFormat: rawFormat === "pdf" || rawFormat === "zpl" ? rawFormat : null,
        };
    };

    isPapiPackageLayoutBlocked = () => {
        return papiDocumentUtil.shouldDisablePapiPackingSlipsForSelection(
            papiDocumentUtil.isPapiSelection(this.state.packAdnShipObj.SmallParcelDocumentTypeValue),
            papiDocumentUtil.isPapiPackageSlipScope(this.state.packAdnShipObj.SmallParcelPapiPackSlipScope),
            this.state.isAnyItemUnpacked
        );
    };

    getPapiPackingSlipFilterCustomerIds = () => {
        if (
            this.props.sharedSelectedOrderIds &&
            this.props.sharedSelectedOrderIds.length === 1 &&
            this.state.packAndShipOrderInfo &&
            this.state.packAndShipOrderInfo.customerId
        ) {
            return [this.state.packAndShipOrderInfo.customerId];
        }
        return this.props.sharedSelectedCustomerIds || [];
    };

    isPapiPackAndShipMixedCustomers = () => {
        return papiDocumentUtil.distinctWmsCustomerIds(
            this.props.sharedSelectedCustomerIds
        ).length > 1;
    };

    getMultiOrderCustomerName = () => {
        var ids = papiDocumentUtil.distinctWmsCustomerIds(this.props.sharedSelectedCustomerIds);
        if (!ids.length) return "";
        var customer = GlobalService.getCustomerById(ids[0]);
        return (customer && customer.name) || "";
    };

    onChangeFunc = (e) => {
        const nextPackAndShipObj = Object.assign({}, this.state.packAdnShipObj, {
            [e.target.name]: e.target.value,
        });

        if (e.target.name === "SmallParcelDocumentTypeValue") {
            this.packingSlipTypeChosen = true;
            papiDocumentUtil.applyDocumentTypeSelection(
                nextPackAndShipObj,
                "packingSlip",
                e.target.value,
                this.state.optionsPackingReports
            );
            const formatOptions = papiDocumentUtil.getFormatOptionsForTemplate(
                e.target.value,
                this.state.papiDocumentTemplatesRaw,
                papiDocumentUtil.PAPI_DOC_TYPES.packingSlip
            );
            const currentFormat = papiDocumentUtil.resolvePapiDocumentFormat(nextPackAndShipObj, "packingSlip");
            if (e.target.value && formatOptions.length
                && !formatOptions.some(function (opt) { return opt.Value === currentFormat; })) {
                nextPackAndShipObj.SmallParcelPapiPackSlipFormat = formatOptions[0].Value;
            }
            this.setState({
                packAdnShipObj: nextPackAndShipObj,
                isIntegratedPackingSlips: papiDocumentUtil.isPapiSelection(nextPackAndShipObj.SmallParcelDocumentTypeValue),
            });
            return;
        }

        this.setState({
            packAdnShipObj: nextPackAndShipObj,
        }, e.target.name === "SmallParcelPapiPackSlipFormat"
            ? () => {
                this.mergePackingSlipTypeOptions(this.state.papiDocumentTemplatesRaw);
            }
            : undefined);

        // If label format changed, re-check printer configuration
        if (e.target.name === "labelFormat") {
            // Packing slip template list intentionally NOT reloaded here: the list no
            // longer depends on Label Format (template.engine does not gate PDF vs
            // ZPL output). Reloading also had the side effect of resetting an
            // in-progress user template selection back to the saved customer
            // default. See SPEC_TW-37988_REMOVE_FORMAT_COUPLING.md REQ-1a.
            console.log(
                "%c[Pack & Ship] Label format changed to:",
                "color: #9C27B0; font-weight: bold",
                e.target.value
            );

            // Re-check printer configuration after state updates
            // Use setTimeout to ensure state has updated
            setTimeout(() => {
                this.checkPrinterConfiguration().catch((error) => {
                    console.error("[Pack & Ship] Error checking printer configuration after label format change:", error);
                });
            }, 100);
        }
    };

    onScanValueEnter = () => {
        var scanValueNormal = this.state.scanGridKey.trim();
        if (!scanValueNormal) {
            return false;
        }

        var gridRef = $("#packAndShipTransactionGrid").data("kendoGrid");
        var data = gridRef.dataSource.data();

        var isBarcodeActionPerformed = this.scannedBarcodeAction(scanValueNormal);
        if (isBarcodeActionPerformed) {
            this.setState({ scanGridKey: "" });
            return true;
        }

        var scanValue = scanValueNormal.toUpperCase();
        var isSkuFoundButPacked = false;
        var res = $.grep(data, (d) => {
            var tmpSku = d.Sku ? d.Sku.toUpperCase() : "";
            var tmpUpc = d.Upc ? d.Upc.toUpperCase() : "";
            var tmpSecondaryUpc = d.secondaryUpc ? d.secondaryUpc.toUpperCase() : "";
            var tmpPackageUpc = d.packageUpc ? d.packageUpc.toUpperCase() : "";
            var tmpMovableUnit = d.MovableUnit ? d.MovableUnit.toUpperCase() : "";
            var tmpDescription = d.Description ? d.Description.toUpperCase() : "";
            var tmpBarcode = d.Barcode ? d.Barcode.toUpperCase() : "";

            // Check Is Non Sku Package items
            if (tmpSku == "INSERTS" && (tmpDescription == scanValue || tmpBarcode == scanValue)) {
                return true;
            }
            if (
                (d.PackageId > 0 || (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && d.orderItemScanned == true)) &&
                (
                    tmpSku == scanValue ||
                    tmpMovableUnit == scanValue ||
                    (
                        this.isAllowDuplicatedUPC == false &&
                        (
                            tmpUpc == scanValue ||
                            tmpSecondaryUpc == scanValue ||
                            tmpPackageUpc == scanValue
                        )
                    )
                )
            ) {
                isSkuFoundButPacked = true;
            }
            return (d.PackageId == 0 || (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && d.orderItemScanned == false)) && (tmpSku == scanValue || tmpMovableUnit == scanValue || (this.isAllowDuplicatedUPC == false && (tmpUpc == scanValue || tmpSecondaryUpc == scanValue || tmpPackageUpc == scanValue)));
        });
        // console.log("onScanValueEnter : res : ", res);
        if (res.length > 0) {
            // console.log("onScanValueEnter : res[0] : ", res[0]);
            // Check Is Non Sku Inserts
            if (res[0].Sku == "INSERTS") {
                this.clickRowAndOpenQtyPop(res[0]);
            } else {
                var tmpSecondaryUpc = res[0].secondaryUpc ? res[0].secondaryUpc.toUpperCase() : "";
                var tmpPackageUpc = res[0].packageUpc ? res[0].packageUpc.toUpperCase() : "";
                this.qtyBaseOnUPC = 1;
                if (tmpSecondaryUpc == scanValue) {
                    this.qtyBaseOnUPC = res[0].secondaryUpcPerUnitsRatio;
                } else if (tmpPackageUpc == scanValue) {
                    this.qtyBaseOnUPC = res[0].packageUpcPerUnitsRatio;
                }
                if (res[0].PackageId == 0 && res[0].orderItemScanned == false && this.state.requiredScanActive) {
                    this.isUnpackedAndUnScannedItem = true;
                } else {
                    this.isUnpackedAndUnScannedItem = false;
                }
                this.clickRowAndOpenQtyPop(res[0]);
            }
        } else if (res.length === 0 && isSkuFoundButPacked === true) {
            // An item still waiting to be scanned matches the grep above, so reaching
            // here means every line for this SKU is done and the scan has nothing
            // left to pack, whether the order packs by scan or by click.
            GlobalService.notificationNewDesign("error", this.translate("Label_Already_Scanned"), this.translate("Label_Fully_Packed_valid_Scan_Content"));
        } else {
            if (this.scannedValueResArr[scanValueNormal]) {
                this.handleMainModalBarcodeScanResult(scanValueNormal);
            } else {
                this.setState({ scanInputLoading: true });
                let customerId = this.state.packAndShipOrderInfo.customerId;

                smallParcelService
                    .lineScanResolver(customerId, scanValueNormal)
                    .then((response) => {
                        this.scannedValueResArr[scanValueNormal] = response.data;
                        this.handleMainModalBarcodeScanResult(scanValueNormal);
                    })
                    .finally(() => {
                        this.setState({
                            scanInputLoading: false,
                        });
                    });
            }
        }
    };

    clickRowAndOpenQtyPop = (res) => {
        this.isEnteredValue = true;
        var gridRef = $("#packAndShipTransactionGrid").data("kendoGrid");
        gridRef.clearSelection();
        gridRef.select($("tr[data-uid='" + res.uid + "']"));
        this.onGridSelection(res);
    };

    handleMainModalBarcodeScanResult = (scannedValue) => {
        var gridRef = $("#packAndShipTransactionGrid").data("kendoGrid");
        let scannedResult = this.scannedValueResArr[scannedValue];
        if (scannedResult.SKU || scannedResult.UPC) {
            var isSkuFoundButPacked = false;
            var res = $.grep(gridRef.dataSource.data(), (d) => {
                // console.log("handleMainModalBarcodeScanResult grepLoop : " + d.PackageId + "   d.Sku: " + d.Sku + "   scannedResult.SKU:" + scannedResult.SKU);
                if (d.PackageId > 0 && ((scannedResult.SKU ? d.Sku.toUpperCase() == scannedResult.SKU.toUpperCase() : false) || (this.isAllowDuplicatedUPC == false && scannedResult.UPC && d.Upc ? d.Upc.toUpperCase() == scannedResult.UPC.toUpperCase() : false))) {
                    isSkuFoundButPacked = true;
                }
                return d.PackageId == 0 && ((scannedResult.SKU ? d.Sku.toUpperCase() == scannedResult.SKU.toUpperCase() : false) || (this.isAllowDuplicatedUPC == false && scannedResult.UPC && d.Upc ? d.Upc.toUpperCase() == scannedResult.UPC.toUpperCase() : false)) && this.order.SmallParcelDisableClickToPack && (!this.state.requiredScanActive || this.order.OrderScanned);
            });
            // console.log("handleMainModalBarcodeScanResult : isSkuFoundButPacked: " + isSkuFoundButPacked);
            if (res.length > 0) {
                this.qtyBaseOnUPC = 1;
                this.clickRowAndOpenQtyPop(res[0]);
            } else if (res.length === 0 && isSkuFoundButPacked === true) {
                GlobalService.notificationNewDesign("error", this.translate("Label_Already_Scanned"), this.translate("Label_Fully_Packed_valid_Scan_Content"));
            } else {
                GlobalService.notificationNewDesign("error", this.translate("Label_SKU_Not_Found"), this.translate("Label_Not_valid_Scan_Content"));
                this.setFocusOnScanAndSelectValue();
            }
        } else {
            GlobalService.notificationNewDesign("error", this.translate("Label_SKU_Not_Found"), this.translate("Label_Not_valid_Scan_Content"));
            this.setFocusOnScanAndSelectValue();
        }
    };

    onClickPackSelectedItem = () => {
        this.lastPackedSelectedIndex = 0;
        this.selectedItems = [];

        var gridRef = $("#packAndShipTransactionGrid").data("kendoGrid");
        var rows = gridRef.select();

        $.map(rows, (row) => {
            this.selectedItems.push(_.cloneDeep(gridRef.dataItem(row)));
        });
        // this.selectedItems = rows.map(function(row) {
        //     return gridRef.dataItem(row)
        // });
        // console.log("onClickPackSelectedItem this.selectedItems : ", this.selectedItems);
        this.checkNextItemToPackSelected();
    };

    checkNextItemToPackSelected = (fromCalled = "") => {
        // console.log("checkNextItemToPackSelected this.selectedItems : ", this.selectedItems, this.lastPackedSelectedIndex, fromCalled, this.content.PackedQty);
        var isSerialNumberRequired = false;
        for (let i = this.lastPackedSelectedIndex; i < this.selectedItems.length; i++) {
            const selectedItem = this.selectedItems[i];
            if (selectedItem.OutboundMobileSerialization > 0) {
                this.lastPackedSelectedIndex = i + 1;
                if (fromCalled !== "qtyNext" && fromCalled !== "_packContent") {
                    this.setState({
                        isEnabledNextOnSerialPopup: false,
                    });
                    this.content = selectedItem;
                    var packagedQty = this.qtyBaseOnUPC;
                    if (this.isIntegral) {
                        packagedQty = Math.ceil(this.qtyBaseOnUPC);
                    }

                    // When OrderScanned is false, treat as unpacked and use remainder for serial items
                    if (this.order.SmallParcelDisableClickToPack && this.state.requiredScanActive && !this.order.OrderScanned) {
                        this.content.PackedQty = this.content.Remainder;
                    } else if (this.content.Remainder > 1 || !this.isIntegral) {
                        if (this.state.isOneQtyPack) {
                            this.content.PackedQty =
                                this.qtyBaseOnUPC < this.content.Remainder ? packagedQty : this.content.Remainder;
                        } else {
                            this.content.PackedQty = this.content.Remainder;
                        }
                    } else {
                        this.content.PackedQty = 1;
                    }
                }
                // GlobalService.notification("error", selectedItem.Sku + ' item has require serial number, please try again after deselect');
                isSerialNumberRequired = true;
                break;
            }
        }

        if (isSerialNumberRequired) {
            this._serial();
        } else if (isSerialNumberRequired == false) {
            if (this.state.isOpenSerialPopup) {
                this.isSerialNumberDisableToAddNew = false;
                this._add(this.props.windowId + "SerialPopup");
            } else {
                this._add("PackAndShipTransactionModel");
            }
        }
    };

    onDeleteAllPackage = () => {
        this.setState({
            isOpenConfirmDeleteAllPopup: true,
        });
    };

    setFocusOnScanAndSelectValueQtyPopup = () => {
        // clear scan value after increment quantity or show record not found message
        this.setState({
            scanPackedQty: "",
            isQtyPopupScanDetected: false,
            isQtyPopupScannedFocus: true,
        });
        const focusScan = () => {
            var scanEl =
                this.refs.scanPackedQty || document.getElementById(this.state.selector + "scanPackedQty");
            if (scanEl) {
                scanEl.focus();
            }
        };
        // Try now (re-scan) and again after Kendo Window finishes opening.
        focusScan();
        setTimeout(focusScan, 300);
    };

    setFocusOnScanNonSkuAndSelectValueQtyPopup = () => {
        // clear scan value after increment quantity or show record not found message
        this.setState({
            scanNonSkuPackedQty: "",
            isQtyPopupScanDetected: false,
            isQtyPopupScannedFocus: true,
        });
        const focusScan = () => {
            var scanEl =
                this.refs.scanNonSkuPackedQty ||
                document.getElementById(this.state.selector + "scanNonSkuPackedQty");
            if (scanEl) {
                scanEl.focus();
            }
        };
        focusScan();
        setTimeout(focusScan, 300);
    };

    onScanQtyPopupEnter = () => {
        this.setState({
            isQtyPopupScanDetected: true,
        });
        // Scanner wedges fire Enter before React state may flush — read the live input value.
        var scanEl = this.refs.scanPackedQty;
        var scanPackedQtyValue = scanEl ? scanEl.value : this.state.scanPackedQty;
        this.qtyBaseOnUPC = 1;
        if (this.content.secondaryUpc == scanPackedQtyValue) {
            this.qtyBaseOnUPC = this.content.secondaryUpcPerUnitsRatio;
        } else if (this.content.packageUpc == scanPackedQtyValue) {
            this.qtyBaseOnUPC = this.content.packageUpcPerUnitsRatio;
        }
        if (
            this.content.Sku == scanPackedQtyValue ||
            this.content.Upc == scanPackedQtyValue ||
            this.content.MovableUnit == scanPackedQtyValue ||
            this.content.secondaryUpc == scanPackedQtyValue ||
            this.content.packageUpc == scanPackedQtyValue
        ) {
            this.onQtyIncrement();
            this.setFocusOnScanAndSelectValueQtyPopup();
        } else {
            if (this.scannedValueResArr[scanPackedQtyValue]) {
                this.handleQtyPopupBarcodeScannedResult(scanPackedQtyValue);
            } else {
                this.setState({ scanPackedLoading: true });
                let customerId = this.state.packAndShipOrderInfo.customerId;

                smallParcelService
                    .lineScanResolver(customerId, scanPackedQtyValue)
                    .then((response) => {
                        this.scannedValueResArr[scanPackedQtyValue] = response.data;
                        this.handleQtyPopupBarcodeScannedResult(scanPackedQtyValue);
                    })
                    .finally(() => {
                        if (this._isMounted) {
                            this.setState({
                                scanPackedLoading: false,
                            });
                        }
                    });
            }
        }
    };

    onScanNonSkuQtyPopupEnter = () => {
        this.setState({
            isQtyPopupScanDetected: true,
        });
        this.onNonSkuQtyIncrement();
    };

    handleQtyPopupBarcodeScannedResult = (scannedValue) => {
        if (!this._isMounted) return;
        var tmpIsScanPackedNotAvailable = true;
        let scannedResult = this.scannedValueResArr[scannedValue];

        if (scannedResult.SKU || scannedResult.UPC) {
            if (
                (scannedResult.SKU && scannedResult.SKU == this.content.Sku) ||
                (scannedResult.UPC && scannedResult.UPC == this.content.Upc)
            ) {
                this.qtyBaseOnUPC = 1;
                this.onQtyIncrement();
                tmpIsScanPackedNotAvailable = false;
            }
        }
        this.setState({
            isScanPackedNotAvailable: tmpIsScanPackedNotAvailable,
        });

        if (tmpIsScanPackedNotAvailable) {
            setTimeout(() => {
                if (this._isMounted) {
                    this.setState({ isScanPackedNotAvailable: false });
                }
            }, 3000);
        }
        this.setFocusOnScanAndSelectValueQtyPopup();
    };

    onPackageChange = (e) => {
        var packAndShipCombobox = $("#PackAndShiAddaPackage").data("kendoComboBox");
        let packageDefId = "";
        // let pkg = this.getPackageByPackageDefIdFromPackageOptions(e.target.value);
        var isBarcodeActionPerformed = this.scannedBarcodeAction(packAndShipCombobox.text());
        if (isBarcodeActionPerformed) {
            packAndShipCombobox.text("");
            return true;
        }
        if (e.target.value == 0 && e.target.selectedIndex !== -1) {
            this.setState({
                isOpenCustomPackageModel: true,
                customPackageObj: {},
            });
            packAndShipCombobox.text("");
            return true;
        }
        if (e.target.value && e.target.selectedIndex == -1) {
            packAndShipCombobox.select(function (dataItem) {
                return dataItem.Name == e.target.value || dataItem.Barcode == e.target.value;
            });
            packageDefId = packAndShipCombobox.value();
        } else {
            packageDefId = e.target.value;
        }

        // console.log("onPackageChange: ", e.target.value, e.target.selectedIndex, packageDefId);

        if (packAndShipCombobox) {
            packAndShipCombobox.value("");
        }
        if (packageDefId) {
            this.previousSelectedPackage = this.currentPackage;
            this.currentPackage = this.getPackageByPackageDefIdFromPackageOptions(packageDefId);
            this.currentPackage.PackageId = 0;
            this.currentPackage.isShawZeroPackageId = true;
            var tmpUniquePackageName = this.getUniquePackageName(this.currentPackage.Name);
            this.currentPackage.uniquePackageName = tmpUniquePackageName;

            for (let i = 0; i < this.state.addNumOfPackages; i++) {
                var tmpCloneCurrentPkg = _.cloneDeep(this.currentPackage);
                tmpCloneCurrentPkg.uniquePackageName = this.getUniquePackageName(this.currentPackage.Name);
                this.previousSelectedPackageArr.push(tmpCloneCurrentPkg);
                this.currentPackage = tmpCloneCurrentPkg;
            }
            this.listGrid_dataBind();
            this.setFocusOnScanAndSelectValue();
        } else if (e.target.value) {
            GlobalService.notification("error", "Scanned package not found");
        }
    };
    removePackageFromArr = (package_name) => {
        _.remove(this.previousSelectedPackageArr, {
            uniquePackageName: package_name,
        });
    };
    scannedBarcodeAction = (scannedValue) => {
        // console.log("scannedValue :",scannedValue);
        if (scannedValue == "Pack") {
            if (this.state.isPackOrPackAndShipDisabled) {
                GlobalService.notification("error", this.state.packOrPackShipTooltip);
            } else {
                this.onPackClick();
            }
            return true;
        } else if (scannedValue == "Pack and Ship") {
            if (this.state.isPackOrPackAndShipDisabled) {
                GlobalService.notification("error", this.state.packOrPackShipTooltip);
            } else {
                this.onPackNShipClick();
            }
            return true;
        } else if (scannedValue == "Pack and Print Packing Slip") {
            if (this.state.isPackOrPackAndShipDisabled) {
                GlobalService.notification("error", this.state.packOrPackShipTooltip);
            } else {
                this.onPackAndPrintPackingSlipClick();
            }
            return true;
        } else if (scannedValue == "Print Carton Label") {
            if (!this.currentPackage.Name) {
                GlobalService.notification("error", this.translate("Label_No_Package_Selected"));
            } else if (!this.currentPackage.PackageId) {
                GlobalService.notification("error", this.translate("Label_Print_Package_Error"));
            } else if (this.isBlankPrintLabel(this.state.cartonLabel)) {
                GlobalService.notification("error", this.translate("Label_Carton_Require_Tooltip"));
            } else {
                this.autoPrintForIndividualPackage(this.currentPackage.PackageId);
            }
            return true;
        } else if (scannedValue == "Print All Carton Labels") {
            if (this.state.isAnyItemUnpacked) {
                GlobalService.notification("error", this.translate("Label_Carton_Fully_Allocated_Require"));
            } else if (this.isBlankPrintLabel(this.state.cartonLabel)) {
                GlobalService.notification("error", this.translate("Label_Carton_Require_Tooltip"));
            } else {
                this.autoPrintForAllPackage("cartonLabelAll");
            }
            return true;
        } else if (scannedValue == "Print Transaction Labels") {
            if (this.state.isAnyItemUnpacked) {
                GlobalService.notification("error", this.translate("Label_Transaction_Fully_Allocated_Require"));
            } else if (this.state.transactionLabel == 0) {
                GlobalService.notification("error", this.translate("Label_Transaction_Require_Tooltip"));
            } else {
                this.autoPrintForAllPackage("transactionLabelAll");
            }
            return true;
        } else if (scannedValue == "New Package") {
            var packAndShipCombobox = $("#PackAndShiAddaPackage").data("kendoComboBox");
            if (packAndShipCombobox) {
                packAndShipCombobox.focus();
            }
            return true;
        } else if (scannedValue == "Custom Dimensions") {
            this.setState({
                isOpenCustomPackageModel: true,
                customPackageObj: {},
            });
            return true;
        } else if (scannedValue == "Clear All") {
            this.deleteAllConfirm();
            return true;
        } else if (scannedValue == "Select All Unpacked Items") {
            this.onSelectUnpackHandler(true);
            return true;
        } else if (scannedValue == "Pack Selected") {
            if (this.state.isPackSelectedBtnEnabled) {
                this.onClickPackSelectedItem();
                return true;
            } else {
                var gridRef = $("#packAndShipTransactionGrid").data("kendoGrid");
                var selectionCounter = gridRef.select() && gridRef.select().length;
                if (selectionCounter == 0) {
                    GlobalService.notification("error", "Please select an item(s) to add into package.");
                    return true;
                }
            }
        } else if (scannedValue == "Get Rates") {
            if (this.props.sharedSelectedOrderIds.length == 1 && !this.state.isAnyItemUnpacked) {
                this.onClickGetRates();
                return true;
            } else {
                return false;
            }
        } else if (scannedValue == "NxtLabTemp") {
            if (
                this.state.packAdnShipObj.processAs == "Standard" &&
                this.state.packAdnShipObj.comboLabelTemplate &&
                this.state.menuOptions[0].Reports.length
            ) {
                let currentIndex = this.state.menuOptions[0].Reports.map(function (element) {
                    return element.Name;
                }).indexOf(this.state.packAdnShipObj.comboLabelTemplate);
                let nextIndex = (currentIndex + 1) % this.state.menuOptions[0].Reports.length;
                this.setState({
                    packAdnShipObj: Object.assign({}, this.state.packAdnShipObj, {
                        comboLabelTemplate: this.state.menuOptions[0].Reports[nextIndex].Name,
                    }),
                });
                return true;
            } else {
                return false;
            }
        } else if (scannedValue == "CrtLabTemp") {
            if (this.state.cartonLabelOptionsLoading) {
                return true;
            }
            if (this.state.cartonLabelOptions.length) {
                let nextLabelTemplateId = papiDocumentUtil.nextLabelId(
                    this.state.cartonLabelOptions,
                    this.state.cartonLabel
                );
                this.setState({
                    cartonLabel: nextLabelTemplateId,
                    ucc128Format: this.resolveUcc128Format(
                        nextLabelTemplateId,
                        this.state.ucc128Format,
                        this.state.ucc128TemplatesRaw
                    ),
                });
                return true;
            } else {
                return false;
            }
        } else if (scannedValue == "TranLabTemp") {
            if (this.state.transactionLabelOptions.length) {
                let nextLabelTemplateId = papiDocumentUtil.nextLabelId(
                    this.state.transactionLabelOptions,
                    this.state.transactionLabel
                );
                this.setState({
                    transactionLabel: nextLabelTemplateId,
                });
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };
    getPackageByPackageDefIdFromPackageOptions(id) {
        return this.state.packagesOptions.find((element) => {
            if (element.PackageDefId == id) {
                return element;
            }
        });
    }
    onShipBtnClick = (fromCalled) => {
        if (this.state.gifShipBtn) {
            return;
        }
        if (!this.checkIfOrderAlreadyInPrinting("ship")) {
            this.setState({ gifShipBtn: true });
            this.onCheckToCallAutoRateShopperBeforeShip(fromCalled);
        }
    };
    onCheckToCallAutoRateShopperBeforeShip = (fromCalled) => {
        if (
            this.order.SmallParcelAutoRateShopOnShip &&
            this.props.sharedSelectedOrderIds.length == 1 &&
            // this.state.carrier == this.translate('Label_None_Selected') &&
            // this.state.service ==  this.translate('Label_None_Selected') &&
            this.isCallAutoRateAPI
        ) {
            this.setState({ gifShipBtn: true });
            // Call Auto Rate Starter API
            let dataObj = {
                OrderIds: this.props.sharedSelectedOrderIds,
                ReturnAllRates: false,
                MultiOrderRateShopOnShip: false,
            };
            smallParcelService.parcelAutoRateShopperStarter(dataObj).then((response) => {
                if (response && response.data) {
                    this.getParcelAutoRateShopperStatus(response.data, fromCalled);
                }
            });
        } else if (this.props.sharedSelectedOrderIds.length > 1 && this.isCallAutoRateAPIMultiOrder) {
            this.setState({ gifShipBtn: true });
            // Call Auto Rate Starter API
            let dataObj = {
                OrderIds: this.props.sharedSelectedOrderIds,
                ReturnAllRates: false,
                MultiOrderRateShopOnShip: true,
            };
            smallParcelService.parcelAutoRateShopperStarter(dataObj).then((response) => {
                if (response && response.data) {
                    this.getParcelAutoRateShopperStatus(response.data, fromCalled);
                }
            });
        } else {
            this.onShipClick(fromCalled);
        }
    };
    onShipClick = async (fromCalled) => {
        if (this.props.isOrderOnHold) {
            shipInFlightGuard.clearPendingOrders(this.props.sharedSelectedOrderIds);
            this.setState({
                isOnHoldOrder: true,
                gifShipBtn: false,
                gifPackNShipButton: false,
                packCompleteLoading: false,
            });
            return;
        }

        // HTTP-boundary guard: atomically claim the in-flight slot before any Starter call.
        // Catches duplicate paths (e.g. two rate-shop pollers) without blocking the first caller.
        if (!shipInFlightGuard.tryAcquireShipLock(this.props.sharedSelectedOrderIds)) {
            console.warn('[Pack & Ship] onShipClick suppressed — order already in flight', this.props.sharedSelectedOrderIds);
            this.setState({ gifShipBtn: false, gifPackNShipButton: false, packCompleteLoading: false });
            return;
        }

        // Auto-print carton/transaction labels BEFORE shipping labels
        // This runs for Ship-only operations. Skip for "fromPackNShip" because onPackClick
        // already called autoPrintForAllPackage -- printing here again would cause a double print.
        // Note: Label ID of 0 means "Not specified". Negative IDs like -2 are VALID label IDs!
        const hasCartonLabel = !this.isBlankPrintLabel(this.state.cartonLabel);
        const hasTransactionLabel = this.state.transactionLabel != 0;

        if (this.isPrintIconShaw && (hasCartonLabel || hasTransactionLabel) && fromCalled !== "fromPackNShip" && this.props.sharedSelectedOrderIds?.length === 1) {
            try {
                await this.autoPrintForAllPackage(fromCalled, { skipPapiUcc128: this.shipCarriesPapiUcc128() });
            } catch (error) {
                console.error('[Pack & Ship] Auto-print failed:', error);
                // Continue with shipping even if auto-print fails
            }
        }

        if (fromCalled != "fromPack") {
            this.setState({ gifShipBtn: true });
            await this.updateScaleWeight(this.currentPackage);
        }
        if (fromCalled == "fromPackNShip") {
            this.setState({
                gifPackNShipButton: true,
                packCompleteLoading: true,
                gifShipBtn: true,
            });
        }

        let labelFormat;

        if (this.state.packAdnShipObj.labelFormat == "Pdf") {
            if (
                this.state.packAdnShipObj.processAs == "High Volume" ||
                (this.state.packAdnShipObj.processAs == "Standard" &&
                    this.state.packAdnShipObj.comboLabelTemplate == "Default")
            ) {
                labelFormat = "Pdf";
            } else if (
                this.state.packAdnShipObj.processAs == "High Volume" ||
                (this.state.packAdnShipObj.processAs == "Standard" &&
                    this.state.packAdnShipObj.comboLabelTemplate != "Default")
            ) {
                labelFormat = "Png";
            }
        } else if (this.state.packAdnShipObj.labelFormat == "Png") {
            labelFormat = "Png";
        } else {
            labelFormat = "Zpl";
        }

        if (this.state.packAdnShipObj.labelFormat == "Zpl" && this.state.packAdnShipObj.processAs == "Standard") {
            const papiTemplateParams = this.getPapiShipTemplateParams();
            const papiUcc128Params = this.getPapiUcc128ShipParams();
            smallParcelService
                .getZplFormattedLabels(
                    this.props.sharedSelectedOrderIds,
                    this.state.packAdnShipObj.returnLabel,
                    this.state.rights["Integrations.SmallParcelPartner"],
                    Object.assign({}, papiTemplateParams, papiUcc128Params)
                )
                .then((response) => {
                    shipInFlightGuard.commitOrdersWithStatusUri(
                        this.props.sharedSelectedOrderIds,
                        response.data.StatusRelativeUri
                    );
                    var targetElement = $('[data-wms-selector="packAndShipTransactionFinish"]');
                    this.$rootScope.animationMoveIcon(targetElement);
                    this.$rootScope.taskStarted();
                    var transferOrderObj = Object.assign(
                        {
                            type: "zplFormatedLabel",
                            relativeUri: response.data.StatusRelativeUri,
                            isMultiId: this.props.sharedSelectedOrderIds.length > 1,
                        },
                        papiDocumentUtil.buildSsrsPackingSlipsProgressEventFields(
                            this.getPackingSlipSelectionEngine(),
                            this.state.isIntegratedPackingSlips,
                            this.state.packAdnShipObj,
                            this.props.sharedSelectedOrderIds,
                            this.state.packAndShipOrderInfo.customerId
                        )
                    );
                    var event = new CustomEvent("showProgressModal", {
                        detail: transferOrderObj,
                    });
                    document.dispatchEvent(event);
                    GlobalService.notification("success", this.translate("Label_ZPL_Successfully_Queued"));
                    this.props.onClosePackAndShipModel();
                })
                .catch(() => {
                    shipInFlightGuard.handleStarterFailure(this.props.sharedSelectedOrderIds, () => {
                        this.setState({
                            gifShipBtn: false,
                            gifPackNShipButton: false,
                            packCompleteLoading: false,
                        });
                    });
                })
                .finally(() => {});
        } else if (
            this.state.packAdnShipObj.labelFormat == "Pdf" &&
            this.state.packAdnShipObj.processAs == "Standard"
        ) {
            let customerId =
                this.props.sharedSelectedOrderIds.length == 1 ? this.state.packAndShipOrderInfo.customerId : null;
            let seletedReport = this.state.menuOptions[0].Reports.find(
                (elem) => elem.Name == this.state.packAdnShipObj.comboLabelTemplate
            );
            const papiTemplateParams = this.getPapiShipTemplateParams();
            const papiUcc128Params = this.getPapiUcc128ShipParams();
            smallParcelService
                .getPdfFormattedLabels(
                    this.props.sharedSelectedOrderIds,
                    customerId,
                    labelFormat,
                    seletedReport.TemplatedRunnerKey,
                    this.state.packAdnShipObj.returnLabel,
                    this.state.rights["Integrations.SmallParcelPartner"],
                    Object.assign({}, papiTemplateParams, papiUcc128Params)
                )
                .then((response) => {
                    shipInFlightGuard.commitOrdersWithStatusUri(
                        this.props.sharedSelectedOrderIds,
                        response.data.StatusRelativeUri
                    );
                    var targetElement = $('[data-wms-selector="packAndShipTransactionFinish"]');
                    this.$rootScope.animationMoveIcon(targetElement);
                    this.$rootScope.taskStarted();
                    var transferOrderObj = Object.assign(
                        {
                            type: "pdfFormatedLabel",
                            relativeUri: response.data.StatusRelativeUri,
                            pdfFileName: "ShippingLabel-" + this.props.sharedSelectedOrderIds.join("-"),
                            isMultiId: this.props.sharedSelectedOrderIds.length > 1,
                        },
                        papiDocumentUtil.buildSsrsPackingSlipsProgressEventFields(
                            this.getPackingSlipSelectionEngine(),
                            this.state.isIntegratedPackingSlips,
                            this.state.packAdnShipObj,
                            this.props.sharedSelectedOrderIds,
                            this.state.packAndShipOrderInfo.customerId
                        )
                    );
                    var event = new CustomEvent("showProgressModal", {
                        detail: transferOrderObj,
                    });
                    document.dispatchEvent(event);
                    GlobalService.notification("success", this.translate("Label_PDf_Successfully_Queued"));
                    this.props.onClosePackAndShipModel();
                })
                .catch(() => {
                    shipInFlightGuard.handleStarterFailure(this.props.sharedSelectedOrderIds, () => {
                        this.setState({
                            gifShipBtn: false,
                            gifPackNShipButton: false,
                            packCompleteLoading: false,
                        });
                    });
                })
                .finally(() => {});
        } else if (this.state.packAdnShipObj.processAs == "High Volume") {
            smallParcelService
                .createShippingLabelsHighVolumeBatch(
                    this.props.sharedSelectedOrderIds,
                    this.state.packAdnShipObj.batchname,
                    labelFormat
                )
                .then((response) => {
                    if ((typeof response != "undefined" && response.status == 204) || response.status == 200) {
                        // this.resetGridSelectionAndButton();
                        GlobalService.notification("success", this.translate("Label_Pack_And_Ship_Success"));
                        // High Volume is synchronous — no progress polling clears the entry, so release here.
                        shipInFlightGuard.clearPendingOrders(this.props.sharedSelectedOrderIds);
                        this.props.onResetGridSelection();
                        setTimeout(() => {
                            this.props.onClosePackAndShipModel();
                        }, 100);
                    }
                })
                .catch(() => {
                    shipInFlightGuard.handleStarterFailure(this.props.sharedSelectedOrderIds, () => {
                        this.setState({
                            gifShipBtn: false,
                            gifPackNShipButton: false,
                            packCompleteLoading: false,
                        });
                    });
                })
                .finally(() => {
                    this.setState({
                        gifShipBtn: false,
                        gifPackNShipButton: false,
                    });
                });
        }
    };
    onGridSelection = (e) => {
        var tmpIsPackSelectedBtnEnabled = false;
        var tmpPackSelectedBtnTooltip = "";
        var gridRef = $("#packAndShipTransactionGrid").data("kendoGrid");
        var selectionCounter = gridRef.select() && gridRef.select().length;
        if ((e && e.shiftKey) || (e && (e.ctrlKey || e.metaKey)) || selectionCounter > 1) {
            tmpIsPackSelectedBtnEnabled = true;
            var selectionData = gridRef.select();
            var unAssignSkuUid = [];
            $.grep(selectionData, (rowElement) => {
                const selectedItem = gridRef.dataItem(rowElement);
                if (selectedItem.PackageId) {
                    tmpPackSelectedBtnTooltip = this.translate("Label_Select_Item_Already_Packed");
                }
            });
            gridRef.select(unAssignSkuUid.join(", "));
        }
        if (selectionCounter == 0) {
            tmpIsPackSelectedBtnEnabled = false;
        }
        this.selectedItems = [];
        var rows = gridRef.select();
        $.map(rows, (row) => {
            this.selectedItems.push(_.cloneDeep(gridRef.dataItem(row)));
        });
        // console.log("onGridSelection : selectedItems : ", this.selectedItems);
        this.setState(
            {
                isPackSelectedBtnEnabled: tmpIsPackSelectedBtnEnabled,
                packSelectedBtnTooltip: tmpPackSelectedBtnTooltip,
            },
            () => this.listGrid_rowClick(e)
        );
    };

    closeAddNonSkuQuantityModal = () => {
        this.setState({ isOpenAddNonSkuQuantityModal: false });
    };

    onNonSkuQtyDecrement = () => {
        if (this.state.nonSkuItemQuantity != 0) {
            let tempNonSkuItemQuantity = parseInt(this.state.nonSkuItemQuantity) - 1;
            this.setState({ nonSkuItemQuantity: tempNonSkuItemQuantity });
        }
    };

    onNonSkuQtyIncrement = () => {
        let tempNonSkuItemQuantity = parseInt(this.state.nonSkuItemQuantity) + 1;
        this.setState({ nonSkuItemQuantity: tempNonSkuItemQuantity });
    };

    onNonSkuItemQtyChangeFunc = (e) => {
        if (!e.target.value) {
            e.target.value = 0;
        }
        var tempNonSkuItemQuantity = parseInt(e.target.value);
        this.setState({ nonSkuItemQuantity: tempNonSkuItemQuantity });
    };

    nonSkuQtyNext = () => {
        this.closeAddNonSkuQuantityModal();
        this.setFocusOnScanNonSkuAndSelectValueQtyPopup();
        this.addNonSkuItems(this.nonSkuContent.InsertId, this.state.nonSkuItemQuantity);
    };

    addNonSkuItems = (insertId, insertedQty) => {
        let orderId = this.props.sharedSelectedOrderIds[0];
        kendo.ui.progress($("#PackAndShipTransactionModel"), true);
        smallParcelService
            .packNonSkuInserts(orderId, insertId, insertedQty)
            .then((response) => {
                // Get Updated Order Info
                smallParcelService.getOrderPackInfo(orderId).then((response) => {
                    if (this.state.requiredScanActive) {
                        const prevItems = this.state.smallPackGridData || [];
                        const prevScannedContentIds = new Set(
                            prevItems
                                .filter((item) => item && item.PackageContentId && item.orderItemScanned === true)
                                .map((item) => item.PackageContentId)
                        );
                        const prevScannedInsertIds = new Set(
                            prevItems
                                .filter((item) => item && item.InsertId && item.orderItemScanned === true)
                                .map((item) => item.InsertId)
                        );
                        if (response.PackageData) {
                            response.PackageData.forEach((pkg) => {
                                pkg.PackageContents.forEach((content) => {
                                    content.orderItemScanned = prevScannedContentIds.has(content.PackageContentId);
                                });
                            });
                        }
                        if (response.Inserts) {
                            response.Inserts.forEach((insert) => {
                                const tmpInsertId = insert.InsertId || (insert.PackageInsertIdentifier && insert.PackageInsertIdentifier.Id);
                                insert.orderItemScanned = insertId ? prevScannedInsertIds.has(tmpInsertId) || insertId === tmpInsertId : false;
                            });
                        }
                    }
                    this.order = response;
                    this.listGrid_dataBind();
                    this.setState({ scanGridKey: "" });
                    kendo.ui.progress($("#PackAndShipTransactionModel"), false);
                });
        });
    };

    listGrid_rowClick = (e) => {
        let clickFrom = "notFromClick";
        if(this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && e && e.type && e.type == "click") {
            clickFrom = "click";
        }
        var gridRef = $("#packAndShipTransactionGrid").data("kendoGrid");
        var selectedItem = gridRef.dataItem(gridRef.select());
        // Checked If Inserts Row Selected Then Clear Selection
        if (selectedItem && selectedItem.Sku == "INSERTS") {
            if (this.state.isOneQtyPack) {
                this.addNonSkuItems(selectedItem.InsertId, selectedItem.InsertedQty + 1);
            } else {
                this.nonSkuContent = selectedItem;
                this.setState(
                    {
                        isOpenAddNonSkuQuantityModal: true,
                        nonSkuItemQuantity: selectedItem.InsertedQty ? selectedItem.InsertedQty : 0,
                    },
                    this.setFocusOnScanNonSkuAndSelectValueQtyPopup
                );
            }
            return;
        }
        if (this.state.isPackSelectedBtnEnabled && selectedItem) {
            this.content = selectedItem;
            if (
                this.content.PackageId == 0 &&
                !this.currentPackage.PackageUri &&
                !this.currentPackage.PackageDefId &&
                this.currentPackage.Name !== this.translate("Label_Custom_Dimensions")
            ) {
                GlobalService.notification("error", "No package selected please select one");
                this.setState({
                    isPackSelectedBtnEnabled: false,
                    selectUnpack: false,
                });
                gridRef.clearSelection();
            }
            return;
        } else if (selectedItem) {
            this.content = selectedItem;
            // get primary Uom and check for item isIntegral or not
            this.isIntegral = GlobalService.getIsIntegeralFlagByType(this.content.PrimaryUOM);
            // Update quantity regex expression
            var quantityRegx = this.isIntegral ? /(^[0-9]+$|^$)/ : /^[0-9]*(?:\.[0-9]{0,3})?$/;
            this.setState({
                quantityRegx: quantityRegx,
            });

            // When OrderScanned is false, prevent clicking on already-packed items
            // if (this.content.PackageId > 0 && this.order.SmallParcelDisableClickToPack && !this.order.OrderScanned) {
            //     // Silently ignore clicks on packed items when OrderScanned is false
            //     return;
            // }

            // When OrderScanned is true or not in scan-required mode, allow editing packed items
            let isAllowEdiItem = this.content.PackageId > 0;
            if(this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && this.content.PackageId > 0 && clickFrom == "notFromClick") {
                isAllowEdiItem = this.content.orderItemScanned;
            }
            if (isAllowEdiItem) {
                this.setState({
                    isOpenEditItemQtyModel: true,
                    packedInSaveDisable: true,
                    selectPackedIn: this.content.PackageId,
                });
                this.itemPopupOpen();
            } else if (
                this.currentPackage.PackageUri ||
                this.currentPackage.PackageDefId ||
                this.currentPackage.Name == this.translate("Label_Custom_Dimensions")
            ) {
                this.lastPackedSelectedIndex = 0;
                var scanGridKeyValue = this.state.scanGridKey.trim();
                if (
                    (this.order.SmallParcelDisableClickToPack && !this.isEnteredValue) ||
                    (this.order.SmallParcelDisableClickToPack &&
                        !scanGridKeyValue &&
                        scanGridKeyValue.toLowerCase() != this.content.Sku.toLowerCase())
                ) {
                    return;
                }
                this.isEnteredValue = false;
                this._packContent();
            } else {
                // no package selected please check
                GlobalService.notification("error", "No package selected please select one");
            }
        }
    };
    itemPopupOpen = () => {
        var labelCount = this.getLabelCounts(this.order.PackageData, this.currentPackage);
        var self = this;
        //build package defs
        var pkgs = this.order.PackageData.reduce(function (obj, p) {
            var isCur = p.PackageId == self.content.PackageId;
            obj.push({
                text: labelCount[p.Name].total > 1 ? p.Name + " (" + ++labelCount[p.Name].i + ")" : p.Name,
                value: p.PackageId,
                disabled: isCur,
                selected: isCur,
            });
            // obj.push($("<option/>")
            //     .text(labelCount[p.Name].total > 1 ?
            //         p.Name + ' (' + ++labelCount[p.Name].i + ')' : p.Name)
            //     .attr("value", p.PackageId)
            //     .attr("disabled", isCur)
            //     .attr("selected", isCur));
            return obj;
        }, []);
        this.setState({
            editPackedInOptions: pkgs,
        });
    };
    _packContent = () => {
        this.showT = false;
        this.showQ = false;
        this.showS = false;

        // if (this.content.Qualifier || this.content.Lot || this.content.Serial || this.content.ExpirationDate) { this.showT = true; }
        var packagedQty = this.qtyBaseOnUPC;
        if (this.isIntegral) {
            packagedQty = Math.ceil(this.qtyBaseOnUPC);
        }
        if(this.content.orderItemScanned == false) {
            this.content.Remainder = this.content.DisplayQty;
        }
        // When OrderScanned is false and SmallParcelDisableClickToPack is enabled, always show quantity modal
        if (this.order.SmallParcelDisableClickToPack && this.state.requiredScanActive && !this.order.OrderScanned) {
            if (this.state.isOneQtyPack || this.content.Remainder == 1) {
                this.content.PackedQty = this.qtyBaseOnUPC < this.content.Remainder ? packagedQty : this.content.Remainder;
            } else {
                this.showQ = true;
            }
        } else if (this.content.Remainder > 1 || !this.isIntegral) {
            if (this.state.isOneQtyPack) {
                this.content.PackedQty =
                    this.qtyBaseOnUPC < this.content.Remainder ? packagedQty : this.content.Remainder;
            } else {
                this.showQ = true;
            }
        } else {
            this.content.PackedQty = 1;
        }

        if (this.content.OutboundMobileSerialization > 0) {
            this.showS = true;
        }
        // if (this.content.TrackSerialNumber > 0) { this.showS = true; }

        // if (this.showT) { this._trackby(); }
        if (this.showQ) {
            this._qty();
        } else if (this.showS) {
            this.checkNextItemToPackSelected("_packContent");
        } else {
            this._add("PackAndShipTransactionModel");
        }
    };
    _trackby = () => {
        // this._qty();
        var info = [];

        if (this.content.Qualifier) {
            info.push({ text: "Qualifier", value: this.content.Qualifier });
        }
        if (this.content.Lot) {
            info.push({ text: "Lot", value: this.content.Lot });
        }
        if (this.content.Serial) {
            info.push({ text: "Serial", value: this.content.Serial });
        }
        if (this.content.ExpirationDate) {
            info.push({
                text: "Expiration Date",
                value: this.content.ExpirationDate,
            });
        }

        this.setState({
            isOpenTrackByInfoMOdel: true,
            trackByModelInfo: info,
        });
    };
    onCloseVerifyTrackByModel = () => {
        this.setState(
            {
                isOpenTrackByInfoMOdel: false,
                trackByModelInfo: [],
            },
            () => {
                this.setFocusOnScanAndSelectValue();
            }
        );
    };
    onConfirmVerifyTrackByModel = () => {
        this.setState({
            isOpenTrackByInfoMOdel: false,
            trackByModelInfo: [],
        });

        if (this.showQ) {
            this._qty();
        } else if (this.showS) {
            this._serial();
        } else {
            this._add("PackAndShipTransactionModel");
        }
    };
    _qty = () => {
        // : pending functionality input maximum qty same as content.Remainder and min quantity 1
        var qty = this.qtyBaseOnUPC;
        if (this.isIntegral) {
            qty = Math.ceil(qty);
        }
        if (this.qtyBaseOnUPC > this.content.Remainder) {
            qty = this.content.Remainder;
        }
        this.setState(
            {
                isOpenAddQuantity: true,
                scanPackedQty: "",
                invalidValue: false,
                remainingQuantity: this.content.Remainder - qty,
                itemQuantity: qty,
            },
            this.setFocusOnScanAndSelectValueQtyPopup
        );
    };
    setFocusOnSerialNumber = () => {
        if (this.refs.serialNumber) {
            // this.refs.serialNumber.refs.myinput.select();
            this.refs.serialNumber.focus();
        }
    };
    _serial = () => {
        this.setState({
            isOpenSerialPopup: true,
            packSerialQty: this.content.PackedQty,
            serials: [],
            enteredSerialNumber: "",
        });
        setTimeout(() => {
            this.setFocusOnSerialNumber();
        }, 500);
        this.validateTrackBySerialAndOutBound([]);
    };
    removeCRIfPresent = (str) => {
        if (str.includes("<CR>")) {
            return str.replaceAll("<CR>", "");
        }
        if (str.includes("<LR>")) {
            return str.replaceAll("<LR>", "");
        }
        return str;
    };
    onEnterSerialInput = () => {
        var list = this.state.serials;

        var val = this.state.enteredSerialNumber;
        // console.log("val", val);
        // console.log("char codes", [...val].map(c => c.charCodeAt(0)));
        const debugString = val.replace(/[\x00-\x1F]/g, c => `[${c.charCodeAt(0)}]`);
        // console.log("debugString", debugString);
        var tmpPackSerialQty = this.state.packSerialQty;
        let serialNumberList = null;
        let splitVal = null;
        let skipVal = null;
        let isEnablePackMultiSerial = this.state.rights.hasOwnProperty("UxPrototypingEnablePackMultiSerial");
        if (isEnablePackMultiSerial && val.includes(",")) {
            splitVal = ",";
            skipVal = 2;
        } else if (
            isEnablePackMultiSerial &&
            /[\r\n\t\x1D\x1E\x1F]+/.test(val) &&
            val.split(/[\r\n\t\x1D\x1E\x1F]+/).length >= 3
        ) {
            splitVal = /[\r\n\t\x1D\x1E\x1F]+/;
            skipVal = 3;
        } else if (isEnablePackMultiSerial && val.includes("  ") && val.split("  ").length >= 3) {
            splitVal = "  ";
            skipVal = 3;
        } else if (isEnablePackMultiSerial && /\r?\n|\r/.test(val) && val.split(/\r?\n|\r/).length >= 3) {
            splitVal = "\n";
            skipVal = 3;
        } else if (isEnablePackMultiSerial && val.includes(" ") && val.split(" ").length >= 3) {
            splitVal = " ";
            skipVal = 3;
        } else {
            serialNumberList = [val];
        }
        if (skipVal) {
            serialNumberList = val.split(splitVal);
            let isNeedSkip = false;
            if (serialNumberList.length > 3 && serialNumberList[2].toLowerCase().includes("qty")) {
                isNeedSkip = true;
            } else if (serialNumberList.length > 3 && serialNumberList[2].toLowerCase().includes("serial")) {
                isNeedSkip = true;
            } else if (serialNumberList.length > 2 && typeof serialNumberList[2] === "string") {
                // Check if serialNumberList[2] can be converted to a number
                const convertedNumber = Number(serialNumberList[2]);
                if (!isNaN(convertedNumber) && isFinite(convertedNumber)) {
                    isNeedSkip = true;
                }
            }
            if (serialNumberList.length >= skipVal && isNeedSkip) {
                serialNumberList.splice(0, skipVal);
            }
            serialNumberList = serialNumberList.filter(item => item !== "").map(item => item.trim());
        } else {
            // For single serial mode, ensure we trim the value
            serialNumberList = [val.trim().replace(/\r?\n|\r/g, '')];
        }
        let numOfSerialNumberNeed = this.content.PackedQty;
        // checked if already have serial number entered than redeem number
        if (this.state.serials && this.state.serials.length) {
            numOfSerialNumberNeed = numOfSerialNumberNeed - this.state.serials.length;
        }
        if (serialNumberList.length > numOfSerialNumberNeed) {
            serialNumberList.splice(numOfSerialNumberNeed);
        }
        for (let i = 0; i < serialNumberList.length; i++) {
            const element = this.removeCRIfPresent(serialNumberList[i]);
            if (this.content.TrackSerialNumber == 4) {
                if (element == this.content.Serial || !this.content.Serial) {
                    list.unshift(element);
                } else {
                    GlobalService.notification("error", "Serial number invalid, expected: " + this.content.Serial);
                }
            } else {
                var isSerialNumberExistsInPacked = false;
                if (this.content.isSerialUnique && this.state.serials.indexOf(element) == -1) {
                    for (let i = 0; i < this.order.PackageData.length; i++) {
                        const packageContentsArr = this.order.PackageData[i].PackageContents;
                        if (packageContentsArr != null && packageContentsArr.length >= 1) {
                            for (let c = 0; c < packageContentsArr.length; c++) {
                                const contentItem = packageContentsArr[c];
                                if (
                                    this.content.oiid == contentItem.OrderItemId &&
                                    contentItem.SerialNumbers.indexOf(element) != -1
                                ) {
                                    isSerialNumberExistsInPacked = true;
                                    break;
                                }
                            }
                        }
                        if (isSerialNumberExistsInPacked) {
                            break;
                        }
                    }
                }
                if (
                    this.content.isSerialUnique &&
                    (this.state.serials.length == 0 || this.state.serials.indexOf(element) == -1) &&
                    isSerialNumberExistsInPacked == false
                ) {
                    list.unshift(element);
                } else if (this.content.isSerialUnique) {
                    GlobalService.notification("error", "Please enter unique serial number");
                }

                if (this.content.isSerialUnique == false) {
                    list.unshift(element);
                }
            }
        }

        tmpPackSerialQty = this.content.PackedQty - list.length;
        this.setState({
            serials: list,
            packSerialQty: tmpPackSerialQty,
            enteredSerialNumber: "",
        });
        this.setFocusOnSerialNumber();

        this.validateTrackBySerialAndOutBound(list);
    };

    validateTrackBySerialAndOutBound = (list) => {
        let isEnabledNext = false;
        // 0 Do not use Outbound Serialization
        // 1 Ignore Quantity Mismatches
        // 2 Require Quantities to Match
        if (this.content.OutboundMobileSerialization == 0) {
            isEnabledNext = true;
        } else if (this.content.OutboundMobileSerialization == 1) {
            if (list.length > 0) {
                isEnabledNext = true;
            }
        } else if (this.content.OutboundMobileSerialization == 2) {
            if (list.length >= this.content.PackedQty) {
                isEnabledNext = true;
            }
        }

        // console.log("validateTrackBySerialAndOutBound before isEnableNextOnSerialPopup", this.state.isEnabledNextOnSerialPopup);
        // console.log("validateTrackBySerialAndOutBound " + isEnabledNext + " this.content.OutboundMobileSerialization: " + this.content.OutboundMobileSerialization);
        this.setState({
            isEnabledNextOnSerialPopup: isEnabledNext,
        });
        // console.log("validateTrackBySerialAndOutBound after isEnableNextOnSerialPopup", this.state.isEnabledNextOnSerialPopup);
        // If all serial added click on next
        if (list.length >= this.content.PackedQty) {
            this.onNextSerialPopup();
        }
    };

    onNextSerialPopup = () => {
        this.content.SerialNumbers = this.state.serials;
        // console.log("onNextSerialPopup this.content.SerialNumbers : ", this.content.SerialNumbers);
        this.checkNextItemToPackSelected();
    };

    closeSerialPopup = () => {
        this.setState({
            isOpenSerialPopup: false,
        });
    };

    listGrid_groupClick = (e) => {
        var g = $(e).find(".group-icon-wrapper").attr("package-id");
        if (Number.isFinite(Number(g)) && g != this.currentPackage.PackageId && parseInt(g) > 0) {
            this._setCurrentPackage(parseInt(g));
            this.listGrid_dataBind();
        } else if (g == 0) {
            let selectedUniquePackageName = $(e).find(".group-icon-wrapper").attr("unique-package-name");
            let selectedPkgIndex = _.findIndex(
                this.previousSelectedPackageArr,
                (packageItem) => {
                    return packageItem.uniquePackageName == selectedUniquePackageName;
                },
                0
            );
            if (selectedPkgIndex != -1) {
                this.previousSelectedPackage = this.currentPackage;
                this.currentPackage = this.previousSelectedPackageArr[selectedPkgIndex];
                this.activePackageIconChange();
                this.listGrid_dataBind();
            }
        }
    };
    activePackageIconChange = () => {
        $(".selected-package").remove(); // remove old active package
        var packageId = this.currentPackage.PackageId;
        var activePackageRow = $("#packAndShipTransactionGrid")
            .find("span.group-icon-wrapper")
            .filter(function () {
                return $(this).attr("package-id") == packageId;
            })
            .closest(".k-reset");
        if (this.currentPackage.PackageId == 0) {
            var uniquePackageName = this.currentPackage.uniquePackageName;
            activePackageRow = $("#packAndShipTransactionGrid")
                .find("span.group-icon-wrapper")
                .filter(function () {
                    return $(this).attr("unique-package-name") === uniquePackageName;
                })
                .last()
                .closest(".k-reset");
        }
        activePackageRow.prepend($('<i class="fas fa-caret-right selected-package"></i>'));

        if (this.state.scaleChangeWeight && this.previousSelectedPackage) {
            this.updateScaleWeight(this.previousSelectedPackage);
            this.previousSelectedPackage = null;
        }
    };
    updateScaleWeight = (currentPackage) => {
        if (
            this.state.scaleChangeWeight &&
            this.state.scaleChangeWeight != "0.0" &&
            this.state.scaleChangeWeight != "0.0000" &&
            currentPackage.Weight != this.state.scaleChangeWeight &&
            this.state.isDeviceConnect &&
            currentPackage.PackageId
        ) {
            var weight = this.state.scaleChangeWeight;
            var pkg = this._getPackageFromOrder(currentPackage.PackageId);
            if (!pkg) {
                return;
            }
            pkg.PackageDefId = currentPackage.PackageDefId;
            var self = this;
            var data = {
                packageData: pkg,
            };
            kendo.ui.progress($("#packAndShipTransactionGrid"), true);
            data.calculateWeight = false;
            data.packageData.Weight = weight;
            // this.state.scaleChangeWeight = 0;
            this.setState({
                isPackNShipLoading: true,
                packNShipLoadingMsg: "Saving weight for current Package...",
            });
            return smallParcelService
                .updatePackage(data)
                .then((response) => {
                    var result = response.data;
                    $.each(self.order.PackageData, function (i, p) {
                        if (p.PackageId == pkg.PackageId) {
                            self.order.PackageData[i] = result;
                        }
                    });
                    GlobalService.notification("success", this.translate("Label_Wieght_Update_Success"));
                    this.isDisabledPack = false;
                    // Which order we have open with have one or more updated packed item.
                    this.isAnyItemPacked = true;
                    this.listGrid_dataBind();
                })
                .finally(() => {
                    this.setState({
                        isPackNShipLoading: false,
                        packNShipLoadingMsg: "",
                    });
                    kendo.ui.progress($("#packAndShipTransactionGrid"), false);
                    return true;
                });
        } else {
            return true;
        }
    };

    _setCurrentPackage = (packageId) => {
        if (!Number.isFinite(Number(packageId))) {
            throw "packageId is not numeric; figure it out";
        }
        this.previousSelectedPackage = this.currentPackage;
        this.currentPackage = this.order.PackageData.find(function (p) {
            return p.PackageId == packageId;
        });

        this.activePackageIconChange();
    };

    _getPackageFromOrder = (packageId) => {
        return this.order.PackageData.find(function (p) {
            return p.PackageId == packageId;
        });
    };

    closeQuantityModal = () => {
        this.qtyBaseOnUPC = 1;
        this.setState(
            {
                isOpenAddQuantity: false,
            },
            () => {
                if (this.showS == false || this.state.isOpenSerialPopup == false) {
                    this.setFocusOnScanAndSelectValue();
                }
            }
        );
    };

    setFocusOnScanAndSelectValue = () => {
        if (this.refs.scanGridKey) {
            this.setState({
                scanGridKey: "",
            });
            this.refs.scanGridKey.focus();
            this.refs.scanGridKey.select();
        }
    };

    setFocusOnAddPackageAndSelectValue = () => {
        var packAndShipCombobox = $("#PackAndShiAddaPackage").data("kendoComboBox");
        if (packAndShipCombobox) {
            packAndShipCombobox.focus();
        }
    };

    // An order with no package has nothing a SKU scan could pack, so the operator
    // has to add one before the scan field is of any use.
    shouldFocusAddPackage = () => {
        var packageData = this.order && this.order.PackageData ? this.order.PackageData : [];
        return packageData.length == 0 && !(this.currentPackage && this.currentPackage.Name);
    };

    setFocusOnPackOrAddPackage = () => {
        if (this.shouldFocusAddPackage()) {
            this.setFocusOnAddPackageAndSelectValue();
        } else {
            this.setFocusOnScanAndSelectValue();
        }
    };

    onQtyIncrement = (e) => {
        var itemQuantity = 0;
        var qty = e ? 1 : this.qtyBaseOnUPC;
        if (this.isIntegral) {
            qty = Math.ceil(qty);
        }
        if (this.isIntegral) {
            itemQuantity = parseInt(this.state.itemQuantity) + Math.ceil(qty);
        } else {
            itemQuantity = (parseFloat(this.state.itemQuantity) + qty).toFixed(3);
        }
        var remainingQuantity = this.state.remainingQuantity - qty;
        if (itemQuantity >= this.content.Remainder) {
            itemQuantity = this.content.Remainder;
            remainingQuantity = 0;
        }
        this.setState({
            itemQuantity: itemQuantity,
            remainingQuantity: remainingQuantity,
        });
        if (remainingQuantity === 0) {
            this.qtyNext(e, this.content.Remainder);
        }
        // no need to check for valid quantity because pack item if quantity is same as remainder
        this.checkValidInput(itemQuantity);
    };

    checkValidInput = (inputValue) => {
        var invalidValue = true;
        if (inputValue && inputValue <= this.content.Remainder) {
            invalidValue = false;
        }
        this.setState({
            invalidValue: invalidValue,
        });
    };
    onQtyDecrement = (e) => {
        var remainingQuantity = 0;
        var itemQuantity = 0;
        var qty = e ? 1 : this.qtyBaseOnUPC;
        if (this.isIntegral) {
            qty = Math.ceil(qty);
        }
        if (this.isIntegral) {
            itemQuantity = parseInt(this.state.itemQuantity) - Math.ceil(qty);
        } else {
            itemQuantity = (parseFloat(this.state.itemQuantity) - qty).toFixed(3);
        }

        if (itemQuantity < 0) {
            // avoid - qty
            itemQuantity = 0;
        }
        if (itemQuantity < this.content.Remainder) {
            remainingQuantity = this.content.Remainder - itemQuantity;
        }

        this.setState({
            itemQuantity: itemQuantity,
            remainingQuantity: remainingQuantity,
        });

        this.checkValidInput(itemQuantity);
    };
    qtyNext = (e, itemQuantity) => {
        var val = this.state.itemQuantity;
        if (itemQuantity) {
            val = itemQuantity;
        }
        if (val && val > 0) {
            if (val <= this.content.Remainder) {
                this.content.PackedQty = val;
            }
            if (this.showS) {
                this.closeQuantityModal();
                this.lastPackedSelectedIndex = 0;
                this.checkNextItemToPackSelected("qtyNext");
            } else {
                this._add(this.props.windowId + "AddItemQuantity");
            }
        }
    };
    handleScanGridKeyChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };
    _add = async (loadingContentId) => {
        // Special handling for pre-packed unscanned items when requiredScanActive is true
        // These items are already in a package, so we just need to update scannedQty in their own package
        if (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && this.content.PackageId > 0 && this.content.orderItemScanned === false) {
            kendo.ui.progress($("#" + loadingContentId), true);
            var scannedQtyToAdd = this.content.PackedQty || 1;
            var pkg = this.order.PackageData.find((p) => p.PackageId == this.content.PackageId);

            if (pkg && pkg.PackageContents) {
                for (let contentIndex = 0; contentIndex < pkg.PackageContents.length; contentIndex++) {
                    var content = pkg.PackageContents[contentIndex];
                    if (content.PackageContentUri == this.content.PackageContentUri) {
                        // Initialize scannedQty if not exists
                        if (!content.scannedQty) {
                            content.scannedQty = 0;
                        }
                        // Add the scanned qty
                        content.scannedQty += scannedQtyToAdd;
                        // Set orderItemScanned = true only when fully scanned
                        if (content.scannedQty >= content.PackedQty) {
                            content.orderItemScanned = true;
                            content.scannedQty = content.PackedQty;
                        }
                        break;
                    }
                }
            }

            kendo.ui.progress($("#" + loadingContentId), false);
            this.isSerialNumberDisableToAddNew = false;
            this.isDisabledPack = false;
            this.isAnyItemPacked = true;
            this.qtyBaseOnUPC = 1;
            this.handlePackageAddSuccess(true);
            return; // Exit early, we're done
        }

        if (this.currentPackage.PackageUri) {
            // id packageUri already than packageContent
            var isUpdatePackageContent = false;
            var tmpUpdatePackageContentsData = [];
            var selectionArr = this.selectedItems;
            var packageData = this.order.PackageData.find((p) => {
                return p.PackageId == this.currentPackage.PackageId;
            });

            if (packageData && packageData.PackageContents) {
                if (packageData.PackageContents.length > 0) {
                    for (let contentIndex = 0; contentIndex < packageData.PackageContents.length; contentIndex++) {
                        if (this.state.isPackSelectedBtnEnabled) {
                            for (let i = 0; i < selectionArr.length; i++) {
                                const selectedItem = selectionArr[i];
                                if (selectedItem.oiid) {
                                    if (
                                        packageData.PackageContents[contentIndex].OrderItemId == selectedItem.oiid &&
                                        packageData.PackageContents[contentIndex].ReceiveItemId == selectedItem.riid
                                    ) {
                                        var packageContentData = packageData.PackageContents[contentIndex];
                                        var newPackedQty = this.getRemainingQty(selectedItem);
                                        var oldPackedQty = packageContentData.PackedQty;
                                        packageContentData.PackedQty = newPackedQty + oldPackedQty;
                                        // merge serial numbers array if already exist
                                        if (
                                            selectedItem.SerialNumbers &&
                                            selectedItem.SerialNumbers.length &&
                                            packageContentData.SerialNumbers &&
                                            packageContentData.SerialNumbers.length
                                        ) {
                                            packageContentData.SerialNumbers = selectedItem.SerialNumbers.concat(
                                                packageContentData.SerialNumbers
                                            );
                                        }

                                        if (this.isIntegral) {
                                            packageContentData.PackedQty =
                                                parseInt(newPackedQty) + parseInt(oldPackedQty);
                                        } else {
                                            packageContentData.PackedQty =
                                                parseFloat(newPackedQty) + parseFloat(oldPackedQty);
                                        }
                                        tmpUpdatePackageContentsData.push(packageContentData);
                                        isUpdatePackageContent = true;
                                        if (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack) {
                                            // Only add to old qty if item was already scanned, otherwise just use newPackedQty
                                            if (packageContentData.orderItemScanned == true || this.isUnpackedAndUnScannedItem) {
                                                packageContentData.PackedQty = parseInt(newPackedQty) + parseInt(oldPackedQty);
                                            } else {
                                                packageContentData.PackedQty = parseInt(newPackedQty);
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            if (
                                packageData.PackageContents[contentIndex].OrderItemId == this.content.oiid &&
                                packageData.PackageContents[contentIndex].ReceiveItemId == this.content.riid
                            ) {
                                var packageContentData = packageData.PackageContents[contentIndex];
                                var newPackedQty = this.content.PackedQty;
                                var oldPackedQty = packageContentData.PackedQty;
                                packageContentData.PackedQty = newPackedQty + oldPackedQty;
                                // merge serial numbers array if already exist
                                if (
                                    this.content.SerialNumbers &&
                                    this.content.SerialNumbers.length &&
                                    packageContentData.SerialNumbers &&
                                    packageContentData.SerialNumbers.length
                                ) {
                                    packageContentData.SerialNumbers = this.content.SerialNumbers.concat(
                                        packageContentData.SerialNumbers
                                    );
                                }

                                if (this.isIntegral) {
                                    packageContentData.PackedQty = parseInt(newPackedQty) + parseInt(oldPackedQty);
                                } else {
                                    packageContentData.PackedQty = parseFloat(newPackedQty) + parseFloat(oldPackedQty);
                                }
                                tmpUpdatePackageContentsData.push(packageContentData);
                                isUpdatePackageContent = true;
                                if (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack) {
                                    // Only add to old qty if item was already scanned, otherwise just use newPackedQty
                                    if (packageContentData.orderItemScanned == true || this.isUnpackedAndUnScannedItem) {
                                        packageContentData.PackedQty = parseInt(newPackedQty) + parseInt(oldPackedQty);
                                    } else {
                                        packageContentData.PackedQty = parseInt(newPackedQty);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            if (isUpdatePackageContent) {
                var finalObject = {
                    packageContentsData: tmpUpdatePackageContentsData,
                };
                kendo.ui.progress($("#" + loadingContentId), true);
                this.isSerialNumberDisableToAddNew = true;
                if (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && this.content.PackageId > 0) {
                    // Track scannedQty instead of just boolean orderItemScanned
                    var packageContentData = tmpUpdatePackageContentsData[0];
                    var scannedQtyToAdd = this.content.PackedQty || 1;
                    var pkg = this.order.PackageData.find((p) => {
                        return p.PackageId == packageContentData.PackageId;
                    });
                    if (pkg && pkg.PackageContents) {
                        for (let contentIndex = 0; contentIndex < pkg.PackageContents.length; contentIndex++) {
                            if (pkg.PackageContents[contentIndex].PackageContentUri == packageContentData.PackageContentUri) {
                                // Initialize scannedQty if not exists
                                if (!pkg.PackageContents[contentIndex].scannedQty) {
                                    pkg.PackageContents[contentIndex].scannedQty = 0;
                                }
                                // Add the scanned qty
                                pkg.PackageContents[contentIndex].scannedQty += scannedQtyToAdd;
                                // Set orderItemScanned = true only when fully scanned
                                if (pkg.PackageContents[contentIndex].scannedQty >= pkg.PackageContents[contentIndex].PackedQty) {
                                    pkg.PackageContents[contentIndex].orderItemScanned = true;
                                    pkg.PackageContents[contentIndex].scannedQty = pkg.PackageContents[contentIndex].PackedQty;
                                }
                            }
                        }
                    }
                    kendo.ui.progress($("#" + loadingContentId), false);
                    this.isSerialNumberDisableToAddNew = false;
                    this.isDisabledPack = false;
                    this.isAnyItemPacked = true;
                    this.qtyBaseOnUPC = 1;
                    this.handlePackageAddSuccess(true); // Pass true to refresh the grid
                } else {
                    smallParcelService
                        .updateItemToPackageContent(finalObject)
                        .then((response) => {
                            var result = response.data[0];
                            var pkg = this.order.PackageData.find((p) => {
                                return p.PackageId == result.PackageId;
                            });
                            if (pkg.PackageContents.length > 0) {
                                for (let contentIndex = 0; contentIndex < pkg.PackageContents.length; contentIndex++) {
                                    packageContentData = pkg.PackageContents[contentIndex];
                                    if (packageContentData.OrderItemId == result.OrderItemId && packageContentData.ReceiveItemId == result.ReceiveItemId) {
                                        pkg.PackageContents[contentIndex].PackedQty = result.PackedQty;
                                        // Set orderItemScanned = true for the updated item when requiredScanActive
                                        if (this.state.requiredScanActive) {
                                            pkg.PackageContents[contentIndex].orderItemScanned = true;
                                            pkg.PackageContents[contentIndex].scannedQty = result.PackedQty;
                                        }
                                    }
                                }
                            }

                            // this.updatedPackageWeight(this.currentPackage.PackageUri);
                            // Enable pack button after package item change when order is already packed
                            this.isDisabledPack = false;
                            // Which order we have open with have one or more item into package content.
                            this.isAnyItemPacked = true;
                            this.qtyBaseOnUPC = 1;
                            if (selectionArr.length != tmpUpdatePackageContentsData.length) {
                                this.checkAndAddItemsToPackage(selectionArr, tmpUpdatePackageContentsData, loadingContentId)
                            } else {
                                this.updatedPackageWeight(this.currentPackage.PackageUri);
                                this.handlePackageAddSuccess(true); // Pass true to refresh grid and show scan status
                            }
                        }).finally(() => {
                            if (selectionArr.length == tmpUpdatePackageContentsData.length) {
                                kendo.ui.progress($('#' + loadingContentId), false);
                                this.isSerialNumberDisableToAddNew = false
                            }
                        });
                }
            } else if (selectionArr.length != tmpUpdatePackageContentsData.length) {
                this.checkAndAddItemsToPackage(selectionArr, tmpUpdatePackageContentsData, loadingContentId);
            }
        } else if (
            this.currentPackage.PackageDefId > 0 ||
            this.currentPackage.Name == this.translate("Label_Custom_Dimensions")
        ) {
            // id packageUri already than package
            var PackageContents = [];
            if (this.state.isPackSelectedBtnEnabled) {
                var selectionArr = this.selectedItems;
                for (let i = 0; i < selectionArr.length; i++) {
                    const selectedItem = selectionArr[i];
                    var packedQty = this.getRemainingQty(selectedItem);
                    if (selectedItem.oiid) {
                        PackageContents.push({
                            OrderItemId: selectedItem.oiid,
                            PackedQty: packedQty, // we need to check and update it : pending
                            ReceiveItemId: selectedItem.riid,
                            SerialNumbers: selectedItem.SerialNumbers, // we need to check and update it   : pending
                            Lot: selectedItem.Lot, // this is null right now
                            Serial: selectedItem.Serial, // this is null right now
                            ExpirationDate: selectedItem.ExpirationDate, // this is null right now
                        });
                    }
                }
            } else {
                PackageContents = [
                    {
                        OrderItemId: this.content.oiid,
                        PackedQty: this.content.PackedQty, // we need to check and update it : pending
                        ReceiveItemId: this.content.riid,
                        SerialNumbers: this.content.SerialNumbers, // we need to check and update it   : pending
                        Lot: this.content.Lot, // this is null right now
                        Serial: this.content.Serial, // this is null right now
                        ExpirationDate: this.content.ExpirationDate, // this is null right now
                    },
                ];
            }
            var finalObject = {
                packageData: {
                    PackageId: this.currentPackage.PackageId,
                    PackageDefId: this.currentPackage.PackageDefId,
                    Length: this.state.currentMeasurementStandardIsImperial
                        ? this.currentPackage.LengthImperial
                        : this.currentPackage.LengthMetric,
                    Width: this.state.currentMeasurementStandardIsImperial
                        ? this.currentPackage.WidthImperial
                        : this.currentPackage.WidthMetric,
                    Height: this.state.currentMeasurementStandardIsImperial
                        ? this.currentPackage.HeightImperial
                        : this.currentPackage.HeightMetric,
                    Ucc128: "",
                    Name: this.currentPackage.Name,
                    PackageUri: this.currentPackage.PackageUri,
                    PackageContents: PackageContents,
                },
                orderUri: "/orders/" + this.props.sharedSelectedOrderIds[0] + "{?detail,itemdetail,recalcautocharges}",
            };
            kendo.ui.progress($("#" + loadingContentId), true);
            this.isSerialNumberDisableToAddNew = true;
            // if (this.state.scaleChangeWeight) {
            //     finalObject.calculateWeight = false;
            //     finalObject.packageData.Weight = this.state.scaleChangeWeight;
            // }
            smallParcelService.addItemToPackage(finalObject).then((response) => {
                var result = response.data;
                if(this.state.requiredScanActive) {
                    result.PackageContents.forEach(content => {
                        content.orderItemScanned = true;
                    });
                }
                if (this._isMounted) {
                    this.setState({
                        scannedPkgUris: [...this.state.scannedPkgUris, result.PackageContentUri]
                    }, () => {
                        if (!this._isMounted) return;
                        this.order.PackageData.push(result);
                        this.removePackageFromArr(this.currentPackage.uniquePackageName);
                        this.previousSelectedPackage = this.currentPackage;
                        this.currentPackage = result;
                        // Enable pack button after package item change when order is already packed
                        this.isDisabledPack = false;
                        this.qtyBaseOnUPC = 1;
                        // Which order we have open with have one or more item add into package.
                        this.isAnyItemPacked = true;
                        if (this.state.isPackSelectedBtnEnabled) {
                            this.setState({ isPackSelectedBtnEnabled: false });
                        }
                        this.handlePackageAddSuccess(true);
                    });
                }

            }).finally(() => {
                if (this._isMounted) {
                    kendo.ui.progress($('#' + loadingContentId), false);
                }
                this.isSerialNumberDisableToAddNew = false
            });
        } else {
            console.log("Something wrong");
        }
    };

    getRemainingQty = (selectedItem) => {
        var packagedQty = this.qtyBaseOnUPC;
        if (this.isIntegral) {
            packagedQty = Math.ceil(this.qtyBaseOnUPC);
        }
        if (selectedItem.Remainder > 1 || !this.isIntegral) {
            if (this.state.isOneQtyPack) {
                packagedQty = this.qtyBaseOnUPC < selectedItem.Remainder ? packagedQty : selectedItem.Remainder;
            } else {
                packagedQty = selectedItem.Remainder;
            }
        } else {
            packagedQty = 1;
        }
        return packagedQty;
    };

    checkAndAddItemsToPackage = (selectionArr, tmpUpdatePackageContentsData, loadingContentId) => {
        var tmpPackageContentsData = [];
        if (this.state.isPackSelectedBtnEnabled) {
            for (let i = 0; i < selectionArr.length; i++) {
                const selectedItem = selectionArr[i];
                if (selectedItem.oiid) {
                    var findInUpdatePkgData = _.find(tmpUpdatePackageContentsData, {
                        ReceiveItemId: selectedItem.riid,
                    });
                    if (findInUpdatePkgData) {
                        continue;
                    }
                    var packedQty = this.getRemainingQty(selectedItem);
                    tmpPackageContentsData.push({
                        PackageContentId: selectedItem.PackageContentId, // this is new fields check it : pending
                        PackageId: this.currentPackage.PackageId,
                        OrderItemId: selectedItem.oiid,
                        ReceiveItemId: selectedItem.riid,
                        PackedQty: packedQty, //  content.PackedQty : pending we need to check it
                        Lot: selectedItem.Lot,
                        Serial: selectedItem.Serial,
                        ExpirationDate: selectedItem.ExpirationDate,
                        SerialNumbers: selectedItem.SerialNumbers,
                        PackageContentUri: selectedItem.PackageContentUri, // this is new fields check it : pending
                        PackageUri: this.currentPackage.PackageUri,
                    });
                }
            }
        } else {
            tmpPackageContentsData = [
                {
                    PackageContentId: this.content.PackageContentId, // this is new fields check it : pending
                    PackageId: this.currentPackage.PackageId,
                    OrderItemId: this.content.oiid,
                    ReceiveItemId: this.content.riid,
                    PackedQty: this.content.PackedQty, //  content.PackedQty : pending we need to check it
                    Lot: this.content.Lot,
                    Serial: this.content.Serial,
                    ExpirationDate: this.content.ExpirationDate,
                    SerialNumbers: this.content.SerialNumbers,
                    PackageContentUri: this.content.PackageContentUri, // this is new fields check it : pending
                    PackageUri: this.currentPackage.PackageUri,
                },
            ];
        }
        var finalObject = {
            packageContentsData: tmpPackageContentsData,
            packageUri: this.currentPackage.PackageUri,
        };
        kendo.ui.progress($("#" + loadingContentId), true);
        this.isSerialNumberDisableToAddNew = true;
        smallParcelService
            .addItemToPackageContent(finalObject)
            .then((response) => {
                var result = response.data[0];
                var pkg = this.order.PackageData.find(function (p) {
                    return p.PackageId == result.PackageId;
                });
                if (this.state.requiredScanActive) {
                    result.orderItemScanned = true;
                    result.scannedQty = result.PackedQty;
                }
                pkg.PackageContents.push(result);
                this.updatedPackageWeight(this.currentPackage.PackageUri);
                // Enable pack button after package item change when order is already packed
                this.isDisabledPack = false;
                // Which order we have open with have one or more item add into package content.
                this.isAnyItemPacked = true;
                this.qtyBaseOnUPC = 1;
                this.handlePackageAddSuccess();
            })
            .finally(() => {
                kendo.ui.progress($("#" + loadingContentId), false);
                this.isSerialNumberDisableToAddNew = false;
            });
    };

    onItemQtyChangeFunc = (e) => {
        if (!e.target.value) {
            e.target.value = 0;
        }
        var itemQuantity;
        var Remainder;
        if (this.isIntegral) {
            itemQuantity = parseInt(e.target.value);
            Remainder = parseInt(this.content.Remainder);
        } else {
            itemQuantity = parseFloat(e.target.value);
            Remainder = parseFloat(this.content.Remainder);
        }

        var remainingQuantity = Remainder - itemQuantity;
        if (remainingQuantity < 0) {
            remainingQuantity = 0;
        }
        this.setState({
            itemQuantity: e.target.value,
            remainingQuantity: remainingQuantity,
        });

        this.checkValidInput(itemQuantity);
    };

    handlePackageAddSuccess = (shouldCallListGridDataBind = false) => {
        this.setState({
            isOpenAddQuantity: false,
            selectUnpack: false,
            isPackSelectedBtnEnabled: false,
        });
        GlobalService.notificationNewDesign("success", this.translate("Label_Item_Packed"), this.translate("Label_Packed_SKU"));
        this.closeSerialPopup();
        if (shouldCallListGridDataBind) {
            this.listGrid_dataBind();
        }

        // When requiredScanActive is true or SmallParcelDisableClickToPack is enabled,
        // check if current package is complete and move to next package.
        if (this.state.requiredScanActive || (this.order.SmallParcelDisableClickToPack && !this.order.OrderScanned)) {
            this.moveToNextPackageIfCurrentIsComplete();
        }
    };

    moveToNextPackageIfCurrentIsComplete = () => {
        // When requiredScanActive is true, check if all items in current package are fully scanned and move to next package with unscanned items
        if (this.state.requiredScanActive && this.order.PackageData.length > 0) {
            // Find current package and check if ALL its items have been fully scanned
            var currentPkg = this.order.PackageData.find((pkg) => pkg.PackageId == this.currentPackage.PackageId);
            var isCurrentPackageComplete = false;

            if (currentPkg && currentPkg.PackageContents && currentPkg.PackageContents.length > 0) {
                // Check if all items in current package are fully scanned (scannedQty >= PackedQty)
                isCurrentPackageComplete = currentPkg.PackageContents.every((content) => {
                    var scannedQty = content.scannedQty || 0;
                    return content.orderItemScanned === true || scannedQty >= content.PackedQty;
                });
            }

            if (isCurrentPackageComplete) {
                // Find next package that has at least one item not fully scanned
                var nextUnscannedPackage = _.find(this.order.PackageData, (pkg) => {
                    if (!pkg.PackageContents || pkg.PackageContents.length == 0) return false;
                    // Return true if any item in this package is NOT fully scanned
                    return pkg.PackageContents.some((content) => {
                        var scannedQty = content.scannedQty || 0;
                        return content.orderItemScanned !== true && scannedQty < content.PackedQty;
                    });
                });

                if (nextUnscannedPackage) {
                    this._setCurrentPackage(nextUnscannedPackage.PackageId);
                    this.listGrid_dataBind();
                }
            }
            return;
        }

        // Original logic for non-requiredScanActive case
        // Check if there are any unpacked items (with Remainder > 0) remaining for the current package
        var hasRemainingItems = false;

        _.each(this.order.OrderItemData, (itemValue) => {
            if (itemValue && itemValue.Allocations) {
                _.each(itemValue.Allocations, (allocationValue) => {
                    // Check if this allocation has remaining quantity and is not yet assigned to a package
                    if (allocationValue.Remainder > 0) {
                        hasRemainingItems = true;
                    }
                });
            }
        });

        // If no unpacked items remain, move to the next package
        if (!hasRemainingItems && this.order.PackageData.length > 0) {
            var currentPackageIndex = _.findIndex(this.order.PackageData, (pkg) => {
                return pkg.PackageId == this.currentPackage.PackageId;
            });

            // Move to next package if available
            if (currentPackageIndex >= 0 && currentPackageIndex < this.order.PackageData.length - 1) {
                var nextPackageId = this.order.PackageData[currentPackageIndex + 1].PackageId;
                this._setCurrentPackage(nextPackageId);
                this.listGrid_dataBind();
            }
        }
    };

    onGridDataBound = (e) => {
        var grid = e.sender;
        var element = grid.element;
        element.find(".hide-package-icon-wrapper").closest(".k-grouping-row").hide();
        element.find(".hide-package-items").closest(".k-grouping-row").next().hide();
        this.activePackageIconChange();
    };
    // on grid column reorder save changes in meta data object
    onColumnReorder = (event) => {
        var grid = $("#packAndShipTransactionGrid").data("kendoGrid");
        var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        let gridColumn = grid.getOptions().columns;
        let switchedArray = ArrayWms.switchIndexByField(gridColumn, event.newIndex, event.oldIndex);
        let finalSubmission = GlobalService.prepareGridOptionsForStorage(
            switchedArray,
            sortArray,
            grid.dataSource.filter()
        );
        metaDataService.setPackAndShipGridOptionInMetaData(finalSubmission);
    };

    // on grid column sort save changes in meta data object
    onSort = (event) => {
        // var grid = $('#packAndShipTransactionGrid').data("kendoGrid");
        // var sortArray = grid.dataSource.sort() ? grid.dataSource.sort() : [];
        // GlobalService.sortDataset(sortArray, event.sort);
        // var gridColumn = grid.getOptions().columns;
        // var finalSubmission = this.state.kendoGrid.prepareGridOptionsForStorage(gridColumn, sortArray, grid.dataSource.filter());
        // metaDataService.setPackAndShipGridOptionInMetaData(finalSubmission);
    };
    unpackItem = () => {
        this._unpack();
    };
    _unpack = () => {
        // $('#pack_item_popup').popup('close');
        var self = this;
        var pkg = this.order.PackageData.find(function (p) {
            return p.PackageId == self.content.PackageId;
        });
        kendo.ui.progress($("#" + this.props.windowId + "EditPackedItem"), true);
        if (pkg && pkg.PackageContents && pkg.PackageContents.length == 1) {
            //deletepackage
            smallParcelService
                .deletePackage(pkg.PackageUri)
                .then((response) => {
                    this.isDisabledPack = false;
                    // Which order we have open with have no item into package content.
                    this.isAnyItemPacked = false;
                    this._handlePackageDelete(pkg.PackageId);
                    this.isSmallParcelGridRefresh = true;
                })
                .finally(() => {
                    kendo.ui.progress($("#" + this.props.windowId + "EditPackedItem"), false);
                });
        } else {
            //delete packagecontent
            smallParcelService
                .deletePackageContent(self.content.PackageContentUri)
                .then((response) => {
                    // Which order we have open with have no item into package content.
                    this.isAnyItemPacked = false;
                    // Enable pack button after package item change when order is already packed
                    this.isDisabledPack = false;
                    this._handleContentDelete(pkg.PackageId);
                    this.updatedPackageWeight(pkg.PackageUri);
                    this.isSmallParcelGridRefresh = true;
                })
                .finally(() => {
                    kendo.ui.progress($("#" + this.props.windowId + "EditPackedItem"), false);
                });
        }
    };
    _handlePackageDelete = (pid) => {
        this.order.PackageData = this.order.PackageData.filter(function (p) {
            return p.PackageId != pid;
        });

        if (this.order.PackageData.length > 0) {
            // If SmallParcelDisableClickToPack is enabled and OrderScanned is false, set first package as active
            if (this.order.SmallParcelDisableClickToPack && this.state.requiredScanActive && !this.order.OrderScanned) {
                this._setCurrentPackage(this.order.PackageData[0].PackageId);
            } else {
                this._setCurrentPackage(this.order.PackageData[this.order.PackageData.length - 1].PackageId);
            }
        } else {
            this._clearCurrentPackage();
        }
        this.content = {};
        this.listGrid_dataBind();
        this.setState({
            isOpenEditItemQtyModel: false,
            selectUnpack: false,
            isPackSelectedBtnEnabled: false,
        });
    };
    _handleContentDelete = () => {
        var self = this;
        $.each(self.order.PackageData, function (i, p) {
            if (p.PackageId == self.content.PackageId) {
                self.order.PackageData[i].PackageContents = self.order.PackageData[i].PackageContents.filter(function (
                    c
                ) {
                    return c.PackageContentId != self.content.PackageContentId;
                });
                return false;
            }
        });
        this.content = {};
        this.listGrid_dataBind();
        this.setState({
            isOpenEditItemQtyModel: false,
            selectUnpack: false,
            isPackSelectedBtnEnabled: false,
        });
    };
    itemPackSelectChange = (e) => {
        var packedInSaveDisable = false;
        if (e.target.value == this.content.PackageId) {
            packedInSaveDisable = true;
        }
        this.setState({
            [e.target.name]: e.target.value,
            packedInSaveDisable: packedInSaveDisable,
        });
    };
    saveItem = () => {
        var newId = parseInt(this.state.selectPackedIn);
        var self = this;
        if (newId) {
            this._setCurrentPackage(newId);

            var pkg = this.order.PackageData.find(function (a) {
                return a.PackageId == self.content.PackageId;
            });
            // if (pkg.PackageContents.length > 1) {
            //     kendo.ui.progress($('#' + this.props.windowId + 'EditPackedItem' ), true);
            //     // Update package content
            //     var finalObject = {
            //         "packageContentData": {
            //             "PackageContentId": content.PackageContentId, // this is new fields check it : pending
            //             "PackageId": newId,
            //             "OrderItemId": content.oiid,
            //             "ReceiveItemId": content.riid,
            //             "PackedQty": content.PackedQty, //  content.PackedQty : pending we need to check it
            //             "Lot": content.Lot,
            //             "Serial":  content.Serial,
            //             "ExpirationDate": content.ExpirationDate,
            //             "SerialNumbers": content.SerialNumbers,
            //             "PackageContentUri": content.PackageContentUri // this is new fields check it : pending
            //             // "PackageUri": this.currentPackage.PackageUri
            //         }
            //     };

            //     smallParcelService.updateItemToPackageContent(finalObject).then((response) => {
            //         var result = response.data;
            //         // After update we need to remove old package contents from old package and move new one to other package id

            //         // First delete package content from other packages
            //         $.each(this.order.PackageData, function (i, p) {
            //             if (p.PackageId == content.PackageId) {
            //                 this.order.PackageData[i].PackageContents = this.order.PackageData[i].PackageContents.filter(function (c) { return c.PackageContentId != content.PackageContentId });
            //             }
            //         });
            //         // add package content to new one package
            //         var newPackage = this.order.PackageData.find(function (p) {
            //             return p.PackageId == newId;
            //         });
            //         newPackage.PackageContents.push(result);
            //         this.listGrid_dataBind();
            //         this.localKendoGrid.clearSelections(() => {
            //             this.localKendoGrid.repaintSelections();
            //         });
            //         this.closePackItem();
            //     }).finally(() => {
            //         kendo.ui.progress($('#' + this.props.windowId + 'EditPackedItem' ), false);
            //     });
            // }
            if (pkg.PackageContents.length > 1) {
                kendo.ui.progress($("#" + this.props.windowId + "EditPackedItem"), true);
                smallParcelService
                    .deletePackageContent(self.content.PackageContentUri)
                    .then((response) => {
                        $.each(self.order.PackageData, function (i, p) {
                            if (p.PackageId == pkg.PackageId) {
                                self.order.PackageData[i].PackageContents = self.order.PackageData[
                                    i
                                ].PackageContents.filter(function (c) {
                                    return c.PackageContentId != self.content.PackageContentId;
                                });
                            }
                        });
                        this.updatedPackageWeight(self.content.PackageUri);
                        this.isSmallParcelGridRefresh = true;
                        this.packcontent(newId);
                    })
                    .finally(() => {});
            } else {
                kendo.ui.progress($("#" + this.props.windowId + "EditPackedItem"), true);
                smallParcelService
                    .deletePackage(pkg.PackageUri)
                    .then((response) => {
                        //remove local instance
                        self.order.PackageData = self.order.PackageData.filter(function (p) {
                            return p.PackageId != pkg.PackageId;
                        });
                        this.isSmallParcelGridRefresh = true;
                        this.packcontent(newId);
                    })
                    .finally(() => {});
            }
        }
    };
    packcontent = (pkgId) => {
        var self = this;

        var isUpdatePackageContent = false;
        var tmpUpdatePackageContentsData = [];
        var selectionArr = this.selectedItems;
        var packageData = this.order.PackageData.find((p) => {
            return p.PackageId == pkgId;
        });
        if (packageData && packageData.PackageContents) {
            if (packageData.PackageContents.length > 0) {
                for (let contentIndex = 0; contentIndex < packageData.PackageContents.length; contentIndex++) {
                    if (
                        packageData.PackageContents[contentIndex].OrderItemId == this.content.oiid &&
                        packageData.PackageContents[contentIndex].ReceiveItemId == this.content.riid
                    ) {
                        var packageContentData = packageData.PackageContents[contentIndex];
                        var newPackedQty = this.content.PackedQty;
                        var oldPackedQty = packageContentData.PackedQty;
                        packageContentData.PackedQty = newPackedQty + oldPackedQty;
                        // merge serial numbers array if already exist
                        if (
                            this.content.SerialNumbers &&
                            this.content.SerialNumbers.length &&
                            packageContentData.SerialNumbers &&
                            packageContentData.SerialNumbers.length
                        ) {
                            if (typeof this.content.SerialNumbers === "object") {
                                this.content.SerialNumbers = Object.values(this.content.SerialNumbers);
                            }
                            packageContentData.SerialNumbers = this.content.SerialNumbers.concat(
                                packageContentData.SerialNumbers
                            );
                        }

                        if (this.isIntegral) {
                            packageContentData.PackedQty = parseInt(newPackedQty) + parseInt(oldPackedQty);
                        } else {
                            packageContentData.PackedQty = parseFloat(newPackedQty) + parseFloat(oldPackedQty);
                        }
                        tmpUpdatePackageContentsData.push(packageContentData);
                        isUpdatePackageContent = true;
                    }
                }
            }
        }

        if (isUpdatePackageContent) {
            var finalObject = {
                packageContentsData: tmpUpdatePackageContentsData,
            };
            this.isSerialNumberDisableToAddNew = true;
            smallParcelService
                .updateItemToPackageContent(finalObject)
                .then((response) => {
                    var result = response.data[0];
                    var pkg = this.order.PackageData.find((p) => {
                        return p.PackageId == result.PackageId;
                    });
                    if (pkg.PackageContents.length > 0) {
                        for (let contentIndex = 0; contentIndex < pkg.PackageContents.length; contentIndex++) {
                            packageContentData = pkg.PackageContents[contentIndex];
                            if (
                                packageContentData.OrderItemId == result.OrderItemId &&
                                packageContentData.ReceiveItemId == result.ReceiveItemId
                            ) {
                                pkg.PackageContents[contentIndex].PackedQty = result.PackedQty;
                            }
                            if (this.state.requiredScanActive) {
                                pkg.PackageContents[contentIndex].orderItemScanned = true;
                                pkg.PackageContents[contentIndex].scannedQty = result.PackedQty;
                            }
                        }
                    }
                    // this.updatedPackageWeight(this.currentPackage.PackageUri);
                    // Enable pack button after package item change when order is already packed
                    this.isDisabledPack = false;
                    // Which order we have open with have one or more item add into package content.
                    this.isAnyItemPacked = true;
                    this.updatedPackageWeight(this.currentPackage.PackageUri);
                    this.listGrid_dataBind();
                    this.closePackItem();
                })
                .finally(() => {
                    if (selectionArr.length == tmpUpdatePackageContentsData.length) {
                        kendo.ui.progress($("#" + this.props.windowId + "EditPackedItem"), false);
                        this.isSerialNumberDisableToAddNew = false;
                    }
                });
        } else {
            var finalObject = {
                packageContentsData: [
                    {
                        PackageContentId: this.content.PackageContentId, // this is new fields check it : pending
                        PackageId: pkgId,
                        OrderItemId: this.content.oiid,
                        ReceiveItemId: this.content.riid,
                        PackedQty: this.content.PackedQty, //  content.PackedQty : pending we need to check it
                        Lot: this.content.Lot,
                        Serial: this.content.Serial,
                        ExpirationDate: this.content.ExpirationDate,
                        SerialNumbers: this.content.SerialNumbers,
                        PackageContentUri: this.content.PackageContentUri, // this is new fields check it : pending
                        PackageUri: this.currentPackage.PackageUri,
                    },
                ],
                packageUri: this.currentPackage.PackageUri,
            };
            smallParcelService
                .addItemToPackageContent(finalObject)
                .then((response) => {
                    var result = response.data;
                    var pkg = self.order.PackageData.find(function (p) {
                        return p.PackageId == result[0].PackageId;
                    });
                    pkg.PackageContents.push(result[0]);
                    // Enable pack button after package item change when order is already packed
                    this.isDisabledPack = false;
                    // Which order we have open with have one or more item add into package content.
                    this.isAnyItemPacked = true;
                    this.listGrid_dataBind();

                    this.updatedPackageWeight(this.currentPackage.PackageUri);

                    this.closePackItem();
                })
                .finally(() => {
                    kendo.ui.progress($("#" + this.props.windowId + "EditPackedItem"), false);
                });
        }
    };
    updatePackage = () => {
        var weight = this.state.editPackageWeight;

        var pkg = this._getPackageFromOrder(this.packageIdForEdit);
        pkg.PackageDefId = this.state.editSelectedPackageDefId;
        delete pkg.Weight;
        var self = this;
        var data = {
            packageData: pkg,
        };

        kendo.ui.progress($("#" + this.props.windowId + "EditPackageDetails"), true);
        data.calculateWeight = !this.weightChanged;
        if (data.calculateWeight == false) {
            data.packageData.Weight = weight;
        }
        if (data.packageData.PackageDefId == 0) {
            data.packageData.Name = this.translate("Label_Custom_Dimensions");
        }
        data.packageData.Height = this.state.editPackageHeight;
        data.packageData.Width = this.state.editPackageWidth;
        data.packageData.Length = this.state.editPackageLength;
        data.packageData.Description = this.state.packageContentDescription;

        const referenceFields = {
            reference1: this.state.reference1,
            reference2: this.state.reference2,
            reference3: this.state.reference3,
        };

        smallParcelService.setReferenceFields(pkg.PackageUri, referenceFields).then(function (response) {
            console.log(response);
        });

        smallParcelService
            .updatePackage(data)
            .then((response) => {
                var result = response.data;
                $.each(self.order.PackageData, function (i, p) {
                    if (p.PackageId == pkg.PackageId) {
                        self.order.PackageData[i] = result;
                    }
                });
                this.closePackGroup();
                // Enable pack button after package item change when order is already packed
                this.isDisabledPack = false;
                // Which order we have open with have one or more updated packed item.
                this.isAnyItemPacked = true;
                this.listGrid_dataBind();
            })
            .finally(() => {
                kendo.ui.progress($("#" + this.props.windowId + "EditPackageDetails"), false);
            });
    };

    updatedPackageWeight = (packageUri) => {
        smallParcelService
            .getPackageFromMT(packageUri)
            .then((response) => {
                let result = response.data;
                _.each(this.order.PackageData, (p, i) => {
                    if (p.PackageId == result.PackageId) {
                        // Preserve orderItemScanned and scannedQty flags from existing package contents
                        if (this.state.requiredScanActive && p.PackageContents && result.PackageContents) {
                            result.PackageContents.forEach((newContent) => {
                                var existingContent = p.PackageContents.find(
                                    (c) => c.PackageContentUri === newContent.PackageContentUri
                                );
                                if (existingContent) {
                                    // Preserve the scan flags
                                    newContent.orderItemScanned = existingContent.orderItemScanned;
                                    newContent.scannedQty = existingContent.scannedQty;
                                }
                            });
                        }
                        this.order.PackageData[i] = result;
                    }
                });
                this.listGrid_dataBind();
            })
            .finally(() => {});
    };
    onChangePackFunc = (e) => {
        if (e.target.name == "transactionLabel") {
            metaDataService.setPackAndShipTransactionLabelInMetaData(e.target.value);
        }
        const nextState = {
            [e.target.name]: e.target.value,
        };
        if (e.target.name === "cartonLabel" && this.usesNewUcc128ForPackAndShip()) {
            nextState.ucc128Format = this.resolveUcc128Format(
                e.target.value,
                this.state.ucc128Format,
                this.state.ucc128TemplatesRaw
            );
        }
        this.setState(nextState, () => {
            this.listGrid_dataBind();
        });
    };

    isBlankPrintLabel = (value) => {
        return value == null || value === "" || value === 0 || value === "0";
    };

    hasSelectedPrintLabel = () => {
        return !this.isBlankPrintLabel(this.state.cartonLabel)
            || !this.isBlankPrintLabel(this.state.transactionLabel);
    };

    autoPrintChangeEvent = (e) => {
        this.isPrintIconShaw = e.target.checked;
        metaDataService.setPackAndShipAutoPrintInMetaData(this.isPrintIconShaw);
        this.listGrid_dataBind();
    };
    oneQtyPackChangeEvent = (e) => {
        this.setState({
            isOneQtyPack: e.target.checked,
        });
        metaDataService.setPackAndShipOneQtyPackInMetaData(e.target.checked);
    };
    onChangeForSelectUnpack = (e) => {
        this.onSelectUnpackHandler(e.target.checked);
    };

    onSelectUnpackHandler = (isChecked) => {
        this.setState(
            {
                selectUnpack: isChecked,
                isPackSelectedBtnEnabled: isChecked,
                packSelectedBtnTooltip: "",
            },
            () => {
                var gridRef = $("#packAndShipTransactionGrid").data("kendoGrid");
                gridRef.clearSelection();
                if (this.state.isPackSelectedBtnEnabled) {
                    var data = gridRef.dataSource.data();
                    var unAssignSkuUid = [];
                    $.grep(data, (d) => {
                        if (d.PackageId == 0 && !d.isHideRow) {
                            unAssignSkuUid.push("[data-uid='" + d.uid + "']");
                        }
                    });
                    if (unAssignSkuUid.length == 0) {
                        this.setState({
                            selectUnpack: false,
                            isPackSelectedBtnEnabled: false,
                        });
                    } else {
                        gridRef.select(unAssignSkuUid.join(", "));
                        this.listGrid_rowClick();
                    }
                } else {
                    gridRef.clearSelection();
                }
            }
        );
    };

    // In-flight guard: tryAcquireShipLock in onShipClick claims the slot before Starter HTTP.
    // progress-holder removes committed entries by StatusRelativeUri on poll terminal states.
    checkIfOrderAlreadyInPrinting = (calledFrom) => {
        const orderIds = this.props.sharedSelectedOrderIds;
        if (shipInFlightGuard.areOrdersInFlight(orderIds)) {
            this.isDuplicatePrintCalledFrom = calledFrom;
            this.setState({
                isOpenDuplicatePrintingModel: true,
            });
            return true;
        }
        return false;
    };

    onCloseDuplicatePrintingModel = () => {
        this.setState({
            isOpenDuplicatePrintingModel: false,
        });
    };

    onClickPrintAnyways = () => {
        if (window.pendo?.track) {
            var pendoTrackObj = {
                orderIds: this.props.sharedSelectedOrderIds,
                tplId: GlobalService.CurrentUser.TplId.toString(),
                tpl: GlobalService.CurrentUser.TplGuid.toString(),
            };
            window.pendo.track("doubleClickShipments", pendoTrackObj);
        }
        if (this.isDuplicatePrintCalledFrom == "ship") {
            this.onCheckToCallAutoRateShopperBeforeShip();
        } else {
            this.onPackClick("fromPackNShip");
        }
        this.onCloseDuplicatePrintingModel();
    };

    printPackingSlipForSelectedOrder = () => {
        this.setState({
            isPackNShipLoading: true,
            packNShipLoadingMsg: "Printing packing slip...",
        });

        const engine = this.getPackingSlipSelectionEngine();
        const stopPrint = () => {
            this.setState({ isPackNShipLoading: false, packNShipLoadingMsg: "" });
            return Promise.resolve(false);
        };
        if (!engine) {
            return stopPrint();
        }

        if (engine === papiDocumentUtil.DOC_ENGINE_PAPI) {
            const payload = papiDocumentUtil.buildPapiPackingSlipGeneratePayload({
                transactionIds: this.props.sharedSelectedOrderIds,
                customerId: this.state.packAndShipOrderInfo.customerId,
                templateId: this.state.packAdnShipObj.SmallParcelPapiPackSlipTemplateId,
                templateVersion: this.state.packAdnShipObj.SmallParcelPapiPackSlipTemplateVersion,
                outputFormat: this.getResolvedPackingSlipFormat(),
            });
            const outputFormat = payload.OutputFormat || "pdf";
            return findOrdersService
                .PapiPackingSlipReportGenerate(payload)
                .then((response) => {
                    if (response && response.status === 200 && response.data) {
                        if (outputFormat === "zpl") {
                            const zplText = papiDocumentUtil.decodeZplResponseData(response.data);
                            GlobalService.printDataInZplPrinter(zplText);
                        } else {
                            GlobalService.printOrViewPackingSlipPdf(response.data);
                        }
                        return true;
                    }
                    return false;
                })
                .catch((error) => {
                    const message = papiDocumentUtil.extractPapiErrorMessage(error)
                        || this.translate("Label_Packing_Slips_Generate_Error");
                    GlobalService.notification("error", this.translate("Label_Packing_Slip"), message);
                    return false;
                })
                .finally(() => {
                    this.setState({
                        isPackNShipLoading: false,
                        packNShipLoadingMsg: "",
                    });
                });
        }

        let payloadRunReportObj = {
            TemplatedRunner: this.state.packAdnShipObj.SmallParcelPackSlip,
            TransactionIds: this.props.sharedSelectedOrderIds,
            CustomerId: this.state.packAndShipOrderInfo.customerId,
            TemplateId: this.state.packAdnShipObj.SmallParcelAddressTemplate,
            OutputType: "application/pdf",
        };

        return findOrdersService
            .PackingSlipReportStarter(payloadRunReportObj)
            .then((response) => {
                if (response && response.status == 200) {
                    this.$rootScope.taskStarted();
                    response.data.outputType = "pdf";
                    response.data.type = "packingslips";

                    var event = new CustomEvent("showProgressModal", {
                        detail: response.data,
                    });
                    document.dispatchEvent(event);
                    return true;
                }
                return false;
            })
            .finally(() => {
                this.setState({
                    isPackNShipLoading: false,
                    packNShipLoadingMsg: "",
                });
            });
    };

    onPackAndPrintPackingSlipClick = async () => {
        if (!this.state.packAndShipOrderInfo || !this.state.packAndShipOrderInfo.OrderId) {
            GlobalService.notification("error", this.getOrderNotLoadedMessage());
            return Promise.resolve(false);
        }
        // Branch on flag: PAPI uses templateId; legacy uses SSRS pack slip + address template.
        if (
            !papiDocumentUtil.isPackAndPrintPackingSlipConfigured(
                this.state.isIntegratedPackingSlips,
                this.state.packAdnShipObj,
                this.state.packAdnShipObj.SmallParcelDocumentTypeValue,
                this.usesNewPackingSlipUiForOrder()
            )
        ) {
            GlobalService.notification("error", this.translate("Label_Packing_Slip") + " configuration is required.");
            return Promise.resolve(false);
        }
        if (this.props.isOrderOnHold) {
            this.setState({
                isOnHoldOrder: true,
            });
            return;
        }

        this.setState({ packCompleteLoading: true });
        await this.updateScaleWeight(this.currentPackage);

        var orderUri = "/orders/" + this.state.packAndShipOrderInfo.OrderId + "{?detail,itemdetail,recalcautocharges}";

        smallParcelService
            .completePackage(orderUri, this.state.requiredScanActive)
            .then(() => {
                this.setState({
                    isPackOrPackAndShipDisabled: true,
                    packOrPackShipTooltip: this.translate("Label_Already_Packed"),
                });
                return this.printPackingSlipForSelectedOrder();
            })
            .then((isPackingSlipQueued) => {
                if (isPackingSlipQueued) {
                    this.props.onResetGridSelection();
                    this.props.onClosePackAndShipModel();
                }
            })
            .finally(() => {
                if (this._isMounted) {
                    this.setState({ packCompleteLoading: false });
                }
            });
    };

    onPackClick = async (fromCalled) => {
        if (!this.state.packAndShipOrderInfo || !this.state.packAndShipOrderInfo.OrderId) {
            GlobalService.notification("error", this.getOrderNotLoadedMessage());
            if (fromCalled == "fromPackNShip") {
                this.setState({ gifPackNShipButton: false, gifShipBtn: false });
            }
            return;
        }
        if (this.props.isOrderOnHold) {
            this.setState({
                isOnHoldOrder: true,
            });
            return;
        }
        if (fromCalled == "fromPackNShip") {
            this.setState({
                gifPackNShipButton: true,
                packCompleteLoading: true,
                gifShipBtn: true,
            });
        } else {
            this.setState({ packCompleteLoading: true });
        }
        await this.updateScaleWeight(this.currentPackage);
        var orderUri = "/orders/" + this.state.packAndShipOrderInfo.OrderId + "{?detail,itemdetail,recalcautocharges}";
        var isApiResponseSuccess = false;
        smallParcelService
            .completePackage(orderUri, this.state.requiredScanActive)
            .then((response) => {
                if (this.isPrintIconShaw) {
                    this.autoPrintForAllPackage(fromCalled, {
                        skipPapiUcc128: fromCalled === "fromPackNShip" && this.shipCarriesPapiUcc128(),
                    });
                } else if (fromCalled != "fromPackNShip") {
                    this.props.onResetGridSelection();
                    this.props.onClosePackAndShipModel();
                }

                if (fromCalled == "fromPackNShip") {
                    this.onCheckToCallAutoRateShopperBeforeShip(fromCalled);
                }
                isApiResponseSuccess = true;
                this.setState({
                    isPackOrPackAndShipDisabled: true,
                    packOrPackShipTooltip: this.translate("Label_Already_Packed"),
                });
            })
            .finally(() => {
                if (this._isMounted) {
                    if (fromCalled == "fromPackNShip" && isApiResponseSuccess == false) {
                        this.setState({
                            gifPackNShipButton: false,
                            packCompleteLoading: false,
                            gifShipBtn: false,
                        });
                    } else if (fromCalled !== "fromPackNShip") {
                        this.setState({ packCompleteLoading: false });
                    }
                }
            });
    };

    onPackNShipClick = () => {
        if (this.props.isOrderOnHold) {
            this.setState({
                isOnHoldOrder: true,
            });
            return;
        }
        if (this.state.gifPackNShipButton || this.state.gifShipBtn) {
            return;
        }
        if (!this.checkIfOrderAlreadyInPrinting("packNShip")) {
            this.setState({ gifShipBtn: true, gifPackNShipButton: true });
            this.onPackClick("fromPackNShip");
        }
    };

    autoPrintForIndividualPackage = (packageId) => {
        const printPapiUcc128 = this.usesNewUcc128ForPackAndShip() && !this.isBlankPrintLabel(this.state.cartonLabel);
        if (printPapiUcc128 && this.props.isOrderOnHold) {
            this.setState({ isOnHoldOrder: true });
            return;
        }
        this.setState({
            isPackNShipLoading: true,
            packNShipLoadingMsg: "Printing labels...",
        });

        let labelTemplateIds = [];
        if (!this.isBlankPrintLabel(this.state.cartonLabel) && !printPapiUcc128) {
            labelTemplateIds.push(this.state.cartonLabel);
        }
        if (this.state.transactionLabel != 0) {
            labelTemplateIds.push(this.state.transactionLabel);
        }
        const packageRecord = this._getPackageFromOrder(packageId);
        let packageUri = packageRecord.PackageUri;
        var payload = {
            packageUri: packageUri,
            labelTemplateIds: labelTemplateIds,
        };
        const printJobs = [];
        if (labelTemplateIds.length) {
            printJobs.push(smallParcelService.autoPrintForIndividualPackage(payload).then((response) => {
                GlobalService.printDataInZplPrinter(response.data);
                return true;
            }));
        }
        if (printPapiUcc128) {
            const packageUcc = packageRecord && packageRecord.Ucc128 && String(packageRecord.Ucc128) !== "0"
                ? [String(packageRecord.Ucc128)]
                : [];
            if (packageUcc.length) {
                printJobs.push(this.printPapiUcc128FromPackAndShip(packageUcc));
            } else {
                GlobalService.notificationNewDesign(
                    "error",
                    this.translate("Label_Ucc128_Package_Labels_Generate_Failed"),
                    this.translate("Label_Ucc128_Package_Missing_Barcode")
                );
            }
        }
        Promise.all(printJobs).then((results) => {
            if (results.some(Boolean)) {
                GlobalService.notification("success", this.translate("Label_Labels_Printed"));
            }
        }).finally(() => {
            this.setState({
                isPackNShipLoading: false,
                packNShipLoadingMsg: "Printing labels...",
            });
        });
    };

    autoPrintForAllPackage = (fromCalled, options) => {
        const skipPapiUcc128 = !!(options && options.skipPapiUcc128);
        const usingNewUcc128 = this.usesNewUcc128ForPackAndShip()
            && !this.isBlankPrintLabel(this.state.cartonLabel);
        const printPapiUcc128 = !skipPapiUcc128
            && usingNewUcc128
            && fromCalled != "transactionLabelAll";
        if (printPapiUcc128 && this.props.isOrderOnHold) {
            this.setState({ isOnHoldOrder: true });
            return Promise.resolve();
        }
        this.setState({
            isPackNShipLoading: true,
            packNShipLoadingMsg: "Printing labels...",
        });

        var labelTemplateIds = [];
        if (!this.isBlankPrintLabel(this.state.cartonLabel) && fromCalled != "transactionLabelAll" && !usingNewUcc128) {
            labelTemplateIds.push(this.state.cartonLabel);
        }
        if (this.state.transactionLabel != 0 && fromCalled != "cartonLabelAll") {
            labelTemplateIds.push(this.state.transactionLabel);
        }
        var payload = {
            orderId: this.state.packAndShipOrderInfo.OrderId,
            labelTemplateIds: labelTemplateIds,
        };
        const printJobs = [];
        if (labelTemplateIds.length) {
            printJobs.push(smallParcelService.autoPrintForAllPackage(payload).then((response) => {
                GlobalService.printDataInZplPrinter(response.data);
                return true;
            }));
        }
        if (printPapiUcc128) {
            printJobs.push(this.printPapiUcc128FromPackAndShip([]));
        }
        // Return the promise so it can be awaited
        return Promise.all(printJobs)
            .then((results) => {
                if (results.some(Boolean)) {
                    this.props.onResetGridSelection();
                    GlobalService.notification("success", this.translate("Label_Labels_Printed"));
                }
            })
            .finally(() => {
                this.setState({
                    isPackNShipLoading: false,
                    packNShipLoadingMsg: "",
                });
                // Only close modal when called from manual print commands (scan-based printing)
                // Don't close when called from auto-print during Pack/Ship flows
                // fromCalled is a string only for manual print commands; it's an object/undefined for workflow calls
                if (
                    typeof fromCalled === "string" &&
                    fromCalled != "fromPackNShip" &&
                    fromCalled != "transactionLabelAll" &&
                    fromCalled != "cartonLabelAll"
                ) {
                    this.props.onClosePackAndShipModel();
                }
            });
    };

    onFocusScanQtyPopup = (event) => {
        // let isQtyPopupScannedFocus;
        // if (this.state.isQtyPopupScannedFocus) {
        //     // setTimeout(() => {
        //         this.refs.itemQuantity.refs.myinput.focus();
        //     // }, 1000);
        //     isQtyPopupScannedFocus = false;
        // } else {
        //     isQtyPopupScannedFocus = true;
        // }
        this.setState({
            isQtyPopupScannedFocus: true,
        });
    };

    onBlurScanQtyPopup = (event) => {
        // console.log("onBlurScanQtyPopup ", event.target);
        this.setState({
            isQtyPopupScannedFocus: false,
        });
    };
    closePackAndShipModel = () => {
        shipInFlightGuard.clearPendingOrders(this.props.sharedSelectedOrderIds);
        this.setState({
            gifShipBtn: false,
            gifPackNShipButton: false,
            packCompleteLoading: false,
        });
        if (this.isSmallParcelGridRefresh) {
            this.props.onResetGridSelection();
        }

        if (
            this.isAnyItemPacked &&
            this.props.sharedSelectedOrderIds.length == 1 &&
            this.order.OrderPacked == false &&
            !this.order.SmallParcelShipDate
        ) {
            // Call order pushed events
            smallParcelService
                .orderPackEvent(this.props.sharedSelectedOrderIds[0], "OrderPackPaused")
                .then((response) => {
                    console.log("OrderPackPaushed Events", response);
                });
        }
        this.props.onClosePackAndShipModel();
    };
    onClickGetRates = async () => {
        await this.updateScaleWeight(this.currentPackage);
        this.setState({
            showAvailableRates: true,
        });
    };
    getParcelAutoRateShopperStatus = (data, fromCalled) => {
        smallParcelService.parcelAutoRateShopperStatus(data.StatusRelativeUri).then(
            (response) => {
                if (response.data.Done) {
                    this.onShipClick(fromCalled);
                } else {
                    setTimeout(() => {
                        this.getParcelAutoRateShopperStatus(response.data, fromCalled);
                    }, 3000);
                }
            },
            (err) => {
                shipInFlightGuard.clearPendingOrders(this.props.sharedSelectedOrderIds);
                this.setState({
                    gifPackNShipButton: false,
                    packCompleteLoading: false,
                    gifShipBtn: false,
                });
            }
        );
    };
    updateCarrierAndServiceInfo = () => {
        kendo.ui.progress($("#PackAndShipTransactionModel"), true);
        let orderId = this.props.sharedSelectedOrderIds[0];
        smallParcelService
            .getOrderInfo(orderId)
            .then((response) => {
                // Set Carrier Account Nickname
                this.setCarrierAccountNickname(response.accountNumber);
                var tmpCarrierServiceObj = this.getCarrierServiceName(
                    this.state.carrierOptions,
                    response.carrier,
                    response.shipServiceCode
                );
                var tmpContactString = this.generateContactString(response);
                this.isSmallParcelGridRefresh = true;
                this.setState({
                    packAndShipContactString: tmpContactString,
                    carrier: tmpCarrierServiceObj.Carrier,
                    service: tmpCarrierServiceObj.Service,
                    packAndShipOrderInfo: Object.assign({}, response, {
                        OrderId: orderId,
                    }),
                });
            })
            .finally(() => {
                kendo.ui.progress($("#PackAndShipTransactionModel"), false);
            });
    };
    onCloseAvailableRatesModel = () => {
        this.setState({
            showAvailableRates: false,
        });
        if (this.order.SmallParcelAutoRateShopOnShip) {
            this.updateCarrierAndServiceInfo();
        }
    };
    setQuotedRates = (quotedRates) => {
        this.setState({
            quotedRates: quotedRates.total ? "$" + quotedRates.total.toFixed(2) : "",
        });
    };
    getServiceCode = (param_service) => {
        let carrierOptions = this.state.carrierOptions;
        let serviceCode = null;

        let shipmentServices = _.find(carrierOptions, function (carriers) {
            return carriers.Carrier == param_service.Carrier;
        });

        shipmentServices = shipmentServices.ShipmentServices;
        for (let shipmentIndex = 0; shipmentIndex < shipmentServices.length; shipmentIndex++) {
            const shipment = shipmentServices[shipmentIndex];
            if (this.isEnableProvider && param_service.Carrier == "USPS") {
                if (
                    shipment.Description.includes(param_service.Service) &&
                    shipment.PackageCode == param_service.PackageType &&
                    shipment.ShipEngineId == param_service.ServiceCode
                ) {
                    serviceCode = shipment.Code;
                    break;
                }
            } else if (shipment.ShipEngineId == param_service.ServiceCode) {
                serviceCode = shipment.Code;
                break;
            }
        }
        return serviceCode;
    };
    getScacCode = (param_service) => {
        let tempObject = this.state.carrierOptions.filter(function (el) {
            return el.Carrier === param_service.Carrier;
        })[0];
        return typeof tempObject !== "undefined" &&
            tempObject.hasOwnProperty("ScacCode") &&
            tempObject["ScacCode"] !== null
            ? tempObject["ScacCode"]
            : "";
    };
    generateContactString = (tmpOrderInfo) => {
        return (
            (tmpOrderInfo.shipToName ? tmpOrderInfo.shipToName + ", " : "") +
            (tmpOrderInfo.shipToCompany ? tmpOrderInfo.shipToCompany + ", " : "") +
            (tmpOrderInfo.shipToAddress ? tmpOrderInfo.shipToAddress + ", " : "") +
            (tmpOrderInfo.shipToAddress2 ? tmpOrderInfo.shipToAddress2 + ", " : "") +
            (tmpOrderInfo.shipToCity ? tmpOrderInfo.shipToCity + ", " : "") +
            (tmpOrderInfo.shipToState ? tmpOrderInfo.shipToState + ", " : "") +
            (tmpOrderInfo.shipToZip ? tmpOrderInfo.shipToZip : "")
        );
    };

    getCarrierServiceName = (param_carrier_option, param_carrier, param_service_code) => {
        this.isCallAutoRateAPI = false;
        let carrierOptions = param_carrier_option;
        var tmpCarrier = this.state.carrier;
        var tmpService = this.state.service;

        if (param_carrier) {
            tmpCarrier = param_carrier;
        }
        if (!param_carrier && param_service_code) {
            tmpService = param_service_code;
            this.isCallAutoRateAPI = true;
        }
        if (param_carrier && param_service_code) {
            var serviceDescription = null;

            for (let carrierIndex = 0; carrierIndex < carrierOptions.length; carrierIndex++) {
                if (param_carrier === carrierOptions[carrierIndex].Carrier) {
                    const shipmentServices = carrierOptions[carrierIndex].ShipmentServices;
                    for (let shipmentIndex = 0; shipmentIndex < shipmentServices.length; shipmentIndex++) {
                        const shipment = shipmentServices[shipmentIndex];
                        if (shipment.Code == param_service_code) {
                            serviceDescription = shipment.Description;
                            break;
                        }
                    }
                    if (serviceDescription != null) {
                        break;
                    }
                }
            }
            tmpService = serviceDescription;
            if (serviceDescription === null) {
                tmpService = param_service_code;

                // Only treat an unknown service code as a rate-shop trigger when it
                // actually matches a configured rate-shopping keyword. Literal service
                // strings coming from the rules engine (e.g. "Ground") should not
                // start auto rate shopping just because they arent tied to the shipment service number
                const rateShoppingLogic = this.state.settings?.SmallParcelRateShoppingLogic || [];
                const configuredKeywords = rateShoppingLogic
                    .map((rule) => rule.Mapping?.toLowerCase())
                    .filter(Boolean);

                const hasConfiguredKeyword = configuredKeywords.some(
                    (keyword) => param_service_code.toLowerCase() === keyword
                );

                this.isCallAutoRateAPI = hasConfiguredKeyword;
            }
        }

        if (!param_carrier) {
            tmpCarrier = this.translate("Label_None_Selected");
        }
        if (!param_service_code) {
            tmpService = this.translate("Label_None_Selected");
        }
        if (!param_carrier && !param_service_code) {
            this.isCallAutoRateAPI = true;
        }

        return {
            Carrier: tmpCarrier,
            Service: tmpService,
        };
    };

    handleCustomPackageChange = (e) => {
        var tmpCustomPkgObj = Object.assign({}, this.state.customPackageObj, {
            [e.target.name]: e.target.value,
        });
        this.setState({
            customPackageObj: tmpCustomPkgObj,
        });
    };
    onCloseCustomPackageModel = () => {
        this.setState({ isOpenCustomPackageModel: false });
        this.focusScanAfterCustomPackageTeardown();
    };
    // Kendo empties the focus out of the page while it closes and destroys the
    // window, taking the scan field with it, so the field can only be given focus
    // once that teardown has finished. Waiting for the window to go rather than for
    // a fixed delay keeps the field ready for the next scan.
    focusScanAfterCustomPackageTeardown = (attempt = 0) => {
        setTimeout(() => {
            if (!this._isMounted) {
                return;
            }
            var isWindowStillUp = document.getElementById(this.props.windowId + "CustomPackage") !== null;
            if (isWindowStillUp && attempt < 20) {
                this.focusScanAfterCustomPackageTeardown(attempt + 1);
                return;
            }
            this.setFocusOnScanAndSelectValue();
        }, 1000);
    };
    onSaveCustomDimension = () => {
        var tmpPkgCustomOption = Object.assign({}, this.pkgCustomOption);
        if (this.state.currentMeasurementStandardIsImperial) {
            tmpPkgCustomOption.LengthImperial = this.state.customPackageObj.length;
            tmpPkgCustomOption.WidthImperial = this.state.customPackageObj.width;
            tmpPkgCustomOption.HeightImperial = this.state.customPackageObj.height;
        } else {
            tmpPkgCustomOption.LengthMetric = this.state.customPackageObj.length;
            tmpPkgCustomOption.WidthMetric = this.state.customPackageObj.width;
            tmpPkgCustomOption.HeightMetric = this.state.customPackageObj.height;
        }
        this.previousSelectedPackage = this.currentPackage;
        this.currentPackage = tmpPkgCustomOption;
        this.currentPackage.isShawZeroPackageId = true;
        var tmpUniquePackageName = this.getUniquePackageName(this.translate("Label_Custom_Dimensions"));
        this.currentPackage.uniquePackageName = tmpUniquePackageName;

        for (let i = 0; i < this.state.addNumOfPackages; i++) {
            var tmpCloneCurrentPkg = _.cloneDeep(this.currentPackage);
            tmpCloneCurrentPkg.uniquePackageName = this.getUniquePackageName(this.translate("Label_Custom_Dimensions"));
            this.previousSelectedPackageArr.push(tmpCloneCurrentPkg);
            this.currentPackage = tmpCloneCurrentPkg;
        }

        this.listGrid_dataBind();
        // onCloseCustomPackageModel puts focus back once the window is gone; Kendo
        // tears it down after this handler returns and takes focus to the body with
        // it, so focusing again from here would only be undone.
        this.onCloseCustomPackageModel();
    };
    getUniquePackageName = (package_name) => {
        var customPkgCounter = _.countBy(this.previousSelectedPackageArr, (rec) => {
            return rec.Name == package_name;
        });
        var uniquePackageName = package_name.trim() + "(1)";
        if (customPkgCounter.true) {
            uniquePackageName = package_name.trim() + "(" + (customPkgCounter.true + 1) + ")";
        }
        return uniquePackageName;
    };

    onChangeQtyInput = (e) => {
        this.setState({ addNumOfPackages: e.target.value });
    };

    // Kendo's window appends this modal to #root, which sits outside the root the
    // Small Parcel tree was mounted into, so React never sees hover or clicks on
    // these header sections. Binding natively keeps the pencil working. The click
    // is delegated from the section because the icon only exists while hovered.
    setCareerSectionRef = (element) => {
        if (this.careerSectionElement === element) {
            return;
        }
        if (this.careerSectionElement) {
            this.careerSectionElement.removeEventListener("mouseenter", this.onSawEditCareerIcon);
            this.careerSectionElement.removeEventListener("mouseleave", this.onHideEditCareerIcon);
            this.careerSectionElement.removeEventListener("click", this.onCareerSectionClick);
        }
        this.careerSectionElement = element;
        if (this.careerSectionElement) {
            this.careerSectionElement.addEventListener("mouseenter", this.onSawEditCareerIcon);
            this.careerSectionElement.addEventListener("mouseleave", this.onHideEditCareerIcon);
            this.careerSectionElement.addEventListener("click", this.onCareerSectionClick);
        }
    };

    setContactSectionRef = (element) => {
        if (this.contactSectionElement === element) {
            return;
        }
        if (this.contactSectionElement) {
            this.contactSectionElement.removeEventListener("mouseenter", this.onSawEditContactIcon);
            this.contactSectionElement.removeEventListener("mouseleave", this.onHideEditContactIcon);
            this.contactSectionElement.removeEventListener("click", this.onContactSectionClick);
        }
        this.contactSectionElement = element;
        if (this.contactSectionElement) {
            this.contactSectionElement.addEventListener("mouseenter", this.onSawEditContactIcon);
            this.contactSectionElement.addEventListener("mouseleave", this.onHideEditContactIcon);
            this.contactSectionElement.addEventListener("click", this.onContactSectionClick);
        }
    };

    onCareerSectionClick = (event) => {
        if (event.target.closest(".edit-icon")) {
            this.openEditCareerDetailModal();
        }
    };

    onContactSectionClick = (event) => {
        if (event.target.closest(".edit-icon")) {
            this.openEditAddressDetailModal();
        }
    };

    onSawEditCareerIcon = () => {
        if (!this.order.SmallParcelShipDate) {
            this.setState({
                isShowEditCareerIcon: true,
            });
        }
    };
    onHideEditCareerIcon = () => {
        this.setState({
            isShowEditCareerIcon: false,
        });
    };

    onSawEditContactIcon = () => {
        this.setState({
            isShowEditContactIcon: true,
        });
    };
    onHideEditContactIcon = () => {
        this.setState({
            isShowEditContactIcon: false,
        });
    };

    openEditCareerDetailModal = () => {
        this.props.editShippingInfo("packNShipEditCareer");
    };

    openEditAddressDetailModal = () => {
        this.setState({
            isOpenEditAddressDetailModal: true,
        });
    };
    onCloseEditAddressDetailModal = () => {
        this.setState({
            isOpenEditAddressDetailModal: false,
        });
    };

    // ============================================================================
    // PRINTER CONFIGURATION METHODS
    // ============================================================================

    /**
     * Check if printer is configured and show notification if needed
     * This uses the abstracted printer service, making it easy to swap implementations
     */
    /**
     * Check if the appropriate printer is configured based on current label format.
     * Called on modal open and when label format changes.
     *
     * Logic:
     * 1. PDF format + silent print OFF → do nothing (browser viewer handles it)
     * 2. QZ Tray connected → check QZ Tray printer configs (ZPL / PDF-silent)
     * 3. QZ Tray NOT connected + Browser Print service running → do nothing
     * 4. QZ Tray NOT connected + Browser Print NOT running → pop QZ Tray modal
     */
    checkPrinterConfiguration = async () => {
        try {
            const labelFormat = this.state?.packAdnShipObj?.labelFormat;
            const silentPdfPrint = localStorage.getItem("qz_silent_pdf_print") === "true";

            if (labelFormat === "Pdf" && !silentPdfPrint) {
                return;
            }

            let isQzTrayConnected = false;
            try {
                isQzTrayConnected = printerService.isConnected();
                if (!isQzTrayConnected) {
                    isQzTrayConnected = await printerService.ensureConnected(2000);
                }
            } catch (connError) {
                console.warn("[Pack & Ship] Could not check QZ Tray connection:", connError.message);
                isQzTrayConnected = false;
            }

            if (isQzTrayConnected) {
                if (labelFormat === "Zpl" || labelFormat === "Png" || !labelFormat) {
                    try {
                        const zplPrinter = printerService.getDefaultZplPrinter();
                        if (!zplPrinter) {
                            console.log("[Pack & Ship] No ZPL printer configured - opening Printer Settings");
                            this.setState({ showPrinterSettingsModal: true });
                            return;
                        }
                    } catch (zplError) {
                        console.warn("[Pack & Ship] Error checking ZPL printer:", zplError.message);
                    }
                }

                if (labelFormat === "Pdf" && silentPdfPrint) {
                    try {
                        const pdfPrinter = printerService.getDefaultPdfPrinter();
                        if (!pdfPrinter) {
                            console.log("[Pack & Ship] No PDF printer configured - opening Printer Settings");
                            this.setState({ showPrinterSettingsModal: true });
                            return;
                        }
                    } catch (pdfError) {
                        console.warn("[Pack & Ship] Error checking PDF printer:", pdfError.message);
                    }
                }

                return;
            }

            const browserPrintRunning = await GlobalService.isBrowserPrintServiceRunning();

            if (browserPrintRunning) {
                return;
            }

            console.log("[Pack & Ship] No printing service available - opening Printer Settings");
            this.setState({ showPrinterSettingsModal: true });
        } catch (error) {
            console.error("[Pack & Ship] Error checking printer configuration:", error);
        }
    };

    /**
     * Open the printer settings modal
     */
    handleOpenPrinterSettings = () => {
        // Note: This is kept for backwards compatibility but printer button is now in header
        // Clear the dismissed flag so the check can run again after settings are saved
        sessionStorage.removeItem("printerNotificationDismissed");
        this.setState({
            showPrinterSettingsModal: true,
            showPrinterConfigNotification: false,
        });
    };

    /**
     * Close the printer settings modal
     * Note: We do NOT re-check configuration here - user explicitly dismissed the modal
     */
    handleClosePrinterSettings = () => {
        this.setState({ showPrinterSettingsModal: false });
    };

    /**
     * Dismiss the printer configuration notification for this session
     */
    handleDismissPrinterNotification = () => {
        sessionStorage.setItem("printerNotificationDismissed", "true");
        this.setState({ showPrinterConfigNotification: false });
    };

    // ============================================================================

    setCarrierAccountNickname = (tmpAccountNumber) => {
        let tempCarrierAccountNickname = "";
        for (var i = 0; i < this.state.availableCarrierAccounts.length; i++) {
            if (tmpAccountNumber === this.state.availableCarrierAccounts[i].AccountNumber) {
                tempCarrierAccountNickname = this.state.availableCarrierAccounts[i].NickName;
            }
        }
        this.setState({ tempCarrierAccountNickname: tempCarrierAccountNickname });
    };
    closeIsOrderOnHoldConfirmModal = (e) => {
        // Close Is Order On Hold Confirm Modal
        this.setState({
            isOnHoldOrder: false,
        });
    };

    render() {
        const isPapiPackageLayoutBlocked = this.isPapiPackageLayoutBlocked();
        return (
            <div>
                <WmsModel
                    id="PackAndShipTransactionModel"
                    class="pack-and-ship-transaction-model-wrapper"
                    title={this.translate("Label_Pack_and_Ship_Orders")}
                    width={1200}
                    height={800}
                    onCloseFunc={this.props.onClosePackAndShipModel}
                    isOpen={this.props.sharedIsPackAndShipModel}
                    customClass="wms-model-new-ui-wrapper"
                >
                    <div className="model-content-wrapper">
                        {this.props.sharedSelectedOrderIds.length == 1 && (
                            <div className="small-parcel-recored-wrapper">
                                {/* Left Section */}
                                <div className="small-parcel-recored-col">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th data-wms-selector={this.state.selector + "CustomerLabel"}>
                                                    {this.translate("FindOrders_Lbl_Customer")}
                                                </th>
                                                <td data-wms-selector={this.state.selector + "CustomerValue"}>
                                                    {this.state.packAndShipOrderInfo.customer}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th data-wms-selector={this.state.selector + "CarrierAccountLabel"}>
                                                    {this.translate("Label_Carrier_Account")}
                                                </th>
                                                <td
                                                    className="remove-white-space"
                                                    data-wms-selector={this.state.selector + "CarrierAccountValue"}
                                                >
                                                    {GlobalService.showFirstNChar(
                                                        this.state.packAndShipOrderInfo.accountNumber,
                                                        25
                                                    )}
                                                </td>
                                            </tr>
                                            {this.order.SmallParcelCarrierSelectionV2 && (
                                                <tr>
                                                    <th
                                                        data-wms-selector={this.state.selector + "AccountNicknameLabel"}
                                                    >
                                                        {this.translate("Label_Account_Nickname")}
                                                    </th>
                                                    <td
                                                        data-wms-selector={this.state.selector + "AccountNicknameValue"}
                                                    >
                                                        {this.state.packAndShipOrderInfo.accountNickName
                                                            ? this.state.packAndShipOrderInfo.accountNickName
                                                            : this.state.tempCarrierAccountNickname}
                                                    </td>
                                                </tr>
                                            )}
                                            <tr>
                                                <th data-wms-selector={this.state.selector + "TransactionIdLabel"}>
                                                    {this.translate("Orders_Lbl_Transaction_Id")}
                                                </th>
                                                <td data-wms-selector={this.state.selector + "TransactionIdValue"}>
                                                    {this.state.packAndShipOrderInfo.OrderId}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {/* Middle Section */}
                                <div
                                    className="small-parcel-recored-col"
                                    ref={this.setCareerSectionRef}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th data-wms-selector={this.state.selector + "CarrierLabel"}>
                                                    {this.translate("Label_Carrier")}
                                                </th>
                                                <td data-wms-selector={this.state.selector + "CarrierValue"}>
                                                    {this.state.carrier && this.state.carrier == "PitneyBowesStd"
                                                        ? "Pitney Bowes Standard"
                                                        : this.state.carrier}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th data-wms-selector={this.state.selector + "ServiceLabel"}>
                                                    {this.translate("Label_Service")}
                                                </th>
                                                <td data-wms-selector={this.state.selector + "ServiceValue"}>
                                                    {this.state.service}
                                                </td>
                                            </tr>
                                            {this.order.SmallParcelCarrierSelectionV2 && (
                                                <tr>
                                                    <th data-wms-selector={this.state.selector + "BillingTypeLabel"}>
                                                        {this.translate("Label_Billing")}
                                                    </th>
                                                    <td data-wms-selector={this.state.selector + "BillingTypeValue"}>
                                                        {this.state.packAndShipOrderInfo.billingCode &&
                                                        this.state.packAndShipOrderInfo.billingCode != null
                                                            ? this.state.packAndShipOrderInfo.billingCode
                                                            : "Unspecified"}
                                                    </td>
                                                </tr>
                                            )}
                                            {this.state.packAndShipOrderInfo.overrideAccountNumber &&
                                                this.order.SmallParcelCarrierSelectionV2 && (
                                                    <tr>
                                                        <th
                                                            data-wms-selector={
                                                                this.state.selector + "OverrideAccountLabel"
                                                            }
                                                        >
                                                            {this.translate("Label_Override_Account")}
                                                        </th>
                                                        <td
                                                            data-wms-selector={
                                                                this.state.selector + "OverrideAccountNumberValue"
                                                            }
                                                        >
                                                            {GlobalService.showFirstNChar(
                                                                this.state.packAndShipOrderInfo.overrideAccountNumber,
                                                                25
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}
                                            <tr>
                                                <th data-wms-selector={this.state.selector + "QuotedRateLabel"}>
                                                    {this.translate("Label_Quoted_Rate")}
                                                </th>
                                                <td data-wms-selector={this.state.selector + "QuotedRateValue"}>
                                                    {this.state.quotedRates}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {this.state.isShowEditCareerIcon && (
                                        <span className="edit-icon fa fa-pencil"></span>
                                    )}
                                </div>
                                {/* Right Section */}
                                <div
                                    className="small-parcel-recored-col"
                                    ref={this.setContactSectionRef}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <th data-wms-selector={this.state.selector + "RecipientAddressLabel"}>
                                                    {this.translate("Label_Recipient_Address")}
                                                </th>
                                                <td data-wms-selector={this.state.selector + "RecipientAddressValue"}>
                                                    {this.state.packAndShipContactString}
                                                </td>
                                            </tr>
                                            {this.state.packAndShipOrderInfo.warehouseInstructions && (
                                                <tr>
                                                    <th
                                                        data-wms-selector={
                                                            this.state.selector + "WarehouseInstructionsLabel"
                                                        }
                                                    >
                                                        {this.translate("Label_Shipping_Warehouse_Instructions")}
                                                    </th>
                                                    <td
                                                        data-wms-selector={
                                                            this.state.selector + "WarehouseInstructionsValue"
                                                        }
                                                    >
                                                        {GlobalService.showFirstNChar(
                                                            this.state.packAndShipOrderInfo.warehouseInstructions,
                                                            50
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    {this.state.isShowEditContactIcon && (
                                        <span className="edit-icon fa fa-pencil"></span>
                                    )}
                                </div>
                            </div>
                        )}

                        {this.props.sharedSelectedOrderIds.length > 1 && (
                            <div className="pack-and-ship-multi-order-header">
                                {this.state.mixedNewPackingSlipFeaturesDisagree && (
                                    <div
                                        className="pack-and-ship-mixed-features-warning"
                                        role="alert"
                                        data-wms-selector={this.state.selector + "MixedNewPackingSlipFeatures"}
                                    >
                                        {this.translate("Label_PackAndShip_Mixed_Packing_Slip_Features")}
                                    </div>
                                )}
                                <div
                                    className="pack-and-ship-customer-line"
                                    data-wms-selector={this.state.selector + "MultiOrderCustomer"}
                                >
                                    <label>
                                        {this.translate("FindOrders_Lbl_Customer") + ": " + (
                                            this.isPapiPackAndShipMixedCustomers()
                                                ? this.translate("Label_Multiple_Values")
                                                : this.getMultiOrderCustomerName()
                                        )}
                                    </label>
                                </div>
                            </div>
                        )}

                        <WmsCollapse
                            id={"PackAndShipSmartParcel"}
                            headerLabel={this.translate("Label_Smart_Parcel")}
                            showCollapseText={false}
                            showCollapseIcon={this.state.isSmartParcelEnabled && this.state.isSmartPackEnabled}
                            isExpanded={this.state.isSmartParcelEnabled}
                            isDisabled={!this.state.isSmartParcelEnabled}
                            isShowTooltip={!this.state.isSmartParcelEnabled}
                            tooltipText={this.translate("Label_Setting_Disable_Tooltip")}
                        >
                            <div className={
                                "pack-and-ship-smartparcel-row-1"
                                + (
                                    this.state.packAdnShipObj.processAs == "Standard"
                                    && this.usesNewPackingSlipUiForOrder()
                                        ? " no-label-template"
                                        : ""
                                )
                            }>
                            <WmsDropdown
                                id="PackAndShiProcessAs"
                                name="processAs"
                                label={this.translate("Label_ProcessAs")}
                                wmsSelector={this.state.selector + "ProcessAs"}
                                value={this.state.packAdnShipObj.processAs}
                                onChangeFunc={this.onChangeFunc}
                                options={this.processAsOption}
                                textField="description"
                                valueField="value"
                                extraWrapperClass="pack-and-ship-process"
                            />

                            <WmsDropdown
                                id="PackAndShiLabelFormat"
                                name="labelFormat"
                                label={
                                    this.state.packAdnShipObj.processAs == "High Volume"
                                        ? this.translate("Label_Label_Reprint_Format")
                                        : this.usesNewPackingSlipUiForOrder()
                                            ? this.translate("Label_Shipping_Label_Format")
                                            : this.translate("Label_Label_Format")
                                }
                                wmsSelector={this.state.selector + "LabelFormat"}
                                value={this.state.packAdnShipObj.labelFormat}
                                onChangeFunc={this.onChangeFunc}
                                options={
                                    this.state.packAdnShipObj.processAs == "High Volume"
                                        ? this.labelFormateOptionForHvp
                                        : this.labelFormateOption
                                }
                                textField="description"
                                valueField="value"
                                //disabled={this.state.packAdnShipObj.processAs == 'High Volume'}
                                //extraWrapperClass={"pack-and-ship-label-format" + (this.state.packAdnShipObj.processAs == 'High Volume' ? ' disable-element': '') } />
                                extraWrapperClass="pack-and-ship-label-format"
                            />

                            <WmsDropdown
                                id="PackAndShiReturnLabel"
                                name="returnLabel"
                                label={this.translate("Label_Return_Label")}
                                wmsSelector={this.state.selector + "ReturnLabel"}
                                value={this.state.packAdnShipObj.returnLabel}
                                onChangeFunc={this.onChangeFunc}
                                options={this.returnLabelOptions}
                                textField="description"
                                valueField="value"
                                disabled={this.state.packAdnShipObj.processAs == "High Volume"}
                                extraWrapperClass={
                                    "pack-and-ship-return-label" +
                                    (this.state.packAdnShipObj.processAs == "High Volume" ? " disable-element" : "")
                                }
                            />
                            {this.state.packAdnShipObj.processAs == "Standard"
                                && !this.usesNewPackingSlipUiForOrder() && (
                                <WmsDropdown
                                    id="PackAndShiComboLabelTemplate"
                                    name="comboLabelTemplate"
                                    label={this.translate("Label_Label_Template")}
                                    wmsSelector={this.state.selector + "ComboLabelTemplate"}
                                    value={this.state.packAdnShipObj.comboLabelTemplate}
                                    onChangeFunc={this.onChangeFunc}
                                    options={this.state.menuOptions[0].Reports}
                                    textField="Name"
                                    valueField="Name"
                                    extraWrapperClass="pack-and-ship-combo-template"
                                />
                            )}
                            {this.state.packAdnShipObj.processAs == "High Volume" && (
                                <WmsInput
                                    id="batchname"
                                    inputName="batchname"
                                    wmsSelector={this.state.selector + "batchname"}
                                    value={this.state.packAdnShipObj.batchname}
                                    onChangeFunc={this.onChangeFunc}
                                    label={this.translate("Label_Batch_Name")}
                                    extraWrapperClass="pack-and-ship-batchname"
                                />
                            )}
                            {this.props.sharedSelectedOrderIds.length == 1 && (
                                <WmsButton
                                    label={this.translate("Lable_Get_Rates")}
                                    wmsSelector={this.state.selector + "GetRates"}
                                    onClickFunc={this.onClickGetRates}
                                    disabled={this.state.isAnyItemUnpacked}
                                    showToolTip={true}
                                    tooltipText={
                                        this.state.isAnyItemUnpacked
                                            ? this.translate("Label_Fully_Packed_Disable_Note_Gate_Rate")
                                            : ""
                                    }
                                    icon="far fa-list-alt"
                                    buttonType="green"
                                    parentClassName={"get-rates-button"}
                                />
                            )}
                            </div>
                            {/* Show packing-slip dropdowns only after THIS customer opted in (saved PAPI
                                template id). Do not load the TPL catalog just because the PAPI right is on;
                                that leaked every published template onto customers with Integrated Packing
                                Slips off (SSRS only fetches reports when pack slip + address template are set). */}
                            {this.state.optionsPackingReports.length > 0 &&
                                this.state.packAdnShipObj.processAs == "Standard" && (
                                <div className="pack-and-ship-smartparcel-row-2">
                                    <WmsDropdown
                                        id="smallParcelPackSlip"
                                        name={
                                            this.usesNewPackingSlipUiForOrder()
                                                ? "SmallParcelDocumentTypeValue"
                                                : "SmallParcelPackSlip"
                                        }
                                        label={
                                            this.usesNewPackingSlipUiForOrder()
                                                ? this.translate("Label_Packing_Slip_Template")
                                                : this.translate("Label_Package_Slip_Type")
                                        }
                                        wmsSelector={this.state.selector + "SmallParcelPackSlip"}
                                        value={
                                            this.usesNewPackingSlipUiForOrder()
                                                ? this.state.packAdnShipObj.SmallParcelDocumentTypeValue
                                                : this.state.packAdnShipObj.SmallParcelPackSlip
                                        }
                                        onChangeFunc={this.onChangeFunc}
                                        options={this.state.optionsPackingReports}
                                        valueField={
                                            this.usesNewPackingSlipUiForOrder()
                                                ? "value"
                                                : "TemplatedRunner"
                                        }
                                        textField="Name"
                                        extraWrapperClass="package-slip-type"
                                    />
                                    {papiDocumentUtil.isPapiSelection(this.state.packAdnShipObj.SmallParcelDocumentTypeValue) && (
                                        <WmsDropdown
                                            id="packAndShipPapiPackSlipFormat"
                                            name="SmallParcelPapiPackSlipFormat"
                                            label={this.translate("Label_PackAndShip_Packing_Slip_Format")}
                                            wmsSelector={this.state.selector + "SmallParcelPapiPackSlipFormat"}
                                            value={papiDocumentUtil.resolvePapiDocumentFormat(this.state.packAdnShipObj, "packingSlip")}
                                            onChangeFunc={this.onChangeFunc}
                                            options={papiDocumentUtil.getFormatOptionsForTemplate(
                                                this.state.packAdnShipObj.SmallParcelDocumentTypeValue,
                                                this.state.papiDocumentTemplatesRaw,
                                                papiDocumentUtil.PAPI_DOC_TYPES.packingSlip
                                            )}
                                            valueField="Value"
                                            textField="Name"
                                            extraWrapperClass="packing-slip-format"
                                        />
                                    )}
                                    {!this.usesNewPackingSlipUiForOrder() && (
                                        <WmsDropdown
                                            id="smallParcelAddressTemplate"
                                            name="SmallParcelAddressTemplate"
                                            label={this.translate("Label_Packing_Slip_Address_Configuration")}
                                            wmsSelector={this.state.selector + "SmallParcelAddressTemplate"}
                                            value={this.state.packAdnShipObj.SmallParcelAddressTemplate}
                                            onChangeFunc={this.onChangeFunc}
                                            options={this.state.optionsTemplateReports}
                                            valueField="Id"
                                            textField="Name"
                                            extraWrapperClass="packing-slip-address-configuration"
                                            disabled={!this.state.packAdnShipObj.SmallParcelPackSlip}
                                        />
                                    )}
                                    {papiDocumentUtil.isPapiSelection(this.state.packAdnShipObj.SmallParcelDocumentTypeValue) && (
                                        <WmsDropdown
                                            id="packAndShipPapiPackSlipScope"
                                            name="SmallParcelPapiPackSlipScope"
                                            label={this.translate("Label_PapiPackSlipLayout")}
                                            showLabelInfoIcon={true}
                                            labelInfoTooltipText={this.translate("Tooltip_PapiPackSlipLayout")}
                                            wmsSelector={this.state.selector + "SmallParcelPapiPackSlipScope"}
                                            value={this.state.packAdnShipObj.SmallParcelPapiPackSlipScope || "shipment"}
                                            onChangeFunc={this.onChangeFunc}
                                            options={this.optionsPapiPackSlipScope}
                                            valueField="value"
                                            textField="text"
                                            extraWrapperClass="packing-slip-layout"
                                        />
                                    )}
                                </div>
                            )}
                        </WmsCollapse>

                        <WmsCollapse
                            id={"PackAndShipSmartPack"}
                            headerLabel={this.translate("Label_Smart_Pack")}
                            showCollapseText={false}
                            showCollapseIcon={this.state.isSmartParcelEnabled && this.state.isSmartPackEnabled}
                            isExpanded={this.state.isSmartPackEnabled}
                            isDisabled={!this.state.isSmartPackEnabled}
                            isShowTooltip={!this.state.isSmartPackEnabled}
                            tooltipText={
                                this.props.sharedSelectedOrderIds.length > 1
                                    ? this.translate("Label_Setting_Disable_Multiple_Order_Tooltip")
                                    : this.translate("Label_Setting_Disable_Tooltip")
                            }
                        >
                            <div className={"inline-elements" + (this.usesNewUcc128ForPackAndShip() ? " has-ucc128-format" : "")}>
                                <div
                                    className={
                                        (this.order.SmallParcelShipDate ? "disabled-add-pkg " : "") +
                                        "add-package-wrapper"
                                    }
                                >
                                    <label className="pkg-option-label">{this.translate("Label_Add_a_Package")}</label>
                                    <div className="pkg-elements-wrapper">
                                        <label className="qty-label">{this.translate("Label_Qty")}</label>
                                        <WmsInput
                                            id={this.state.selector + "QtyInput"}
                                            extraWrapperClass="qty-input-wrapper"
                                            inputName={"addNumOfPackages"}
                                            wmsSelector={this.state.selector + "QtyInput"}
                                            label={""}
                                            value={this.state.addNumOfPackages}
                                            onChangeFunc={this.onChangeQtyInput}
                                            valueType={"number"}
                                        />
                                        <WmsComboBox
                                            id="PackAndShiAddaPackage"
                                            name="addaPackage"
                                            label={this.translate("Label_Add_a_Package")}
                                            wmsSelector={this.state.selector + "AddaPackage"}
                                            value={this.state.selectedPackage}
                                            onChangeFunc={this.onPackageChange}
                                            options={this.state.packagesOptions}
                                            placeholder={this.translate("Label_Select_Package_Option")}
                                            valueField="PackageDefId"
                                            textField="Name"
                                            parentClassName="pack-and-ship-add-package"
                                        />
                                    </div>
                                </div>

                                <WmsDropdown
                                    id="PackAndShiCartonLabel"
                                    name="cartonLabel"
                                    label={this.translate(this.usesNewUcc128ForPackAndShip()
                                        ? "Label_Ucc128_Package_Label"
                                        : "Label_Carton_Label")}
                                    wmsSelector={this.state.selector + "CartonLabel"}
                                    value={
                                        papiDocumentUtil.isBlankLabelId(this.state.cartonLabel)
                                            ? 0
                                            : String(this.state.cartonLabel)
                                    }
                                    onChangeFunc={this.onChangePackFunc}
                                    disabled={this.state.cartonLabelOptionsLoading}
                                    options={this.state.cartonLabelOptions}
                                    textField="Name"
                                    valueField="LabelTemplateId"
                                    extraWrapperClass="pack-and-ship-carton-label"
                                />
                                {this.usesNewUcc128ForPackAndShip() && (
                                    <WmsDropdown
                                        id="PackAndShipUcc128Format"
                                        name="ucc128Format"
                                        label={this.translate("Label_PackAndShip_Ucc128_Format")}
                                        wmsSelector={this.state.selector + "Ucc128Format"}
                                        value={this.state.ucc128Format}
                                        onChangeFunc={this.onChangePackFunc}
                                        options={this.ucc128FormatOptionsForTemplate(
                                            this.state.cartonLabel,
                                            this.state.ucc128TemplatesRaw
                                        )}
                                        textField="Name"
                                        valueField="Value"
                                        extraWrapperClass="pack-and-ship-ucc128-format"
                                        disabled={this.isUcc128FormatDropdownDisabled()}
                                    />
                                )}

                                <WmsDropdown
                                    id="PackAndShiTransactionLabel"
                                    name="transactionLabel"
                                    label={this.translate("Label_Transaction_Label")}
                                    wmsSelector={this.state.selector + "TransactionLabel"}
                                    value={this.state.transactionLabel}
                                    onChangeFunc={this.onChangePackFunc}
                                    options={this.state.transactionLabelOptions}
                                    textField="Name"
                                    valueField="LabelTemplateId"
                                    extraWrapperClass="pack-and-ship-transaction-label"
                                />

                                <WmsCheckBox
                                    id={"autoPrint"}
                                    name={"autoPrint"}
                                    wmsSelector={this.state.selector + "autoPrint"}
                                    onChangeFunc={this.autoPrintChangeEvent}
                                    label={this.translate("Label_Auto_Print_Labels")}
                                    value={this.isPrintIconShaw}
                                    checked={this.isPrintIconShaw}
                                />
                            </div>

                            <div className="scan-key-wrapper">
                                <div className="first-section">
                                    <WmsInput
                                        id={this.state.selector + "scanGridKey"}
                                        extraWrapperClass="full-width-input"
                                        inputName={"scanGridKey"}
                                        wmsSelector={this.state.selector + "scanGridKey"}
                                        label={
                                            this.isAllowDuplicatedUPC
                                                ? this.translate("Label_Pack_a_Line_Item_Without_UPC")
                                                : this.translate("Label_Pack_a_Line_Item")
                                        }
                                        value={this.state.scanGridKey}
                                        onChangeFunc={this.handleScanGridKeyChange}
                                        onIconClick={this.handleScanGridKeyChange}
                                        showIconAfterInput={true}
                                        icon={this.state.scanInputLoading ? "fa-spinner fa-pulse" : ""}
                                        // isAutoFocus={true}
                                        ref="scanGridKey"
                                    />
                                    <WmsButton
                                        label=""
                                        wmsSelector={this.state.selector + "ScanKeyAddButton"}
                                        onClickFunc={this.onScanValueEnter}
                                        icon="fa-plus"
                                        disabled={!this.state.scanGridKey}
                                        buttonType="green"
                                        parentClassName={"package-scan-add"}
                                    />
                                </div>
                                <div>
                                    <div className="chk-btn-wrapper">
                                        <WmsCheckBox
                                            id={"selectUnpack"}
                                            name={"selectUnpack"}
                                            wmsSelector={this.state.selector + "selectUnpack"}
                                            onChangeFunc={this.onChangeForSelectUnpack}
                                            label={this.translate("Label_Select_Unpacked_Items")}
                                            value={this.state.selectUnpack}
                                            checked={this.state.selectUnpack}
                                            disabled={
                                                this.order.SmallParcelDisableClickToPack ||
                                                !this.state.isAnyItemUnpacked
                                            }
                                        />

                                        <WmsCheckBox
                                            id={"oneQtyPack"}
                                            name={"oneQtyPack"}
                                            wmsSelector={this.state.selector + "oneQtyPack"}
                                            onChangeFunc={this.oneQtyPackChangeEvent}
                                            label={this.translate("Label_Qty_One_Pack")}
                                            value={this.state.isOneQtyPack}
                                            checked={this.state.isOneQtyPack}
                                            parentClassName="qty-chk-wrapper"
                                            showToolTip={true}
                                            tooltipText={this.translate("Label_Qty_One_Pack_Tooltip")}
                                            tooltipShowAfter={300}
                                        />

                                        <WmsButton
                                            label={this.translate("Label_Pack_Selected")}
                                            wmsSelector={this.state.selector + "PackSelected"}
                                            onClickFunc={this.onClickPackSelectedItem}
                                            disabled={
                                                !this.state.isPackSelectedBtnEnabled ||
                                                this.state.packSelectedBtnTooltip != "" ||
                                                this.order.SmallParcelDisableClickToPack
                                            }
                                            showToolTip={this.state.packSelectedBtnTooltip != ""}
                                            tooltipText={this.state.packSelectedBtnTooltip}
                                            icon="fas fa-box-open"
                                            parentClassName={"pack-all-selected"}
                                        />

                                        <WmsButton
                                            label={this.translate("Label_Delete_All_Packages")}
                                            wmsSelector={this.state.selector + "DeleteAllPackage"}
                                            onClickFunc={this.onDeleteAllPackage}
                                            icon="fa-trash"
                                            buttonType="red"
                                            disabled={
                                                this.state.disableDeleteAll ||
                                                (this.order.SmallParcelShipDate ? true : false)
                                            }
                                            showToolTip={this.order.SmallParcelShipDate ? true : false}
                                            tooltipText={this.translate("Label_Already_Shipped_Tooltip")}
                                            parentClassName={"package-delete-all"}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                {this.state.isDeviceConnect && (
                                    <div className="scale-weight-text">
                                        <label>{this.translate("Label_Current_Package_Weight")}</label>
                                        <span>
                                            {this.state.scaleChangeWeight +
                                                " " +
                                                (this.state.currentMeasurementStandardIsImperial ? "lbs" : "kg")}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <div>
                                {this.order.SmallParcelDisableClickToPack && (
                                    <div className="pack-item-warning-alert">
                                        <div className="pack-item-warning-alert-icon">
                                            <span className="wms-sprite far fa-square-info"></span>
                                        </div>
                                        <div className="pack-item-warning-alert-content">
                                            <div className="pack-item-warning-alert-title">{this.translate("Label_Scan_Required_Pack_And_Ship")}</div>
                                            <div className="pack-item-warning-alert-description">{this.translate("Label_Scan_Required_Pack_and_Ship_Description")}</div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {this.state.loadPackInfoCall && (
                                <VirtualGroupGrid
                                    ref="packAndShipTransactionGrid"
                                    wmsSelector={this.state.selector + "Grid"}
                                    gridKeySelection={"RowNumber"}
                                    groupKeyName={"val"}
                                    staticGridData={this.state.smallPackGridData}
                                    gridName={"packAndShipTransactionGrid"}
                                    filterText={""}
                                    columns={PackAndShipGridConfig.getPackAndShipGridColumns(this.order.SmallParcelDisableClickToPack).columns}
                                    id={"packAndShipTransactionGrid"}
                                    showScanKeyInput={true}
                                    scanKeyLabel={this.translate("Label_Pack_a_Line_Item")}
                                    onSelection={this.onGridSelection}
                                    schema={PackAndShipGridConfig.getPackAndShipGridSchema().schema}
                                    onClickGroupHeader={this.listGrid_groupClick}
                                    onDataBound={this.onGridDataBound}
                                    onColumnReorder={this.onColumnReorder}
                                    onSort={this.onSort}
                                    metaGridConfig={metaDataService.getPackAndShipGridOptionInMetaData()}
                                    sortOptions={this.state.gridSortOptions}
                                />
                            )}
                        </WmsCollapse>
                    </div>

                    <div className="footer-btn-holder">
                        <WmsButton label={this.translate("Label_Close")} wmsSelector={this.state.selector + "PickTicketExit"} onClickFunc={this.closePackAndShipModel} disabled={false} loading={false} buttonType="orange" icon={"fa-times-circle-o"} />
                        {this.state.isSmartPackEnabled && <WmsButton id={this.state.selector + "Pack"} label={this.translate("Label_Pack")} wmsSelector={this.state.selector + "Pack"} onClickFunc={this.onPackClick} loading={this.state.packCompleteLoading} disabled={this.state.isPackOrPackAndShipDisabled} showToolTip={true} tooltipText={this.state.packOrPackShipTooltip} icon={"fas fa-box-open"} />}
                        {this.state.isSmartParcelEnabled &&
                            <WmsButton id={"PackAndSshipTransaction" + this.props.windowId}
                            label={this.translate("Label_Ship")}
                            wmsSelector={this.state.selector + "Finish"}
                            onClickFunc={this.onShipBtnClick}
                            disabled={this.state.isShipInFlight || this.state.gifShipBtn ||!this.state.isSmartParcelEnabled || (this.order.SmallParcelShipDate ? true : false) || this.state.isAnyItemUnpacked || isPapiPackageLayoutBlocked || (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && !this.areAllItemsScanned(this.state.smallPackGridData))}
                            showToolTip={this.state.isShipInFlight || this.order.SmallParcelShipDate || this.state.isAnyItemUnpacked || isPapiPackageLayoutBlocked ||
                                (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && !this.areAllItemsScanned(this.state.smallPackGridData)) ? true : false} tooltipText={this.state.isShipInFlight ? this.translate("Label_Ship_In_Flight_Tooltip") : isPapiPackageLayoutBlocked ? this.translate("Label_Packing_Slips_Must_Be_Packed") : this.state.isAnyItemUnpacked ? this.translate("Label_Fully_Packed_Disable_For_Ship_Note") : (this.state.requiredScanActive && this.order.SmallParcelDisableClickToPack && !this.areAllItemsScanned(this.state.smallPackGridData)) ? "Please scan all items before packing or shipping" : this.translate("Label_Already_Shipped_Tooltip")} loading={this.state.gifShipBtn} icon={"fa-dolly"} />}
                        {this.state.isSmartParcelEnabled &&
                            this.state.isSmartPackEnabled && ( // smart parcel section disable condition
                                <WmsButton
                                    id={this.state.selector + "PackAndShip"}
                                    label={this.translate("Label_Pack_And_Ship")}
                                    wmsSelector={this.state.selector + "PackAndShip"}
                                    disabled={this.state.isPackOrPackAndShipDisabled}
                                    showToolTip={true}
                                    tooltipText={this.state.packOrPackShipTooltip}
                                    onClickFunc={this.onPackNShipClick}
                                    loading={this.state.gifPackNShipButton}
                                    icon={"fa-shipping-fast"}
                                />
                            )}
                        {this.state.isPackNShipLoading && (
                            <div className="div-packnship-loading-footer" id="div-packnship-loading-footer">
                                <i className="fa fa-spinner fa-spin"></i>&nbsp;
                                {this.state.packNShipLoadingMsg}
                            </div>
                        )}
                    </div>
                </WmsModel>
                {this.state.isOpenAddQuantity && (
                    <WmsModel
                        id={this.props.windowId + "AddItemQuantity"}
                        title={this.translate("Label_Packed_Quantity")}
                        width={450}
                        height={175}
                        class="add-item-quantity-wrapper"
                        onCloseFunc={this.closeQuantityModal}
                        removeCloseAnimation={true}
                        removeOpenAnimation={true}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenAddQuantity}
                    >
                        <div className="model-content-wrapper text-align-center">
                            <div className="sku-detail-wrapper">
                                <ul>
                                    {this.content.Sku && (
                                        <li>
                                            <label>Sku:</label>
                                            <span>{this.content.Sku}</span>
                                        </li>
                                    )}
                                    {this.content.Qualifier && (
                                        <li>
                                            <label>Qualifier:</label>
                                            <span>{this.content.Qualifier}</span>
                                        </li>
                                    )}
                                    {this.content.Description && (
                                        <li>
                                            <label>Desc:</label>
                                            <span>{this.content.Description}</span>
                                        </li>
                                    )}
                                    {this.content.Lot && (
                                        <li>
                                            <label>Lot:</label>
                                            <span>{this.content.Lot}</span>
                                        </li>
                                    )}
                                    {this.content.ExpirationDate && (
                                        <li>
                                            <label>Expr:</label>
                                            <span>
                                                {kendo.toString(
                                                    kendo.parseDate(this.content.ExpirationDate),
                                                    "MMM dd yyyy"
                                                )}
                                            </span>
                                        </li>
                                    )}
                                    {this.content.Serial && (
                                        <li>
                                            <label>S/n:</label>
                                            <span>{this.content.Serial}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <p>{this.translate("Label_Quantity_Remaining")}</p>
                            <h1>
                                {this.state.remainingQuantity % 1 !== 0
                                    ? this.state.remainingQuantity.toFixed(3)
                                    : this.state.remainingQuantity}
                            </h1>
                            <hr />
                            <div className="scan-key-wrapper">
                                <div className="scan-key-not-found">
                                    {this.state.isScanPackedNotAvailable
                                        ? this.translate("Label_Costomer_Record_Not_Found")
                                        : ""}
                                </div>
                            </div>
                            <div
                                className={
                                    (this.state.itemQuantity && this.state.invalidValue ? "invalid-error " : "") +
                                    "quantity-wrapper"
                                }
                            >
                                <i
                                    className={(this.state.itemQuantity <= 0 ? "disable-btn " : "") + "fas fa-minus"}
                                    data-wms-selector="packedQuantityMinus"
                                ></i>
                                <WmsInput
                                    id="itemQuantity"
                                    inputName="itemQuantity"
                                    wmsSelector={this.state.selector + "itemQuantity"}
                                    value={this.state.itemQuantity}
                                    disabled={false}
                                    onChangeFunc={this.onItemQtyChangeFunc}
                                    label={this.translate("Label_Quantity")}
                                    regularExp={this.state.quantityRegx} // change number and float input conditionally
                                    extraWrapperClass="pack-and-ship-itemQuantity"
                                    ref="itemQuantity"
                                />
                                <i
                                    className={
                                        (this.state.remainingQuantity == 0 ? "disable-btn " : "") + "fas fa-plus"
                                    }
                                    data-wms-selector="packedQuantityPlus"
                                ></i>
                                <label
                                    className={
                                        (this.state.isQtyPopupScannedFocus ? "scanned-focused " : "") +
                                        (this.state.isQtyPopupScanDetected ? "scanned-detected " : "") +
                                        "scan-inputlabel"
                                    }
                                    htmlFor={this.state.selector + "scanPackedQty"}
                                >
                                    <i className="fas fa-qrcode"></i>
                                    <input
                                        type={"text"}
                                        name={"scanPackedQty"}
                                        ref="scanPackedQty"
                                        value={this.state.scanPackedQty}
                                        id={this.state.selector + "scanPackedQty"}
                                    />
                                </label>
                            </div>
                            <span
                                className={
                                    (this.state.itemQuantity && this.state.invalidValue ? "" : "message-opacity ") +
                                    "error-message"
                                }
                            >
                                {this.translate("Label_Max_Qty_Warning").replace("{remainQty}", this.content.Remainder)}
                            </span>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Cancel")}
                                wmsSelector={this.state.selector + "Cancel"}
                                onClickFunc={this.closeQuantityModal}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Next")}
                                wmsSelector={this.state.selector + "Next"}
                                onClickFunc={this.qtyNext}
                                disabled={this.state.invalidValue}
                                loading={false}
                                buttonType="green"
                                icon={"fa-caret-right"}
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.isOpenSerialPopup && (
                    <WmsModel
                        id={this.props.windowId + "SerialPopup"}
                        title={this.translate("Label_Serial_Numbers")}
                        width={350}
                        height={680}
                        removeCloseAnimation={true}
                        class="serial-number-popup-wrapper"
                        onCloseFunc={this.closeSerialPopup}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenSerialPopup}
                    >
                        <div className="model-content-wrapper text-align-center">
                            <p className="serial-reminder-label">
                                {this.content.isSerialUnique ? "Unique " : ""}
                                {this.translate("Label_Unique_Serial_Numbers")}: {this.content.Sku}
                            </p>
                            <h1>
                                {this.state.packSerialQty % 1 !== 0
                                    ? parseFloat(this.state.packSerialQty).toFixed(3)
                                    : this.state.packSerialQty}{" "}
                            </h1>
                            <hr />
                            <div className="serial-input-add-wrapper">
                                <div className="searialnumber-wrapper">
                                    <label>
                                        {(this.content.isSerialUnique ? "Unique " : "") +
                                            this.translate("Label_Unique_Serial_Number")}
                                    </label>
                                    <textarea
                                        id={this.state.selector + "serialNumber"}
                                        name="enteredSerialNumber"
                                        value={this.state.enteredSerialNumber}
                                        onChange={this.handleScanGridKeyChange}
                                        autoFocus={true}
                                        disabled={this.isSerialNumberDisableToAddNew}
                                        data-wms-selector={this.state.selector + "serialNumber"}
                                        ref="serialNumber"
                                        rows={3}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                                <WmsButton
                                    label={""}
                                    wmsSelector={this.state.selector + "AddSerialNumber"}
                                    onClickFunc={this.onEnterSerialInput}
                                    icon="fa-plus"
                                    disabled={!this.state.enteredSerialNumber}
                                />
                            </div>
                            <hr />
                            <div className="provide-serial-wrapper">
                                <h4>{this.translate("Label_Provided_Serial_Numbers")}:</h4>
                                <ul>
                                    {this.state.serials.map((serial, index) => (
                                        <li key={index}>{serial}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Cancel")}
                                wmsSelector={this.state.selector + "Cancel"}
                                onClickFunc={this.closeSerialPopup}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Next")}
                                wmsSelector={this.state.selector + "Next"}
                                onClickFunc={this.onNextSerialPopup}
                                disabled={!this.state.isEnabledNextOnSerialPopup}
                                loading={false}
                                buttonType="green"
                                icon={"fa-caret-right"}
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.isOpenEditItemQtyModel && (
                    <WmsModel
                        id={this.props.windowId + "EditPackedItem"}
                        title={this.translate("Label_Edit_Packed_Item")}
                        width={650}
                        height={300}
                        class="edit-packed-item-wrapper"
                        onCloseFunc={this.closePackItem}
                        removeCloseAnimation={true}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenEditItemQtyModel}
                    >
                        <div className="model-content-wrapper text-align-center">
                            <WmsCollapse
                                id={"EditPackedItem"}
                                headerLabel={this.translate("Label_Edit_Packed_Item")}
                                showCollapseText={false}
                                showCollapseIcon={false}
                            >
                                <WmsDropdown
                                    id="PackedIn"
                                    name="selectPackedIn"
                                    label={this.translate("Label_Packed_In")}
                                    wmsSelector={this.state.selector + "PackedIn"}
                                    value={this.state.selectPackedIn}
                                    onChangeFunc={this.itemPackSelectChange}
                                    options={this.state.editPackedInOptions}
                                    valueField="value"
                                    textField="text"
                                />
                            </WmsCollapse>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Cancel")}
                                wmsSelector={this.state.selector + "Cancel"}
                                onClickFunc={this.closePackItem}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Unpack_Sku")}
                                wmsSelector={this.state.selector + "UnpackSku"}
                                onClickFunc={this.unpackItem}
                                disabled={false}
                                loading={false}
                                buttonType="yellow"
                                icon={"fa-dropbox"}
                            />
                            <WmsButton
                                label={this.translate("Label_Save")}
                                wmsSelector={this.state.selector + "Save"}
                                onClickFunc={this.saveItem}
                                disabled={this.state.packedInSaveDisable}
                                loading={false}
                                icon="fa-floppy-o"
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.isOpenEditPackageDetailsModel && (
                    <WmsModel
                        id={this.props.windowId + "EditPackageDetails"}
                        title={this.translate("Label_Edit_Package_Details")}
                        width={650}
                        height={300}
                        removeCloseAnimation={true}
                        class="edit-package-detail-wrapper"
                        onCloseFunc={this.closePackGroup}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenEditPackageDetailsModel}
                    >
                        <div className="model-content-wrapper text-align-center">
                            <WmsCollapse
                                id={"serviceChargeTrigger"}
                                headerLabel={this.translate("Label_Package_Details")}
                                showCollapseText={false}
                                showCollapseIcon={true}
                            >
                                <WmsDropdown
                                    id="editSelectedPackageDefId"
                                    name="editSelectedPackageDefId"
                                    label={this.translate("Label_Selected_Package")}
                                    wmsSelector={this.state.selector + "editSelectedPackageDefId"}
                                    value={this.state.editSelectedPackageDefId}
                                    onChangeFunc={this.handleEditPackageChange}
                                    options={this.state.packagesOptions}
                                    textField="Name"
                                    valueField="PackageDefId"
                                    extraWrapperClass="pack-and-ship-package-options"
                                />
                                <WmsInput
                                    id="editPackageWeight"
                                    inputName="editPackageWeight"
                                    wmsSelector={this.state.selector + "editPackageWeight"}
                                    value={this.state.editPackageWeight}
                                    onChangeFunc={this.handleEditPackageChange}
                                    label={
                                        this.translate("Label_Package_Weight_Lbs") +
                                        (this.state.currentMeasurementStandardIsImperial ? " (lbs)" : " (kg)")
                                    }
                                    extraWrapperClass={
                                        (this.state.originalPackageWeight != this.state.editPackageWeight &&
                                        this.state.isDeviceConnect == false
                                            ? ""
                                            : "reset-icon-opacity ") + "pack-and-ship-weight"
                                    }
                                    disabled={this.state.isDeviceConnect}
                                    showIconAfterInput={true}
                                    onIconClick={this.state.isDeviceConnect ? () => {} : this.onResetIconClick}
                                    icon="fa-refresh"
                                />
                                {this.state.isCustomDimensionPackSelect && (
                                    <div className="customer-dimensions-wrapper">
                                        <div className="dimension-wrapper">
                                            <WmsInput
                                                id="length"
                                                inputName={"editPackageLength"}
                                                label={
                                                    this.translate("Label_Length") +
                                                    " (" +
                                                    (this.state.currentMeasurementStandardIsImperial
                                                        ? this.translate("Label_Inch_Abbrev_Wihtout_dot")
                                                        : this.translate("Label_Centimeter_Abbrev_Wihtout_dot")) +
                                                    ")"
                                                }
                                                wmsSelector={this.state.selector + "Length"}
                                                onChangeFunc={this.handleEditPackageChange}
                                                value={this.state.editPackageLength}
                                                extraWrapperClass="length-wrapper"
                                                required={true}
                                                regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                                            />

                                            <WmsInput
                                                id="width"
                                                inputName={"editPackageWidth"}
                                                label={
                                                    this.translate("Label_Width") +
                                                    " (" +
                                                    (this.state.currentMeasurementStandardIsImperial
                                                        ? this.translate("Label_Inch_Abbrev_Wihtout_dot")
                                                        : this.translate("Label_Centimeter_Abbrev_Wihtout_dot")) +
                                                    ")"
                                                }
                                                wmsSelector={this.state.selector + "Width"}
                                                onChangeFunc={this.handleEditPackageChange}
                                                value={this.state.editPackageWidth}
                                                extraWrapperClass="width-wrapper"
                                                required={true}
                                                regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                                            />

                                            <WmsInput
                                                id="height"
                                                inputName={"editPackageHeight"}
                                                label={
                                                    this.translate("Label_Height") +
                                                    " (" +
                                                    (this.state.currentMeasurementStandardIsImperial
                                                        ? this.translate("Label_Inch_Abbrev_Wihtout_dot")
                                                        : this.translate("Label_Centimeter_Abbrev_Wihtout_dot")) +
                                                    ")"
                                                }
                                                wmsSelector={this.state.Selector + "Height"}
                                                onChangeFunc={this.handleEditPackageChange}
                                                value={this.state.editPackageHeight}
                                                extraWrapperClass="height-wrapper"
                                                required={true}
                                                regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                                            />
                                        </div>
                                    </div>
                                )}
                            </WmsCollapse>

                            <WmsCollapse
                                id={"referenceFields"}
                                headerLabel={this.translate("Label_Reference_Fields")}
                                showCollapseText={false}
                                showCollapseIcon={true}
                            >
                                <div className="reference-fields-wrapper">
                                    <WmsInput
                                        id="reference1"
                                        inputName="reference1"
                                        wmsSelector={this.state.selector + "reference1"}
                                        value={this.state.reference1}
                                        onChangeFunc={this.handleEditReferenceFieldChange}
                                        label={this.translate("Label_Reference_Field_1")}
                                        disabled={false}
                                        showIconAfterInput={false}
                                        onIconClick={() => {}}
                                    />

                                    <WmsInput
                                        id="reference2"
                                        inputName="reference2"
                                        wmsSelector={this.state.selector + "reference2"}
                                        value={this.state.reference2}
                                        onChangeFunc={this.handleEditReferenceFieldChange}
                                        label={this.translate("Label_Reference_Field_2")}
                                        disabled={false}
                                        showIconAfterInput={false}
                                        onIconClick={() => {}}
                                    />

                                    <WmsInput
                                        id="reference3"
                                        inputName="reference3"
                                        wmsSelector={this.state.selector + "reference3"}
                                        value={this.state.reference3}
                                        onChangeFunc={this.handleEditReferenceFieldChange}
                                        label={this.translate("Label_Reference_Field_3")}
                                        disabled={false}
                                        showIconAfterInput={false}
                                        onIconClick={() => {}}
                                    />
                                </div>
                            </WmsCollapse>

                            <WmsCollapse
                                id={"packageDescription"}
                                headerLabel={this.translate("Label_Package_Description")}
                                showCollapseText={false}
                                showCollapseIcon={true}
                            >
                                <div className="reference-fields-wrapper">
                                    <WmsInput
                                        id="packageContentDescription"
                                        inputName="packageContentDescription"
                                        wmsSelector={this.state.selector + "packageContentDescription"}
                                        value={this.state.packageContentDescription}
                                        label={this.translate("Label_Package_Content_Description")}
                                        onChangeFunc={this.handleEditPackageContentDescriptionChange}
                                    />
                                </div>
                            </WmsCollapse>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Cancel")}
                                wmsSelector={this.state.selector + "Cancel"}
                                onClickFunc={this.closePackGroup}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Save")}
                                wmsSelector={this.state.selector + "Save"}
                                onClickFunc={this.updatePackage}
                                disabled={
                                    this.state.packGroupSaveDisable ||
                                    !this.state.editPackageHeight ||
                                    !this.state.editPackageLength ||
                                    !this.state.editPackageWidth
                                }
                                loading={false}
                                icon="fa-floppy-o"
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.isOpenDeleteConfirmModel && (
                    <WmsModel
                        id={this.props.windowId + "confirmDeletePackage"}
                        title={this.translate("Label_Confirm_Delete_Package")}
                        width={600}
                        height={200}
                        removeCloseAnimation={true}
                        class="confirm-remove-package-wrapper"
                        onCloseFunc={this.onCloseDeleteConfirmationModel}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenDeleteConfirmModel}
                    >
                        <div className="model-content-wrapper">
                            <label
                                className="confirm-remove-msg"
                                dangerouslySetInnerHTML={{
                                    __html: this.translate("Label_Delete_Package_Confirm").replace(
                                        "{packagename}",
                                        '"' + this.state.selectedPackageName + '"'
                                    ),
                                }}
                            ></label>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Cancel")}
                                wmsSelector={this.state.selector + "Cancel"}
                                onClickFunc={this.onCloseDeleteConfirmationModel}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Delete")}
                                wmsSelector={this.state.selector + "Delete"}
                                onClickFunc={this.deleteConfirmPackage}
                                buttonType="red"
                                disabled={false}
                                loading={false}
                                icon={"fa-trash"}
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.isOpenConfirmDeleteAllPopup && (
                    <WmsModel
                        id={this.props.windowId + "confirmDeletePackage"}
                        title={this.translate("Label_Confirm_Delete_Package")}
                        width={600}
                        height={200}
                        removeCloseAnimation={true}
                        class="confirm-remove-all-package-wrapper"
                        onCloseFunc={this.onCloseDeleteAllConfirmationModel}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenConfirmDeleteAllPopup}
                    >
                        <div className="model-content-wrapper">
                            <label className="confirm-remove-msg">
                                {this.translate("Label_Delete_All_Package_Confirm")}
                            </label>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Cancel")}
                                wmsSelector={this.state.selector + "DeleteAllCancel"}
                                onClickFunc={this.onCloseDeleteAllConfirmationModel}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Delete")}
                                wmsSelector={this.state.selector + "DeleteAllDelete"}
                                onClickFunc={this.deleteAllConfirm}
                                buttonType="red"
                                disabled={false}
                                loading={this.state.deleteAllLoading}
                                icon={"fa-trash"}
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.isOpenTrackByInfoMOdel && (
                    <WmsModel
                        id={this.props.windowId + "trackByInfo"}
                        title={this.translate("Label_Verify_Track_Bys")}
                        width={400}
                        height={200}
                        removeCloseAnimation={true}
                        class="verify-track-by-wrapper"
                        onCloseFunc={this.onCloseVerifyTrackByModel}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenTrackByInfoMOdel}
                    >
                        <div className="model-content-wrapper">
                            <ul id="trackby_list">
                                {this.state.trackByModelInfo.map((item, index) => (
                                    <li key={"InforKey_" + index}>
                                        <strong>{item.text + " :"}</strong>
                                        {item.value}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Cancel")}
                                wmsSelector={this.state.selector + "Cancel"}
                                onClickFunc={this.onCloseVerifyTrackByModel}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Select_Confirm")}
                                wmsSelector={this.state.selector + "Confirm"}
                                onClickFunc={this.onConfirmVerifyTrackByModel}
                                disabled={false}
                                loading={false}
                                icon={"fa-check-circle"}
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.showAvailableRates && (
                    <AvailableRates
                        isAvailableRatesModelOpen={this.state.showAvailableRates}
                        updateCarrierAndServiceInfo={this.updateCarrierAndServiceInfo}
                        onCloseAvailableRatesModel={this.onCloseAvailableRatesModel}
                        onGetServiceCode={this.getServiceCode}
                        onGetScacCode={this.getScacCode}
                        windowId={this.props.windowId}
                        sharedSelectedOrderIds={this.props.sharedSelectedOrderIds}
                        customerId={this.state.packAndShipOrderInfo.customerId}
                        orderInfoResponse={this.state.packAndShipOrderInfo}
                        setQuotedRates={this.setQuotedRates}
                    />
                )}
                {this.state.isOpenCustomPackageModel && (
                    <WmsModel
                        id={this.props.windowId + "CustomPackage"}
                        title={this.translate("Label_Add_Custom_Package")}
                        width={700}
                        height={200}
                        onCloseFunc={this.onCloseCustomPackageModel}
                        customClass="wms-model-new-ui-wrapper custom-package-model-wrapper"
                        isOpen={this.state.isOpenCustomPackageModel}
                    >
                        <div className="model-content-wrapper">
                            <WmsCollapse
                                id={"dimensionAndWeight"}
                                headerLabel={this.translate("Label_Package_Dimensions_And_Weight")}
                                showCollapseText={false}
                                showCollapseIcon={false}
                            >
                                <div className="dimension-input-wrapper">
                                    <WmsInput
                                        id="length"
                                        inputName={"length"}
                                        label={
                                            this.translate("Label_Length") +
                                            " (" +
                                            (this.state.currentMeasurementStandardIsImperial
                                                ? this.translate("Label_Inch_Abbrev_Wihtout_dot")
                                                : this.translate("Label_Centimeter_Abbrev_Wihtout_dot")) +
                                            ")"
                                        }
                                        wmsSelector={this.state.selector + "Length"}
                                        onChangeFunc={this.handleCustomPackageChange}
                                        value={this.state.customPackageObj.length}
                                        extraWrapperClass="length-wrapper"
                                        required={true}
                                        isAutoFocus={true}
                                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                                    />

                                    <WmsInput
                                        id="width"
                                        inputName={"width"}
                                        label={
                                            this.translate("Label_Width") +
                                            " (" +
                                            (this.state.currentMeasurementStandardIsImperial
                                                ? this.translate("Label_Inch_Abbrev_Wihtout_dot")
                                                : this.translate("Label_Centimeter_Abbrev_Wihtout_dot")) +
                                            ")"
                                        }
                                        wmsSelector={this.state.selector + "Width"}
                                        onChangeFunc={this.handleCustomPackageChange}
                                        value={this.state.customPackageObj.width}
                                        extraWrapperClass="width-wrapper"
                                        required={true}
                                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                                    />

                                    <WmsInput
                                        id="height"
                                        inputName={"height"}
                                        label={
                                            this.translate("Label_Height") +
                                            " (" +
                                            (this.state.currentMeasurementStandardIsImperial
                                                ? this.translate("Label_Inch_Abbrev_Wihtout_dot")
                                                : this.translate("Label_Centimeter_Abbrev_Wihtout_dot")) +
                                            ")"
                                        }
                                        wmsSelector={this.state.Selector + "Height"}
                                        onChangeFunc={this.handleCustomPackageChange}
                                        value={this.state.customPackageObj.height}
                                        extraWrapperClass="height-wrapper"
                                        required={true}
                                        regularExp={/^[0-9]*(?:\.[0-9]{0,4})?$/}
                                    />
                                </div>
                            </WmsCollapse>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Close")}
                                wmsSelector={this.state.selector + "Close"}
                                onClickFunc={this.onCloseCustomPackageModel}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Save")}
                                wmsSelector={this.state.selector + "save"}
                                onClickFunc={this.onSaveCustomDimension}
                                disabled={
                                    !this.state.customPackageObj.length ||
                                    !this.state.customPackageObj.width ||
                                    !this.state.customPackageObj.height
                                }
                                loading={false}
                                icon="fa-floppy-o"
                                buttonType="green"
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.isOpenDuplicatePrintingModel && (
                    <WmsModel
                        id={this.props.windowId + "DuplicatePrintingModel"}
                        title={this.translate("Label_Duplicate_Printing_Model")}
                        width={600}
                        height={200}
                        removeCloseAnimation={true}
                        onCloseFunc={this.onCloseDuplicatePrintingModel}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenDuplicatePrintingModel}
                    >
                        <div className="model-content-wrapper">
                            {
                                "The order was already sent and printing again may cause multiple charges based on carrier fees"
                            }
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Close")}
                                wmsSelector={this.state.selector + "Close"}
                                onClickFunc={this.onCloseDuplicatePrintingModel}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-close"}
                            />
                            <WmsButton
                                label={this.translate("Print Anyways")}
                                wmsSelector={this.state.selector + "PrintingLabels"}
                                onClickFunc={this.onClickPrintAnyways}
                                disabled={this.state.isShipInFlight}
                                showToolTip={this.state.isShipInFlight}
                                tooltipText={this.translate("Label_Ship_In_Flight_Tooltip")}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-print"}
                            />
                        </div>
                    </WmsModel>
                )}
                {this.state.isOpenEditAddressDetailModal && (
                    <EditAddressDetail
                        isOpenEditAddressDetailModal={this.state.isOpenEditAddressDetailModal}
                        onCloseEditAddressDetailModal={this.onCloseEditAddressDetailModal}
                        sharedSelectedOrderIds={this.props.sharedSelectedOrderIds}
                        updateAddressInfo={this.updateCarrierAndServiceInfo}
                    />
                )}

                {/* Printer Settings Modal */}
                {this.state.showPrinterSettingsModal && (
                    <PrinterSettingsModal onClose={this.handleClosePrinterSettings} />
                )}

                {/* Printer Configuration Notification Modal */}
                <div>
                    <WmsConfirmModel
                        id={this.props.windowId + "PrinterConfigNotification"}
                        isOpen={this.state.showPrinterConfigNotification}
                        onCloseFunc={this.handleDismissPrinterNotification}
                        isCallToFront={true}
                        isFirstBtnSaw={true}
                        isSecondBtnSaw={false}
                        isThirdBtnSaw={true}
                        sawCheckBox={false}
                        firstButtonType="yellow"
                        thirdButtonType="gray"
                        firstBtnLabel="Set Up Now"
                        firstBtnOnClickFunc={this.handleOpenPrinterSettings}
                        thirdBtnLabel="Remind Me Later"
                        thirdBtnIcon=""
                        firstBtnIcon=""
                        secondFunctionClick={() => {}}
                        conFormModelText={`
                            <div class="printer-config-modal-content">
                                <div class="printer-config-icon">
                                    <i class="fa fa-exclamation-triangle"></i>
                                </div>
                                <div class="printer-config-message">
                                    <h3>${this.state.printerNotificationMessage.title}</h3>
                                    <p>${this.state.printerNotificationMessage.message}</p>
                                </div>
                            </div>
                        `}
                    />
                </div>

                {this.state.isOpenAddNonSkuQuantityModal && (
                    <WmsModel
                        id={this.props.windowId + "AddNonSkuItemQuantity"}
                        title={this.translate("Label_Packed_Quantity")}
                        width={450}
                        height={175}
                        class="add-item-quantity-wrapper"
                        onCloseFunc={this.closeAddNonSkuQuantityModal}
                        removeCloseAnimation={true}
                        removeOpenAnimation={true}
                        customClass="wms-model-new-ui-wrapper"
                        isOpen={this.state.isOpenAddNonSkuQuantityModal}
                    >
                        <div className="model-content-wrapper text-align-center">
                            <div className="sku-detail-wrapper">
                                <ul>
                                    {this.nonSkuContent.Sku && (
                                        <li>
                                            <label>Sku:</label>
                                            <span>{this.nonSkuContent.Sku}</span>
                                        </li>
                                    )}
                                    {this.nonSkuContent.Description && (
                                        <li>
                                            <label>Desc:</label>
                                            <span>{this.nonSkuContent.Description}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                            <div className="quantity-wrapper">
                                <i
                                    className={
                                        (this.state.nonSkuItemQuantity == 0 ? "disable-btn " : "") + "fas fa-minus"
                                    }
                                    data-wms-selector="packedNonSkuQuantityMinus"
                                ></i>
                                <WmsInput
                                    id="nonSkuItemQuantity"
                                    inputName="nonSkuItemQuantity"
                                    wmsSelector={this.state.selector + "nonSkuItemQuantity"}
                                    value={this.state.nonSkuItemQuantity}
                                    disabled={false}
                                    onChangeFunc={this.onNonSkuItemQtyChangeFunc}
                                    label={this.translate("Label_Quantity")}
                                    regularExp={this.state.quantityRegx} // change number and float input conditionally
                                    extraWrapperClass="pack-and-ship-itemQuantity"
                                    ref="nonSkuItemQuantity"
                                />
                                <i
                                    className={
                                        (this.state.nonSkuItemQuantity < 0 ? "disable-btn " : "") + "fas fa-plus"
                                    }
                                    data-wms-selector="packedNonSkuQuantityPlus"
                                ></i>
                                <label
                                    className={
                                        (this.state.isQtyPopupScannedFocus ? "scanned-focused " : "") +
                                        (this.state.isQtyPopupScanDetected ? "scanned-detected " : "") +
                                        "scan-inputlabel"
                                    }
                                    htmlFor={this.state.selector + "scanNonSkuPackedQty"}
                                >
                                    <i className="fas fa-qrcode"></i>
                                    <input
                                        type={"text"}
                                        name={"scanNonSkuPackedQty"}
                                        ref="scanNonSkuPackedQty"
                                        value={this.state.scanNonSkuPackedQty}
                                        id={this.state.selector + "scanNonSkuPackedQty"}
                                    />
                                </label>
                            </div>
                        </div>
                        <div className="footer-btn-holder">
                            <WmsButton
                                label={this.translate("Label_Cancel")}
                                wmsSelector={this.state.selector + "Cancel"}
                                onClickFunc={this.closeAddNonSkuQuantityModal}
                                disabled={false}
                                loading={false}
                                buttonType="orange"
                                icon={"fa-ban"}
                            />
                            <WmsButton
                                label={this.translate("Label_Next")}
                                wmsSelector={this.state.selector + "Next"}
                                onClickFunc={this.nonSkuQtyNext}
                                disabled={this.state.nonSkuItemQuantity < 0}
                                loading={false}
                                buttonType="green"
                                icon={"fa-caret-right"}
                            />
                        </div>
                    </WmsModel>
                )}
                <div>
                    <WmsConfirmModel
                        id={"IsOrderOnHoldConfirmModel" + this.props.windowId}
                        isOpen={this.state.isOnHoldOrder}
                        type={this.translate("Label_Confirmation_Warning_Title")}
                        width={400}
                        height={100}
                        firstBtnLabel={this.translate("Label_Close")}
                        firstBtnIcon={"fa-times-circle"}
                        firstBtnOnClickFunc={this.closeIsOrderOnHoldConfirmModal}
                        firstButtonType="orange"
                        sawCheckBox={false}
                        conFormModelText={this.translate("Label_You_Cannot_Pack_This_Order")}
                        onCloseFunc={this.closeIsOrderOnHoldConfirmModal}
                        isSecondBtnSaw={false}
                        isThirdBtnSaw={false}
                    />
                </div>
            </div>
        );
    }
}
